// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/search.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/prev.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/next.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/endpoint.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/success.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/warning.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/in_progress.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/Spinner-1s-16px.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* These MUST be 6 char hex or bad things (silently) happen */
@font-face {
  font-style: normal;
  font-weight: 400;
  src: local("Open Sans Regular"), local("OpenSans-Regular"), url(https://fonts.gstatic.com/s/opensans/v15/mem8YaGs126MiZpBA-UFUZ0bbck.woff2) format("woff2");
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* variables for easier Custom Less modification */
html {
  position: relative;
  min-height: 100vh;
}
.skip-to.popup.focus {
  z-index: 1030;
}
body {
  padding-top: 70px;
  background: #fff;
  background-size: cover;
  font-weight: normal;
  font-family: "Open Sans", sans-serif;
}
.body-content {
  width: 100%;
  position: relative;
}
a {
  color: #466db2;
}
a:hover {
  cursor: pointer;
  color: #304b7b;
}
p {
  clear: none;
}
h1 {
  line-height: 1;
  color: #333;
}
h1,
h2,
h3 {
  margin-top: 10px;
  font-weight: 500;
}
h1 {
  font-size: 1.9rem;
}
h2 {
  font-size: 1.65rem;
}
h3 {
  font-size: 1.45rem;
}
h4 {
  font-size: 1.3rem;
}
h5 {
  font-size: 1.15rem;
}
h6 {
  font-size: 1rem;
}
.pull-right {
  float: right;
}
.loading {
  margin: 15px auto;
  display: block;
  margin: 0 auto;
  height: 100px;
}
.text-smaller {
  font-size: 0.875rem;
}
.tile,
.dashboard_btn {
  background: #ffffff;
  border-radius: 8px;
  padding: 15px;
}
[data-bind*="clickOrEnter"],
[data-bind^="clickOrEnter"] {
  cursor: pointer;
}
.dropdown-menu li,
.returning_user li {
  list-style-type: none;
  list-style-position: initial;
}
.previous-question {
  padding: 5px 10px;
  border-top: 1px solid #ddd;
  font-size: 13px;
  cursor: pointer;
}
.previous-question strong {
  font-size: 15px;
}
.current-question {
  border-top: 1px solid #ddd;
}
.answer.disabled {
  opacity: 0.65;
}
.previous-question:hover,
.previous-question:focus {
  background: #f5f5f5;
}
.dropdown-menu {
  border-radius: 0 0 6px 6px;
}
.dropdown.open .dropdown-menu {
  opacity: 1;
}
.dropdown-toggle.show + .dropdown-menu {
  display: block;
}
label {
  font-weight: 500;
}
#jsPageEditor .form-control,
#jsPageEditor .vs__dropdown-toggle,
#jsPageEditor .form-group .input-group .input-group-text {
  font-weight: normal;
  border-color: #787878;
}
#jsPageEditor .vs__dropdown-toggle .vs__open-indicator {
  fill: #333333;
}
#jsPageEditor .form-control:focus,
#jsPageEditor .vs--open .vs__dropdown-toggle {
  border-width: 2px;
  border-color: rgba(0, 0, 0, 0.87);
  box-shadow: unset;
}
#jsPageEditor .form-control:focus ~ .vs__dropdown-menu,
#jsPageEditor .vs--open .vs__dropdown-toggle ~ .vs__dropdown-menu {
  --vs-border-width: 0;
}
#jsPageEditor .form-group .btn-group {
  border-radius: 0.35rem;
}
#jsPageEditor .form-group.text-form-group .input-group-append .input-group-text:focus,
#jsPageEditor .form-group.text-form-group .input-group-prepend .input-group-text:focus {
  z-index: 0;
}
#jsPageEditor .form-group.has-custom-errors .border-mixin {
  border-color: #b00020;
  border-width: 1px;
  outline: unset;
}
#jsPageEditor .form-group.has-custom-errors .border-focus-mixin {
  border-width: 2px;
  box-shadow: unset;
}
#jsPageEditor .form-group.has-custom-errors .invalid-border-mixin {
  border-color: #b00020;
  border-width: 1px;
  outline: unset;
}
#jsPageEditor .form-group.has-custom-errors .invalid-border-mixin:focus {
  border-width: 2px;
  box-shadow: unset;
}
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .form-control,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .form-control,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-text {
  border-color: #b00020;
  border-width: 1px;
  outline: unset;
}
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .form-control:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .form-control:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-text:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-text:focus {
  border-width: 2px;
  box-shadow: unset;
}
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend .input-group-text {
  border-color: #b00020;
  border-width: 1px;
  outline: unset;
}
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append .input-group-text:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append .input-group-text:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend .input-group-text:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend .input-group-text:focus {
  border-width: 2px;
  box-shadow: unset;
}
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append .input-group-text:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append .input-group-text:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend .input-group-text:focus,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend .input-group-text:focus {
  outline: 2px solid #b00020;
  box-shadow: unset;
  border: unset;
  z-index: 0;
}
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append:not(.input-group-prepend) .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append:not(.input-group-prepend) .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend:not(.input-group-prepend) .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend:not(.input-group-prepend) .input-group-text {
  border-left-width: 0;
}
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append:not(.input-group-append) .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append:not(.input-group-append) .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend:not(.input-group-append) .input-group-text,
#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend:not(.input-group-append) .input-group-text {
  border-right-width: 0;
}
#jsPageEditor .form-group.has-custom-errors.dropdown-form-group > div > div > select.form-control,
#jsPageEditor .form-group.has-custom-errors.dropdown-form-group > div > div > .v-select .vs__dropdown-toggle {
  border-color: #b00020;
  border-width: 1px;
  outline: unset;
}
#jsPageEditor .form-group.has-custom-errors.dropdown-form-group > div > div > .v-select.vs--open .vs__dropdown-toggle {
  border-width: 2px;
  box-shadow: unset;
}
#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-file,
#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group {
  border-color: #b00020;
  border-width: 1px;
  outline: unset;
  border-width: 2px;
}
#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-file:focus,
#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group:focus {
  border-width: 2px;
  box-shadow: unset;
}
#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group {
  border-style: solid;
}
#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group a.btn {
  border-width: 0;
}
#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group .input-group-append {
  border-top-width: 0;
  border-right-width: 0;
  border-bottom-width: 0;
}
.form-check-label,
.radio-inline,
.checkbox label {
  font-weight: normal;
  margin-bottom: 0;
}
.page-loading {
  position: fixed;
  opacity: 1;
  transition: all 0.4s ease-in;
}
html.no-js .page-loading {
  display: none;
}
.page-loaded {
  opacity: 0;
  height: 0;
  transition: none;
  /*ensure wheel doesn't fade out, rather disappears*/
  z-index: -1;
}
.body-loading {
  width: 100px;
  height: 100px;
  border-radius: 1.5ex;
  padding: 0.2ex;
  position: fixed;
  left: calc(50% - 50px);
  top: calc(50% - 50px);
}
.body-loading .loading {
  height: 100%;
}
.popover-header {
  margin: 0;
}
.popper {
  background: #ffffff;
  max-width: 300px;
  border: 1px solid #cccccc;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  padding: 7.5px;
}
.form-check.answer {
  position: static;
}
.v--modal-overlay {
  z-index: 1002;
}
.modal-content {
  border: none;
  max-height: 100vh;
  overflow-y: auto;
}
/* ------------------------
 NAVIGATION
-/----------------------- */
.skip-navigation-link:focus {
  display: block;
  top: 0;
  width: auto !important;
  height: auto !important;
  z-index: 998999;
  background: white;
  clip: unset;
}
.navbar-dark {
  background-color: #2b2b2b;
  /*min-height: 60px;*/
  padding-top: 5px;
  padding-bottom: 5px;
}
.navbar-dark {
  padding-left: 0;
  padding-right: 0;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
}
.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link:focus {
  color: #ffffff;
}
.navbar-dark a {
  white-space: nowrap;
}
.navbar-dark a:hover,
.navbar-dark a:focus {
  text-decoration: none;
}
.icon-bar {
  display: block;
  background: #ffffff;
  height: 1px;
  width: 18px;
  margin-top: 5px;
}
.navbar-fixed-top .navbar-collapse,
.navbar-fixed-bottom .navbar-collapse {
  max-height: none;
  border: none;
  box-shadow: none;
  padding: 0;
  width: 100%;
}
.navbar-dark .navbar-nav > li > a {
  color: #fff;
  font-size: 15px;
  text-decoration: none;
  display: inline-block;
  letter-spacing: 0.5px;
  /*text-transform: uppercase;*/
}
.navbar-dark .navbar-nav > li {
  padding: 13px 7.5px;
}
.navbar-dark .navbar-nav > li button {
  margin-bottom: 0;
}
.navbar-dark .navbar-nav > li ::-webkit-input-placeholder,
.navbar-dark .navbar-nav > li :-moz-placeholder,
.navbar-dark .navbar-nav > li ::-moz-placeholder,
.navbar-dark .navbar-nav > li :-ms-input-placeholder {
  color: #fff !important;
  opacity: 1 !important;
}
fieldset {
  border: none;
  padding: 0;
  margin: 0;
}
legend {
  font-size: 1.2em;
  font-weight: 500;
}
.navbar-dark .navbar-nav > .vr {
  height: 50px;
  width: 1px;
  margin-top: 5px;
  margin-left: 7px;
  padding-left: 0;
  padding-right: 7px;
  border-left: 1px solid #3e3e3e;
}
.navbar-dark .navbar-nav > li:not(.active) > a:hover,
.navbar-dark .navbar-nav > li > a:focus,
.navbar-dark .navbar-nav > li:focus,
.navbar-dark .navbar-nav > li.open > a:hover,
.navbar-dark .navbar-nav > li.open > a:focus,
.navbar-dark .navbar-nav > li.open > a:active,
.dropdown-menu > li > a:hover,
.dropdown-menu > li > a:focus,
.dropdown-menu > li > a:active {
  color: #fff;
  background: #2b2b2b;
  border-color: transparent;
}
.navbar-dark .navbar-nav > .open > a:hover,
.navbar-dark .navbar-nav > .open > a:focus {
  background: #27221a;
}
.navbar-dark .navbar-brand {
  padding: 0;
  /* cspell:ignore ccess */
}
.navbar-dark .navbar-brand img {
  height: 50px;
  display: inline;
}
.navbar-dark .navbar-brand .brand-letters {
  display: inline;
  margin-left: 4px;
}
.navbar-dark .navbar-brand .brand-letters img {
  height: 25px;
}
.navbar-dark .navbar-brand .brand-letters-ccess,
.navbar-dark .navbar-brand .brand-letters-gov {
  font-size: 40px;
  letter-spacing: 6pt;
  vertical-align: middle;
  display: inline-block;
  margin-top: -1px;
}
.navbar-dark .navbar-brand .brand-letters-ccess {
  font-weight: bold;
  color: #ccc;
}
.navbar-dark .navbar-brand .brand-letters-gov {
  color: #fff;
}
.navbar-dark .navbar-right {
  font-size: 1.1em;
  letter-spacing: 0.4pt;
  margin: 0;
  margin-right: -15px;
  margin-left: auto;
}
.form-control.search-control {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center left 7.5px;
  background-size: 15px;
  padding-left: 30px;
}
.navbar-dark .form-control.search-control:focus {
  border-bottom-color: #fff;
}
.search-backdrop,
.my-forms-backdrop {
  /*display: none;*/
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  z-index: 10000;
}
.search-backdrop .close {
  position: fixed;
  top: 30px;
  right: 30px;
  color: #fff;
  font-size: 2em;
  opacity: 1;
}
.search-backdrop .close img {
  height: 20px;
}
.search-backdrop .search-form-wrapper {
  width: 600px;
  height: 100px;
  max-width: 100%;
  position: fixed;
  top: 25vh;
  left: calc(50% - 300px);
}
.search-backdrop .search-form-wrapper .form-group label {
  font-size: 1.5em;
  color: #aaa;
  margin-bottom: 0;
  -webkit-transition: all 0.25s;
  transition: all 0.25s;
}
.search-backdrop .search-form-wrapper .form-group .form-control {
  background: none;
  height: 40px;
  color: #ddd;
  border: none;
  padding: 10px;
  border-bottom: 1px solid #aaa;
  border-radius: 0;
  box-shadow: none;
}
.search-backdrop .search-form-wrapper .form-group .form-control:focus {
  border-color: #466db2;
  border-bottom-width: 2px;
}
.nav-search-results {
  position: relative;
  height: auto;
  max-height: calc(75vh - 125px);
  min-height: 75px;
  overflow-y: auto;
  width: 600px;
  max-width: 100%;
  background: #fff;
  margin-top: 0;
  padding: 0;
  border-radius: 4px;
  box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.25);
  overflow: auto;
}
.nav-search-results .nav-search-results-inner {
  padding: 15px;
  position: relative;
  height: auto;
  width: 100%;
  overflow-x: hidden;
  text-align: left;
}
.nav-search-results .nav-search-results-caption {
  position: absolute;
  top: 5px;
  right: 10px;
  display: inline-block;
  color: #636363;
  font-size: 12px;
  /*font-weight: 600;*/
}
.nav-search-results .result {
  padding-top: 5px;
  letter-spacing: normal;
  /*font-size: 14px;*/
  text-align: left;
}
.nav-search-results .result:first-of-type {
  padding-top: 10px;
}
.close {
  opacity: 0.7;
  font-size: 1.25em;
}
.dropdown-menu {
  padding: 0;
  padding-bottom: 8px;
}
.dropdown-menu > li > a {
  display: block;
  color: #fff;
  font-size: 13px;
  padding: 6px 18px;
}
.dropdown-menu .divider {
  opacity: 0.3;
  background-color: #000000;
  margin: 0;
  display: none;
}
.pane-size-toggle {
  font-size: 32px;
  margin-top: -10px;
  -webkit-appearance: none;
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  float: right;
}
.toolbox_pane .pane-size-toggle {
  margin-top: -14px;
}
.toggle-symbol {
  font-size: 24px;
  margin-top: -10px;
}
.toggle-smaller {
  margin-left: 7px;
}
.toggle-larger {
  margin-left: 0;
}
.pane-size-toggle.close:hover {
  opacity: 1;
}
.df-public-nav .navbar {
  min-height: 0;
}
.navbar-toggle.public_pages_toggle {
  margin: 5px;
  padding: 5px;
}
.navbar-collapse .list-group {
  margin-bottom: 0;
}
.btn .icon {
  line-height: 0;
  vertical-align: inherit;
}
.btn .icon-trash {
  font-size: 1.1em;
}
.btn .icon-undo,
.btn .icon-redo {
  font-size: 1.15em;
}
.btn-link {
  color: #466db2;
}
.btn-link.icon:active,
.btn-link.icon:focus {
  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
}
.btn-group-vertical .btn {
  margin-bottom: 0;
}
.fixed-top {
  z-index: 1001;
}
.btn.btn-primary {
  background: #234d7f;
  color: #fff;
  border-color: transparent;
}
.btn.btn-primary:hover {
  background: #3471bb;
  border-color: #3471bb;
  color: #fff;
}
.btn.btn-primary:focus {
  outline: 2px solid #3471bb;
  outline-offset: 2px;
  box-shadow: unset;
}
.btn.btn-primary:active {
  background: #3471bb !important;
  color: #fff !important;
  border-color: #183557;
}
.btn.btn-outline-primary:hover {
  background: #234d7f;
  border-color: #234d7f;
}
.btn.btn-outline-primary:focus {
  background: #234d7f;
  color: #fff;
  outline: 2px solid #234d7f;
  outline-offset: 2px;
  box-shadow: unset;
}
.btn.btn-outline-secondary:focus {
  background: #6c757d;
  color: #ffffff;
  outline: 2px solid #6c757d;
  outline-offset: 2px;
  box-shadow: unset;
}
.btn.btn-outline-danger:focus {
  background: #dc3545;
  color: #ffffff;
  outline: 2px solid #dc3545;
  outline-offset: 2px;
  box-shadow: unset;
}
.btn.btn-outline-success:focus {
  background: #28a745;
  color: #ffffff;
  outline: 2px solid #28a745;
  outline-offset: 2px;
  box-shadow: unset;
}
.btn.btn-bare:focus {
  outline: 2px solid rgba(0, 0, 0, 0.87);
  outline-offset: 2px;
  box-shadow: unset;
}
.btn-block {
  display: block;
  width: 100%;
}
.btn.btn-xs {
  padding: 2px 5px;
  font-size: 0.75rem;
  border-radius: 3px;
  -webkit-transition: 0.1s all ease-in-out;
  -moz-transition: 0.1s all ease-in-out;
  -o-transition: 0.1s all ease-in-out;
  transition: 0.1s all ease-in-out;
}
.notificationBarTop {
  background: #ffc107;
  color: #121212;
  text-align: center;
  line-height: 2.5;
  overflow: hidden;
  /*margin-top: -15px;
    margin-bottom: 15px;*/
}
.notificationBarTop a,
html.bootstrap-legacy .notificationBarTop button,
html.bootstrap-5 .notificationBarTop button:not(.close) {
  color: #121212;
  font-weight: bold;
  border-bottom: 1px solid #121212;
  border-radius: 0;
  padding: 0;
}
.notificationBarTop a:hover,
html.bootstrap-legacy .notificationBarTop button:hover,
html.bootstrap-5 .notificationBarTop button:not(.close):hover {
  color: #0a0c0d;
}
html.bootstrap-5 .notificationBarTop button:not(.close) {
  text-decoration: none;
}
.notificationBarTop .close {
  color: #eeeeee;
  padding: 7px 10px;
  opacity: 0.8;
  font-size: 1.3em;
}
.notificationBarTop .close:hover {
  opacity: 1;
}
.notificationBarTop .close:not(:disabled):not(.disabled):hover,
.notificationBarTop .close:not(:disabled):not(.disabled):focus {
  color: #fff;
  opacity: 0.75;
}
.tab-content .result {
  border-bottom: 1px solid #ddd;
  padding: 15px;
}
.tab-content .result:first-of-type {
  border-top: 1px solid #ddd;
}
.form-group {
  margin-bottom: 0.75rem;
  /*label.focused {
        color: @focus;
    }*/
}
.form-group label.sr-only {
  position: absolute;
}
.form-group legend {
  font-size: 1em;
  font-weight: 600;
  border-bottom: none;
  margin-bottom: 2px;
}
.form-group .radio-inline,
.form-group .checkbox-inline,
.form-group .checkbox label,
.form-group .radio label {
  margin-left: 0;
  margin-right: 10px;
}
/*.radio-inline,
.radio,
.checkbox-inline,
.checkbox {
    font-size: 14px;
}*/
.loading {
  margin: 15px auto;
  display: block;
  margin: 0 auto;
  height: 100px;
}
.have_not_searched {
  text-align: center;
  height: 100%;
  width: 100%;
  /*padding-top: 15px;*/
}
.have_not_searched:before {
  /*content: "Use this search tool to find forms.";*/
  font-size: 1.2em;
  vertical-align: middle;
}
#questionsDiv {
  position: relative;
  margin-bottom: 20px;
}
#questionsDiv .radio {
  margin-bottom: 7px;
}
.public-page-body .body-content {
  padding: 0;
}
/* ------------------------
 AUTHENTICATED USER
------------------------ */
.index-container {
  display: flex;
  flex: 1;
  flex-direction: column-reverse;
}
.index-content legend {
  display: block;
  width: 100%;
  text-align: center;
}
.returning_user {
  overflow: auto;
  flex: 0 0 100%;
  padding: 0px 15px 15px 15px;
  background: #f9f9f9;
  border-top: 1px solid #ccc;
}
.returning_user .returning_user_header,
.returning_user .returning_user_body {
  visibility: visible;
}
.returning_user .nav-tabs {
  border-bottom-color: #bbbbbb;
}
.returning_user .nav-tabs li a {
  background: none !important;
}
.returning_user .badge {
  margin-left: 5px;
}
.returning_user .tab-content {
  padding: 4px 0;
  border: none;
  border-top: none;
}
.returning_user .returning_user_list_of_forms {
  list-style: none;
  padding: 0;
}
.returning_user .returning_user_list_of_forms li {
  position: relative;
  display: table;
  width: 100%;
  padding: 0.5rem;
  border-bottom: 1px solid #ccc;
}
.returning_user .returning_user_list_of_forms li .returning_user_actions {
  float: right;
  display: block;
}
#MyFormsHeading {
  margin-top: 15px;
  margin-bottom: 10px;
}
.submitted_timestamp {
  font-size: 12px;
  color: #6d6d6d;
  float: left;
  margin-top: 5px;
}
.my-forms-tag {
  display: block;
  clear: both;
  padding: 2px 6px;
  border-radius: 100px;
  font-size: 80%;
  margin-top: 5px;
  margin-bottom: 2.5px;
  float: left;
}
.my-forms-tag.returned {
  background: #ffebce;
}
.my-forms-tag.in-progress {
  background: #e0edff;
}
.my-forms-tag.done {
  background: #dbf2e4;
}
.my-forms-tag.unavailable {
  background: #ffe0e0;
}
.badge {
  font-weight: 600;
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.badge-primary {
  color: #fff;
  background-color: #007bff;
}
.badge-light {
  border: 1px solid #dee2e6;
}
div .nav-tabs {
  margin-right: 0;
}
.nav-tabs > li > .nav-link {
  border: none;
  border-bottom: 3px solid transparent;
}
.nav-tabs > li > .nav-link.active,
.nav-tabs > li > .nav-link.active:hover,
.nav-tabs > li > .nav-link.active:focus {
  border-bottom: 3px solid #466db2;
  background-color: #fff;
  border-radius: 0;
  color: #466db2 !important;
  border-bottom-color: #466db2 !important;
}
/*.nav-tabs > li.active > .nav-link.show {
    border-bottom-color: transparent;
}

.nav-tabs > li.active > .nav-link,
.nav-tabs > li.active > .nav-link:hover,
.nav-tabs > li.active > .nav-link:focus {
    border-bottom: 3px solid @focus;
    background-color: #fff;
    border-radius: 0;
    color: @focus !important;
    border-bottom-color: @focus !important;

    .badge {
        background-color: #333;
    }
}*/
.nav-tabs > li {
  margin-bottom: -1px;
}
.nav-tabs > li > .nav-link,
.nav-tabs > li > .nav-link:hover {
  color: inherit;
  margin-right: 0;
  background-color: transparent;
}
#myFormsDiv {
  max-height: 495px;
  overflow: auto;
}
#myFormsDiv ul {
  padding-left: 20px;
}
#myFormsDiv li {
  margin-bottom: 10px;
}
.navbar-dark .navbar-nav > li.login > a img,
.navbar-dark .navbar-nav > li.login.dropdown > a img {
  height: 20px;
  margin-right: 5px;
}
.navbar-dark .navbar-nav > li > a,
.navbar-dark .navbar-nav > li > a:hover,
.navbar-dark .navbar-nav > li > a:focus {
  color: #fff;
  background: transparent;
}
.navbar-dark .navbar-nav > li .dropdown-menu {
  background-color: #2b2b2b;
  border: 0;
  left: auto;
  right: 0;
}
.navbar-dark .navbar-nav > li .dropdown-menu > li > a {
  color: #fff;
  /*text-transform: uppercase;*/
}
.nav .open > a,
.nav .open > a:hover,
.nav .open > a:focus {
  border-color: transparent;
}
.help-block {
  color: #717171;
  font-size: 13px;
}
/*----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/* ------------------------
 FOOTER
------------------------ */
#demo {
  width: 600px;
  padding-top: 5px;
  margin-left: 10px;
  float: left;
}
#demo a,
a.visited,
a.hover {
  text-decoration: none;
  border: none;
}
#footer {
  background: #2b2b2b;
  color: rgba(255, 255, 255, 0.9);
  width: 100%;
}
#footer ul {
  padding: 24px 20px;
  list-style-type: none;
  text-align: center;
  list-style: none outside none;
  z-index: 11;
  bottom: 0px;
  margin: 0px auto;
  flex: auto;
  display: inline;
}
#footer ul li {
  margin: 0 5px;
  display: inline-block;
  color: #e2d5b4;
}
#footer ul li a {
  background: none;
  color: #fff;
  letter-spacing: normal;
  font-size: 12px;
}
#footer ul li:first-of-type {
  margin-left: 0;
}
#footer ul li:last-of-type {
  margin-right: 0;
}
#footer ul li:hover {
  background: none;
  color: #e2d5b4;
}
#footer > a {
  margin-left: auto;
  max-height: 48px;
  border: none;
}
.mi-footer-logo {
  height: 35px;
  margin-top: -6px;
}
.accessgov-footer-logo {
  height: 45px;
  margin-top: -10px;
}
.visible-xs-inline-block {
  display: none;
}
.my-forms-backdrop {
  background: rgba(0, 0, 0, 0.5);
  height: 100vh;
  width: 100%;
  z-index: 999;
}
.index-logo {
  height: 150px;
  margin: 10px auto;
  max-width: 100%;
}
.public-page-body .tile {
  margin-top: 20px;
  margin-bottom: 20px;
}
.public-page-body .body-content {
  padding: 0 5px;
}
@media (max-width: 767px) {
  body {
    padding-top: 60px;
    background-image: none;
    padding-bottom: 0 !important;
  }
  .body-content {
    margin-top: 0;
    padding-top: 0;
  }
  .transitions-after-load .body-content {
    height: 100vh;
  }
  .nav .dropdown {
    position: static;
  }
  .dropdown-menu {
    position: static;
    box-shadow: none;
  }
  .notificationBarTop {
    /*margin-top: -10px;*/
    margin-bottom: 0;
  }
  #footer {
    position: static;
    text-align: center;
    height: auto;
    /*margin-top: 25px;*/
    padding: 15px 0;
    display: block;
  }
  #footer ul {
    display: block;
    width: 90%;
  }
  #footer ul li {
    display: block;
    margin-left: 0;
    margin-right: 0;
  }
  #footer ul li a:link,
  #footer ul li a {
    /*background: @primary-light;*/
    float: none;
    margin: 0.5em 0px;
    padding: 1.2em 0 1.2em;
    height: auto;
    display: block;
    margin-bottom: 5px;
    /*color: #fff;*/
    padding-top: 10px;
    padding-bottom: 10px;
  }
  #footer ul li a:link:hover,
  #footer ul li a:hover {
    background: #eee !important;
    text-decoration: underline;
    color: #2b2b2b;
  }
  #footer ul li:hover a {
    background: #454545;
  }
  #questionsDiv {
    height: auto;
    padding-bottom: 0;
    position: relative;
  }
  .form-control {
    max-width: none;
  }
  .visible-xs-inline-block {
    display: inline-block !important;
  }
  .have_not_searched {
    background-position: center center;
    background-size: 150px;
    padding-top: 30px;
  }
  /*.dfNavButton:not(.dfNavRemoveButton) {
        display: block;
        width: 100%;
        margin-bottom: 5px;
    }*/
  .dropdown-toggle {
    width: 100%;
  }
  .pane-size-toggle {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    margin-top: -8px !important;
    margin-right: 0 !important;
  }
  .navbar-dark {
    padding: 13px 5px;
  }
  .navbar-dark a.search-toggle,
  .navbar-dark a.search-toggle:hover,
  .navbar-dark a.search-toggle:focus {
    float: right;
    color: #ffffff;
    opacity: 0.8;
    padding: 0 10px;
  }
  .navbar-dark a.search-toggle .icon,
  .navbar-dark a.search-toggle:hover .icon,
  .navbar-dark a.search-toggle:focus .icon {
    display: block;
    margin-top: 2px;
  }
  .navbar-dark .navbar-brand {
    width: min-content;
    margin: 0 auto;
  }
  .navbar-dark .navbar-brand img {
    height: 33px;
  }
  .navbar-dark .navbar-brand .brand-letters {
    margin-left: 3px;
  }
  .navbar-dark .navbar-brand .brand-letters img {
    height: 15px;
  }
  .navbar-dark .navbar-toggler,
  .navbar-dark .navbar-toggler:focus,
  .navbar-dark .navbar-toggler:hover {
    background: #2b2b2b;
    border: none;
    box-shadow: none;
    padding: 0.25rem 0.75rem 0.5rem 0.75rem;
    /*.navbar-toggler-icon {
                width: 20px;
                height: 20px;
            }*/
  }
  .search-backdrop,
  .my-forms-backdrop {
    padding: 5px 15px;
    height: 150vh;
  }
  .search-backdrop .close {
    font-size: 1.4em;
    top: 15px;
    right: 15px;
  }
  .search-backdrop .close img {
    height: 15px;
  }
  .search-backdrop .search-form-wrapper {
    position: static;
    margin-top: 40px;
    width: 100%;
  }
  .navbar-dark .navbar-nav > .vr {
    display: none;
  }
  .navbar-dark .form-group.search-group .search-control {
    width: 100% !important;
  }
  .navbar-dark .navbar-left {
    margin-left: 0;
    margin-right: -15px;
  }
  .navbar-dark .navbar-nav > li {
    padding: 0 7px;
  }
  .navbar-dark .icon-search {
    font-size: 1.4em;
  }
  #collapse2 {
    padding: 8px;
    overflow-x: hidden;
  }
  .nav-search-results {
    position: relative;
    width: calc(100% - 30px);
    z-index: 10000;
    max-height: calc(100vh - 150px);
    /*background: #fff;
        margin-top: 0;
        padding: 0;
        border: 1px solid #ddd;
        box-shadow: 0 2px 6px 1px rgba(0,0,0,.25);
        overflow: auto;*/
  }
  .nav-search-results .nav-search-results-inner {
    padding: 15px;
    position: relative;
    height: auto;
    width: 100%;
  }
  .nav-search-results .nav-search-results-caption {
    position: absolute;
    top: 5px;
    right: 10px;
    display: inline-block;
    color: #717171;
    font-size: 11px;
  }
  .nav-search-results .result {
    padding-top: 5px;
    letter-spacing: normal;
    font-size: 13px;
  }
  .nav-search-results .result:first-of-type {
    padding-top: 10px;
  }
}
@media (min-width: 768px) {
  body,
  label,
  .btn,
  .form-control {
    font-size: 15px;
  }
  .navbar-dark {
    height: 70px;
  }
  .navbar-dark .navbar-brand {
    pointer-events: none;
  }
  .public-page-body .body-content {
    padding: 0;
  }
  .index-content {
    padding: 15px;
  }
  .returning_user {
    margin: 0;
  }
  .mi-footer-logo {
    float: right;
  }
  .lead {
    font-size: 16px;
  }
  .accessgov-footer-logo {
    float: left;
  }
  .my-forms-backdrop {
    display: none;
  }
  #collapse2 {
    margin-right: 10px;
  }
  .navbar-inverse .navbar-nav > li .dropdown-menu {
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
  }
}
@media (max-width: 991px) {
  .img-responsive {
    /* account for large homepage images to be responsive on mobile devices */
    max-width: 100%;
    height: auto !important;
  }
}
/* Medium devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .lead {
    font-size: 17px;
  }
  .index-container {
    flex-direction: row;
    min-height: calc(100vh - 70px);
  }
  .index-container .index-content {
    flex: 1;
  }
  .index-container .returning_user {
    flex: 0 0 375px;
    border-top: none;
    border-right: 1px solid #ccc;
    overflow: auto;
  }
  .body-content {
    min-height: calc(100vh - 70px);
  }
}
@media (min-width: 1200px) {
  .have_not_searched {
    background-position: center 40%;
  }
}
@media print {
  .no_print,
  #footer,
  .btn {
    display: none !important;
  }
}
.no-bg {
  background: #fff;
  padding-bottom: 0;
  margin-bottom: 0;
  padding-top: 70px;
  padding-bottom: 60px;
  height: 100vh;
}
img.bg {
  min-height: 100%;
  min-width: 1024px;
  width: 100%;
  height: auto;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
}
/* Override the default bootstrap behavior where horizontal description lists
   will truncate terms that are too long to fit in the left column
*/
.dl-horizontal dt {
  white-space: normal;
}
/* ------------------------
 GENERAL STYLES
------------------------ */
.body-content-fluid {
  padding: 15px;
}
h1 {
  margin-bottom: 20px;
}
h3 {
  margin-top: 15px;
}
b,
strong {
  font-weight: 600;
}
.inline-block {
  display: inline-block;
}
.indent {
  padding-left: 45px;
}
.alert p:last-child {
  margin-bottom: 0;
}
.width-auto {
  width: auto;
}
.scroll-y {
  overflow-y: auto;
}
.scroll-x {
  overflow-x: auto;
}
.well {
  background: #eee;
  border-radius: 0;
  border: 0;
  margin-top: 10px;
  box-shadow: none;
}
.well ul:last-of-type,
.well p:last-of-type {
  margin-bottom: 0;
}
.breadcrumb {
  background: #fff;
  padding: 0;
  padding-bottom: 3px;
  border-bottom: 1px solid #ddd;
  border-radius: 0;
}
.breadcrumb > li + li:before {
  padding: 0 3px;
  color: #666666;
}
a.tile {
  color: #444;
}
.btn-outline-danger {
  color: #d42435;
}
.btn-outline-success {
  color: #1e7e34;
}
.tile:not(.form_intro) h2 {
  /*margin-top: 0;*/
  /*padding-bottom: 5px;*/
  /*border-bottom: 1px solid #eee;*/
}
.well > h3 {
  margin-top: 0;
}
.add-new-row .btn {
  display: block;
  width: 100%;
  border-radius: 0;
  box-sizing: border-box;
  margin-top: 3px;
  /* for active outline */
}
.add-new-row .btn:not(:focus):not(:hover) {
  background: #ffffff;
  border-color: #dddddd;
}
#DataSourceTable .btn:hover,
#DataSourceTable .btn:focus {
  box-shadow: inset 0 0 0 1px #3471bb;
  border-color: #3471bb;
}
.action-success-icon,
.action-failure-icon {
  float: left;
  margin-right: 5px;
}
.action-success-text,
.action-failure-text {
  margin: 0;
  font-weight: bold;
}
.action-success-text,
.action-success-icon {
  color: #008000;
}
.action-failure-text,
.action-failure-icon {
  color: #800000;
}
.optional:after {
  content: " (Optional)";
  color: #737373;
}
.plus-sign {
  color: #1e7e34;
  font-size: 1.25em;
  margin-top: -3px;
  display: inline-block;
  vertical-align: baseline;
  line-height: normal;
}
*:disabled .plus-sign {
  color: #666666;
}
.btn-outline-secondary:hover .icon-trash {
  color: #fff;
}
.btn:hover:disabled .plus-sign {
  color: #666666;
}
.btn:hover .plus-sign {
  color: #ffffff;
}
.btn:disabled .icon-trash,
button:disabled .icon-trash {
  color: inherit;
}
.icon-trash {
  color: #d64343;
}
.pull-left {
  float: left;
}
[disabled="disabled"],
.disabled img:hover {
  cursor: not-allowed !important;
}
.disabled {
  pointer-events: none;
  cursor: default;
}
hr {
  border-color: #dddddd;
}
.v--modal-overlay {
  z-index: 1002;
}
.modal-content {
  border: none;
  max-height: 100vh;
  overflow-y: auto;
}
.modal .loading {
  height: 50px;
}
.modal-title {
  margin: 0;
}
.modal-footer {
  display: block;
  text-align: center;
}
.address-field {
  margin-bottom: 10px;
}
.card-header,
.list-group-item {
  background-color: transparent;
  color: inherit;
}
.card-body {
  background: #f5f5f5;
}
.card-body .table {
  margin-bottom: 0;
}
.clickable-element,
a {
  cursor: pointer;
}
/* --------------------------------------------------------------------
    DATEPICKER
-------------------------------------------------------------------- */
.ui-state-default,
.ui-widget-content .ui-state-default,
.ui-widget-header .ui-state-default,
.ui-button,
html .ui-button.ui-state-disabled:hover,
html .ui-button.ui-state-disabled:active {
  background: #fff;
  border-color: transparent;
  text-align: center;
  width: 30px;
  color: #0071bc;
  padding: 5px 0;
  border-radius: 2px;
}
.ui-state-highlight,
.ui-widget-content .ui-state-highlight,
.ui-widget-header .ui-state-highlight {
  background: #eee;
}
.ui-state-active,
.ui-widget-content .ui-state-active,
.ui-widget-header .ui-state-active,
a.ui-button:active,
.ui-button:active,
.ui-button.ui-state-active:hover {
  border-color: #466db2;
}
.ui-datepicker .ui-datepicker-next,
.ui-datepicker .ui-datepicker-prev {
  cursor: pointer;
}
.ui-widget-header {
  border: none;
  border-radius: 0;
  background: #f1f1f1;
}
.ui-datepicker table thead {
  text-transform: uppercase;
  font-size: 0.8em;
  color: #666;
  background: #f1f1f1;
}
.ui-datepicker-trigger {
  height: 20px;
  position: absolute;
  right: 8px;
  top: 8px;
  cursor: pointer;
}
.ui-datepicker .ui-datepicker-title {
  color: #555;
}
.ui-datepicker .ui-datepicker-prev span,
.ui-datepicker .ui-datepicker-next span {
  display: none !important;
}
.ui-datepicker .ui-datepicker-prev,
.ui-datepicker .ui-datepicker-prev:hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center center no-repeat;
  background-size: 8px;
  left: 2px;
  top: 2px;
}
.ui-datepicker .ui-datepicker-next,
.ui-datepicker .ui-datepicker-next:hover {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center center no-repeat;
  background-size: 8px;
  right: 2px;
  top: 2px;
}
#ui-datepicker-div {
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  border: none;
  z-index: 10 !important;
  /*override inline z-index*/
}
#ui-datepicker-div .ui-priority-secondary,
#ui-datepicker-div .ui-widget-content .ui-priority-secondary,
#ui-datepicker-div .ui-widget-header .ui-priority-secondary {
  opacity: 1;
}
.index-heading {
  margin-top: 20px;
  font-size: 24px;
}
/* ------------------------
 VALIDATION
------------------------ */
.validation-summary-errors {
  margin-bottom: 15px;
}
.validation-summary-errors ul {
  list-style: none;
  margin: auto;
  vertical-align: middle;
  margin-bottom: 0;
  padding-left: 0;
}
.validation-summary-errors ul li {
  color: #b94a48;
}
.required {
  color: #b94a48;
}
/*#region ADMIN*/
/* ------------------------
 GUIDED QUESIONS
------------------------ */
.gq_error_message {
  color: #d01022;
  margin-right: 15px;
  /*border: 1px solid red;
    padding: 3px 8px;*/
}
.gq_maincontent {
  height: 200px;
  font-size: 0.9em;
}
.gq_maincontent textarea,
.gq_maincontent .htmlContent {
  height: 182px;
}
.gq_maincontent .htmlContent {
  border: 1px dashed #dddddd;
  overflow: hidden;
  /* Because we want encourage shorter content */
}
.gq_container {
  overflow: auto;
  width: 100%;
  margin: 0;
  position: relative;
}
.gq_container > h2 {
  padding: 0;
  margin: 0 0 9px 0;
}
.gq_container .gq_box_container {
  position: relative;
}
.gq_container .gq_box_container,
.gq_container .gq_top_container,
.gq_container .gq_bottom_container {
  height: calc(100vh - 400px);
}
.gq_container .gq_top_container,
.gq_container .gq_bottom_container {
  top: 0;
}
.gq_container .gq_top_container {
  background: #f5f5f5;
  border: 1px solid #ddd;
  width: 100%;
  overflow: auto;
  padding-right: 475px !important;
  z-index: 0;
}
.gq_container .gq_top_container svg {
  white-space: nowrap !important;
}
.gq_container .gq_top_container.is_editing {
  width: calc(100% - 400px);
  padding-right: 0 !important;
}
.gq_editor_controls {
  position: fixed;
  background: #fff;
  padding: 10px 15px 0 15px;
  right: 16px;
  width: 398px;
  margin-top: -60px;
  z-index: 1000;
}
.gq_editor_controls .btn {
  margin-bottom: 0;
  /*float: left;*/
}
.gq_editor_controls .close {
  position: absolute;
  right: 15px;
  padding: 0;
}
.gq_editor_controls .close:hover {
  color: #444;
}
.gq_editor_controls .change-text {
  float: left;
  padding: 7px 0;
}
.gq_bottom_container {
  background: #fff;
  z-index: 999;
  display: block;
  position: absolute;
  padding-top: 60px;
  width: 400px;
  height: calc(100vh - 120px);
  bottom: 0;
  right: 0;
  border: 1px solid #ddd;
  overflow-y: auto;
}
.gq_bottom_container .gq_bottom_container_top {
  position: fixed;
  width: 398px;
  background: #fff;
  padding: 10px 0 5px 0;
  z-index: 1000;
  box-shadow: 0 1px 8px 0 #fff;
}
.gq_bottom_container .form-group {
  margin-bottom: 10px;
}
.gq_bottom_container .form-group label {
  top: 0 !important;
  left: 2px !important;
}
.gq_bottom_container .selected {
  border-left: 4px solid #466db2;
}
.gq_bottom_container .list-group-item:not(.selected) a {
  color: inherit;
}
.gq_bottom_container .list-group-item:not(.selected):hover {
  border-left: 4px solid #dddddd;
}
.overflow-y-auto {
  overflow-y: auto !important;
  overflow-x: hidden;
}
#endpointEditor .panel {
  border-radius: 0;
  /*border-left: 8px solid transparent;*/
}
#endpointEditor .panel .panel-heading strong {
  color: #234d7f;
}
.node-name {
  margin-bottom: 0;
}
#zoomInAndOut {
  z-index: 501 !important;
  position: absolute;
}
.web_details_section h3 {
  border-bottom: 1px solid #eee;
  padding-bottom: 3px;
}
/*Template Nodes*/
#gqTemplateNodes {
  display: none !important;
}
.gq_node {
  background: #fff;
  font-size: 0.9em;
  padding: 0;
  white-space: nowrap !important;
  overflow: hidden;
  border: none;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);
  border-radius: 3px;
  color: #444;
}
.gq_node.error {
  box-shadow: 0 1px 6px 0 rgba(200, 0, 0, 0.75);
}
.gq_node.error .node_body {
  background: #ffecec;
}
.gq_node a {
  color: #444;
}
.gq_node > div {
  display: flex !important;
}
.gq_node.error {
  border-color: red;
}
.selected_node {
  border-color: dodgerblue;
}
.node_addon {
  display: block;
  height: 32px;
  overflow: hidden;
  width: 40px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  text-align: center;
  vertical-align: super;
  padding: 7.5px;
  padding: 5px 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center center;
  color: #fff;
}
.node_addon .plus-sign {
  margin-top: 0;
}
.node_body {
  text-align: center;
  height: 32px;
  padding: 5px 8px;
  display: block;
  overflow: hidden;
  width: auto;
}
.node_body a {
  color: #466db2;
}
.gq_node .node_body:hover {
  cursor: pointer;
  background: #f5f5f5;
  text-decoration: none;
}
.node_body.long {
  box-shadow: -10px 0 15px -10px inset;
}
.color-indicators {
  display: inline-block;
  vertical-align: middle;
}
.color-indicators span {
  height: 12px;
  width: 12px;
  display: inline-block;
  border-radius: 6px;
  margin-left: 3px;
}
.color-indicators span:first-of-type {
  margin-left: 5px;
}
.color-indicators [data-indicator="webForm"] {
  background: #389de4;
}
.color-indicators [data-indicator="pdfForm"] {
  background: #d6504f;
}
.color-indicators [data-indicator="link"] {
  background: #c063e6;
}
.color-indicators [data-indicator="contact"] {
  background: #2ab95c;
}
.color-indicators [data-indicator="content"] {
  background: #eaa030;
}
.gq_question_node {
  display: block;
}
.gq_question_node .node_addon {
  background: #333333;
  font-size: 1.4em;
  padding: 0;
}
.gq_linked_question_node {
  display: block;
}
.gq_linked_question_node .node_addon {
  background: #333333;
  font-size: 1.4em;
  padding: 0;
}
.gq_answer_node {
  display: block;
}
.gq_answer_node .node_addon {
  background: #d4d4d4;
  font-size: 1.6em;
  padding: 0;
  color: #202020;
}
.gq_web_node {
  display: block;
}
.gq_web_node .node_addon {
  background-color: #389de4 !important;
}
.gq_pdf_node {
  display: block;
}
.gq_pdf_node .node_addon {
  background-color: #d6504f;
}
/*.gq_pdf_node.gq_web_node {
    .node_addon {
        background-image: url("../images/endpoint.png"), linear-gradient(@pdf-red 50%, @button-color 50%);
        background-repeat: no-repeat;
        background-position: center center;
    }
}*/
.gq_link_node {
  display: block;
}
.gq_link_node .node_addon {
  background-color: #c063e6;
}
.gq_link_node.gq_pdf_node {
  display: block;
}
.gq_link_node.gq_pdf_node .node_addon {
  background-color: #1496b6;
}
.gq_contact_node {
  display: block;
}
.gq_contact_node .node_addon {
  background-color: #2ab95c;
  font-size: 1.2em;
}
.gq_contact_node .node_addon span {
  vertical-align: top;
}
.gq_content_node {
  display: block;
}
.gq_content_node .node_addon {
  background-color: #eaa030;
  font-size: 1.3em;
}
.gq_content_node .node_addon span {
  vertical-align: top;
}
#GuidedSearchContainer {
  padding-top: 10px;
}
/* ------------------------
 Admin Endpoint Creator
------------------------ */
#formUploadAccordion {
  border: none;
}
#formUploadAccordion .panel-default {
  border: none;
}
#formUploadAccordion .panel-default .panel-heading {
  background: #fff;
}
#formUploadAccordion .panel-default .panel-heading .edit {
  margin-left: 5px;
  cursor: pointer;
}
#formUploadAccordion .panel-default:last-of-type .card-body {
  border-bottom: 1px solid #ddd;
}
#formUploadAccordion .form_upload_type > input {
  visibility: hidden;
  position: absolute;
}
#formUploadAccordion .form_upload_type > input + img {
  cursor: pointer;
  border: 1px solid transparent;
  padding: 7.5px;
  border-radius: 4px;
}
#formUploadAccordion .form_upload_type > input:checked + img {
  border-color: dodgerblue;
}
#formUploadAccordion .qualified_question {
  border-top: 1px solid #eee;
  margin-top: 10px;
  padding-top: 10px;
}
.panel_header {
  display: inline-block;
  font-size: 1.7em;
  border: none;
  padding: 0 !important;
  margin: 0;
}
.step_header {
  display: inline-block;
  text-align: center;
  color: #fff !important;
  background: #444;
  width: 35px;
  height: 35px;
  vertical-align: baseline;
  margin-right: 10px;
  border-radius: 50%;
  padding-top: 2px;
}
#wysiwyg_ifr {
  min-height: 300px;
}
#formUploadAccordion .form_upload_type > input + img {
  height: 100px;
  padding: 5px;
}
/*#endregion*/
.panel-default .panel-heading.is_hidden {
  background: #eee;
}
.panel-default .panel-heading.is_hidden strong {
  color: #000000;
}
.panel-default .panel-heading.is_hidden .is_hidden_text {
  color: #000000;
  font-weight: bold;
  font-style: italic;
  float: right;
}
[class*="cke_editor"] {
  margin-bottom: 15px !important;
}
textarea.cke_source,
.cke_editable {
  font-weight: normal;
}
.admin_directory_additional_content_box,
.admin_directory_qualifying_questions_box {
  max-height: 300px;
  overflow: auto;
  border: 1px solid #ddd;
  padding: 15px;
  margin-bottom: 10px;
}
#submitFormEntry .btn:last-child {
  margin-left: 5px;
}
.directory_accordion .card-body .btn:not(:last-child) {
  margin-right: 5px;
}
/* ------------------------
 MENU
------------------------ */
.admin-card {
  display: block;
  position: relative;
  top: 0;
  padding: 15px;
  box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.25);
  border: none;
  text-align: center;
  transition: all ease 0.25s;
}
.admin-card .admin-icon {
  color: #234d7f;
  font-size: 95px;
  vertical-align: middle;
}
.admin-card .admin-icon:before {
  display: block;
  margin: 30px auto 5px auto;
}
.admin-card .card-text {
  color: #212529;
  margin-top: 10px;
}
.admin-card .caption-heading {
  display: inline-block;
  /*font-weight: 600;*/
  font-size: 1.2em;
  margin-top: 10px;
  color: #234d7f;
}
.admin-card:focus,
.admin-card:hover {
  top: -4px;
  text-decoration: none;
  box-shadow: 0 6px 25px 0 rgba(0, 0, 0, 0.25);
}
.admin-card:focus .admin-icon,
.admin-card:hover .admin-icon,
.admin-card:focus .caption-heading,
.admin-card:hover .caption-heading {
  color: #3e7eca;
}
/* ------------------------
 SUBMISSIONS
------------------------ */
.editable-container .editable-click,
.editable-container a.editable-click,
.editable-container a.editable-click:hover {
  color: inherit;
  border-bottom: none;
}
.editable-container .editable-buttons {
  position: absolute;
  margin-left: 0;
}
.editable-container .editable-buttons .editable-submit,
.editable-container .editable-buttons .editable-cancel {
  padding: 0 3px;
  margin-left: 3px;
}
.editable-container .editable-input {
  margin-top: -4px;
}
.editable-container .editable-input input,
.editable-container .editable-input select {
  padding: 0;
}
.table-sm {
  font-size: 0.875rem;
}
.table-sm th,
.table-sm td {
  vertical-align: middle;
}
.table .editable-td,
.table-sm .editable-td {
  padding-bottom: 0;
}
.inline-edit-field {
  color: inherit;
  border-bottom: none !important;
}
.submissions-vr {
  display: inline;
  border-left: 1px solid #dee2e6;
  margin-left: 15px;
  margin-right: 15px;
  vertical-align: middle;
  height: 20px;
}
.submissions-bulk-input {
  max-width: 170px;
}
.submissions-bulk-btn {
  padding: 0;
}
.submissions-bulk-btn .icon-trash {
  margin-top: -8px;
  display: block;
}
.delete-submissions:focus,
.delete-submissions:hover {
  text-decoration: none;
}
.submissions-left-col,
.submissions-right-col {
  padding: 0 15px;
  width: 100%;
}
.submissions-left-col {
  background: whitesmoke;
  overflow: auto;
}
.submissions-left-col .help-block {
  white-space: nowrap;
}
.submissions-left-col .comment-card {
  border: none;
  padding: 0;
  margin: 0;
}
.no-form-comments .submissions-left-col {
  width: 0;
}
.no-form-comments .submissions-right-col {
  width: 100%;
}
.has-form-comments {
  padding-top: 0;
  padding-bottom: 0;
}
.has-form-comments .submissions-left-col,
.has-form-comments .submissions-right-col {
  overflow: auto;
}
.has-form-comments .submissions-right-col {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 30px;
}
.submissions-bulk-options {
  display: inline;
  width: calc(100% - 100px);
}
.submissions-actions-td {
  white-space: nowrap;
  text-align: right;
  width: 85px;
}
.submissions-actions-td .icon {
  font-size: 1.1em;
  vertical-align: middle;
  line-height: 0;
}
.submissions-actions-td .icon:hover,
.submissions-actions-td .icon:focus {
  text-decoration: none;
}
.submissions-actions-td .icon-comment {
  margin: 0;
}
.submissions-comment-count {
  font-size: 0.9em;
  vertical-align: baseline;
  line-height: 0;
}
.form-control-review {
  width: auto;
  display: inline;
}
.pdf-inline {
  display: inline;
  display: table;
  float: left;
  margin-bottom: 5px;
}
.display-label,
.display-value {
  display: table-cell;
  padding: 0;
  margin: 0;
  padding-right: 5px;
  text-align: left;
  vertical-align: top;
  float: left;
}
.display-label {
  font-weight: bolder;
  font-size: 1em;
}
.display-value {
  word-break: break-word;
}
.calculated-list-item {
  display: block;
}
/* fix formatting issue for display elements on review pages */
.display-element-container .form-group {
  max-width: 100%;
}
/*----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
/*#region PUBLIC*/
/* ------------------------
 DYNAMIC FORMS
------------------------ */
.df-public-nav .list-group-item {
  -webkit-transition: all ease 0.25s;
  transition: all ease 0.25s;
}
.df-public-nav .list-group-item .icon {
  display: none;
}
.df-page-title {
  display: none;
  margin-top: 0;
  margin-left: 0;
  border-left: 0;
  font-size: 18px;
  padding-left: 0;
}
.dfForEachItem .dfNavRemoveButton {
  background-color: transparent;
  position: absolute;
  right: 0;
  top: -7px;
  padding: 0 10px;
  color: #d42435;
  font-size: 1.5em;
}
.dfForEachItem.row {
  margin-left: 0;
  margin-right: 0;
}
.defDiv {
  /*.settingDiv {
        background: @cream;
    }*/
}
.defDiv .defHeader {
  background: #2b2b2b;
  background-color: #2b2b2b;
  border-bottom: 1px solid #050505;
}
.defDiv .settingHeader {
  display: none;
}
.defDiv *[data-df-type="AddChildButton"] {
  background: #2b2b2b;
  background-color: #2b2b2b;
  color: #70b85d;
}
.defDiv *[data-df-type="AddChildButton"]:hover {
  background: #050505;
  background-color: #050505;
}
.defDiv [data-df-type="NameOutput"] {
  color: #6edcff;
}
.defDiv .childrenDiv,
.defDiv .form {
  border-color: #050505;
}
.DFPageContent {
  margin-left: 0;
  margin-right: 0;
  /*.{
        padding: 0;
    }*/
}
.DFPageContent .checkbox:only-of-type [type="checkbox"][data-val-required]:before,
.DFPageContent .checkbox-inline:only-of-type [type="checkbox"][data-val-required]:before {
  color: #d64343;
  margin-top: -3px;
  margin-left: -12px;
  font-weight: bold;
  vertical-align: text-top;
  content: " *";
  display: inline-block;
}
.DFPageContent .col-sm-12.col-xs-offset-1 {
  margin-left: 0;
}
a.dfPageLink_Complete,
button[type="submit"].dfPageLink_Complete {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: 17px;
  background-position: 7px center;
}
a.dfPageLink_Invalid,
button[type="submit"].dfPageLink_Invalid {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: 17px;
  background-position: 7px center;
}
a.dfPageLink_Disabled,
button[type="submit"].dfPageLink_Disabled {
  background-color: #f0f0f0 !important;
}
a.dfPageLink_InProgress,
button[type="submit"].dfPageLink_InProgress {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: 10px;
  background-position: 11px center;
  background-color: #ddd !important;
  color: #444 !important;
  border-color: #bbb !important;
}
a.dfPageLink_Saving,
button[type="submit"].dfPageLink_Saving {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: 17px;
  background-position: 7px center;
}
.list-group-item {
  word-break: break-word;
  text-decoration: none !important;
  -webkit-transition: all ease 0.15s;
  transition: all ease 0.15s;
}
.list-group-item a {
  text-decoration: none !important;
}
.list-group-item.active,
.list-group-item.active:hover,
.list-group-item.active:focus {
  background-color: #ffffff;
  color: buttontext !important;
  border-left-width: 5px !important;
  border-left-style: solid !important;
  border-color: #466db2;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.df-navigation-btn-container {
  display: flex;
  flex-wrap: wrap;
}
.df-navigation-btn-container .btn {
  margin-bottom: 15px;
  width: 100%;
}
.form_submit_success_buttons .btn:not(:last-of-type) {
  margin-right: 5px;
}
.bs-docs-grid {
  padding: 15px;
}
.bs-docs-grid .clearfix.alert-danger {
  margin: auto !important;
}
.bs-docs-grid .clearfix.alert-danger .pull-left img {
  display: none;
}
.select_element_page_children .btn {
  height: auto;
}
.icon-with-text {
  position: relative;
  color: inherit;
}
.icon-with-text .icon-text {
  opacity: 0;
  background: #fff;
  position: absolute;
  top: -4ex;
  right: 0;
  border: 1px solid #999;
  padding: 0 4px;
  pointer-events: none;
  z-index: 100;
  white-space: nowrap;
  -webkit-transition: opacity linear 0.15s;
  transition: opacity linear 0.15s;
  transition-delay: 0.25s;
}
.icon-with-text:hover,
.icon-with-text:focus {
  text-decoration: none;
}
.icon-with-text:hover .icon-text,
.icon-with-text:focus .icon-text {
  opacity: 1;
  color: inherit;
}
/* ------------------------
 PUBLIC USER
------------------------ */
#welcomeDiv img {
  max-width: 100%;
  margin: 15px 0;
}
#welcomeDiv hr {
  margin-left: -10px;
  margin-right: -10px;
  margin-top: 25px;
  margin-bottom: 35px;
}
.search {
  width: 100%;
}
.search .input-group {
  margin: auto;
  margin-bottom: 10px;
  width: 300px;
}
.drop_target {
  clear: both;
}
.page_title {
  float: left;
}
.input-group-text {
  font-size: inherit;
}
a[data-toggle="popover"],
.list_items_toggle {
  text-decoration: none !important;
}
.has-error .form-control,
.panel-default .card-body .has-error .form-control {
  border-color: #ca0706;
}
.has-error .help-block,
.panel-default .card-body .has-error .help-block {
  color: #a94442;
}
.select2-container--default.select2-container--focus .select2-selection--multiple,
.select2-container--default.select2-container--focus .select2-selection--single,
.select2 select2-container select2-container--default select2-container--below,
.select2 select2-container select2-container--default,
.select2-selection--single,
.select2-selection--multiple,
.select2-container--default {
  height: 34px !important;
  max-width: 100%;
  border-radius: 0 !important;
  border: none !important;
  border-bottom: 2px solid #ddd !important;
  border-color: #dddddd;
  padding: 2px;
  font-size: 14px;
  background: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  -webkit-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.select2-container--default.select2-container--focus .select2-selection--multiple,
.select2-container--default.select2-container--focus .select2-selection--single {
  border-color: #466db2 !important;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
}
.select2-container {
  border-radius: 0;
  background: none !important;
  border: none !important;
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 32px !important;
}
.select2-container .select2-selection--single .select2-selection__rendered {
  padding-left: 12px !important;
  padding-top: 3px !important;
}
.dashboard_btn {
  display: block;
  border-radius: 2px;
  text-align: center;
  padding: 15px;
  font-size: 1.2em;
  text-decoration: none !important;
  height: auto;
}
#formDirectoryBtn,
.dashboard_btn {
  color: #234d7f;
  -webkit-transition: 0.1s all ease-in-out;
  -moz-transition: 0.1s all ease-in-out;
  -o-transition: 0.1s all ease-in-out;
  transition: 0.1s all ease-in-out;
}
#formDirectoryBtn:hover {
  color: #3471bb;
  background: #f3f3f3;
}
#formDirectoryBtn a {
  margin-top: 10px;
  display: inline;
  color: #234d7f;
}
.dashboard_btn span {
  color: #444;
  margin-top: 10px;
  display: inline;
}
.dashboard_btn img {
  height: 25px;
  margin-right: 3px;
  margin-top: 0;
  display: inline;
}
#formDirectoryTile:hover,
#formDirectoryBtn:hover,
.dashboard_btn:hover {
  text-decoration: none;
}
#formDirectoryTile img {
  height: 75px;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 15px;
}
#formDirectoryTile {
  font-size: 1.2em;
}
#homeSearchForm {
  margin-top: 15px;
}
.has_results {
  background: #fff;
}
.need_character:before {
  content: "Please enter at least 1 character to search.";
  font-size: 1.2em;
  vertical-align: middle;
}
#questionsDiv {
  position: relative;
}
#questionsDiv .radio {
  margin-bottom: 7px;
}
.transitions-after-load * {
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -ms-transition: none !important;
  -o-transition: none !important;
}
/* ------------------------
 ENDPOINT LANDING
------------------------ */
/*.form_intro {
    padding-top: 15px;

    .btn:not(:last-of-type) {
        margin-right: 5px;
    }
}*/
.form_type {
  float: right;
}
.form_type img {
  height: 45px;
}
.form_type img:not(:last-of-type) {
  margin-right: -3px;
}
.form_intro h1 {
  display: inline-block;
  width: 100%;
  /*border-bottom: 1px solid #eee;*/
  margin-top: 0;
  line-height: 100%;
}
.form_intro h1 .form_name {
  display: none;
  white-space: inherit;
  width: auto;
  vertical-align: baseline;
  margin-right: 10px;
}
.form_intro h1 .form_title {
  /*display: block;
        line-height: 110%;
        font-size: .6em;

        padding: 3px 0 5px 0;*/
  font-size: 0.9em;
  display: inline-block;
}
.form_intro h1 .form_year {
  display: inline-block;
  line-height: 110%;
  font-size: 0.7em;
  padding: 3px 0 5px 0;
}
/* ------------------------
 EDIT FORM
------------------------ */
#validationStatus img {
  height: 20px;
  display: inline-block;
}
#assessmentCode {
  display: inline-block;
}
/* ------------------------
 ADDRESS BOOK
------------------------ */
#addressBookAccordion .panel-heading {
  display: table;
  width: 100%;
}
#addressBookAccordion .panel-heading .panel_heading_group_name {
  font-size: 14px;
}
#addressBookAccordion .panel-heading .group_totals {
  float: right;
}
#addressBookAccordion .panel-heading .group_totals .group_individuals_total {
  display: block;
  text-align: right;
  float: right;
  width: 50px;
}
#addressBookAccordion .panel-heading .group_totals .group_groups_total {
  padding-left: 0;
  display: block;
  text-align: right;
  width: 70px;
}
#addressBookAccordion .panel-heading .group_totals .total_number {
  width: 20px;
  display: inline-block;
}
#addressBookAccordion .panel-heading .group_totals img {
  height: 19px;
  display: inline-block;
}
/* ------------------------
 FORM DIRECTORY
------------------------ */
#directorySearchDiv {
  display: block;
  margin-bottom: 10px;
}
#directorySortDiv {
  text-align: right;
  margin-top: 15px;
}
.directory-deselect {
  white-space: nowrap;
}
.panel-group {
  margin-top: 15px;
}
.panel {
  border-radius: 0;
}
/*.panel:last-of-type {
    border-bottom: 1px solid #999999;
}*/
.panel-group .panel + .panel {
  margin-top: 0;
}
.accordion > .card:first-of-type:last-of-type {
  border-radius: 0.25rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.panel-default {
  margin-bottom: 0;
}
.panel-default a {
  text-decoration: none !important;
}
.panel-default .panel-heading {
  border-top: 1px solid #999999;
  border-bottom: none;
  border-radius: 0;
  background: #fff;
  font-size: 1.1em;
  color: #444;
  width: 100%;
  display: table;
}
.panel-default .panel-heading strong {
  /*color: @button-color;*/
}
.panel-default .card-body hr {
  border-color: #ddd;
}
.panel-default .card-body h5 {
  margin-top: 0;
}
.panel-default .card-body .help-block {
  color: #666666;
}
.panel-group .panel-heading + .panel-collapse > .card-body,
.panel-group .panel-heading + .panel-collapse > .list-group {
  border: none;
}
.pills li {
  margin-right: 3px;
}
.pills li a {
  font-size: 0.85em;
  font-weight: 500;
  letter-spacing: -0.25pt;
  border-radius: 15px;
  border: 1px solid #6c757d;
  padding: 2px 6px;
  text-decoration: none !important;
  color: #6c757d;
  display: block;
  margin-bottom: 4px;
  -webkit-transition: 0.1s ease-in-out;
  -moz-transition: 0.1s ease-in-out;
  -o-transition: 0.1s ease-in-out;
  transition: 0.1s ease-in-out;
}
.pills li a.disabled {
  border-color: #999;
  background: #ddd;
  color: #999;
}
#tags {
  display: inline;
}
.pills li a:hover {
  background: #eeeeee;
  border-color: #466db2;
  text-decoration: none;
}
.pills li.active a {
  background: #466db2;
  border-color: transparent;
  text-decoration: none;
  color: #fff !important;
}
.pills li.active .filter_linked {
  background: #1496b6;
}
.pills li.active .filter_web {
  background: #234d7f;
}
.pills li.active .filter_pdf {
  background: #d6504f;
}
.pills li.active .filter_contact {
  background: #2ab95c;
}
.pills li.active .filter_content {
  background: #eaa030;
}
.pills {
  list-style-type: none;
  padding: 0;
  padding-top: 2px;
  margin-bottom: 5px;
}
.pills li {
  display: inline-block;
}
.pills li .filter_linked {
  border-color: #1496b6;
  color: #1496b6;
}
.pills li .filter_linked:hover {
  background: #1496b6;
}
.pills li .filter_web {
  border-color: #234d7f;
  color: #234d7f;
}
.pills li .filter_web:hover {
  background: #234d7f;
}
.pills li .filter_pdf {
  border-color: #d6504f;
  color: #d6504f;
}
.pills li .filter_pdf:hover {
  background: #d6504f;
}
.pills li .filter_contact {
  border-color: #2ab95c;
  color: #2ab95c;
}
.pills li .filter_contact:hover {
  background: #2ab95c;
}
.pills li .filter_content {
  border-color: #eaa030;
  color: #eaa030;
}
.pills li .filter_content:hover {
  background: #eaa030;
}
.related_forms_list {
  padding-left: 5px;
}
.related_forms_list li {
  list-style-position: inside;
}
.display_tags_keys {
  padding: 0;
}
.display_tags_keys li {
  display: inline;
  list-style-type: none;
}
.display_tags_keys li:not(:last-of-type):after {
  content: ", ";
}
.directory_create_buttons {
  text-align: right;
}
.admin_directory_sort_buttons {
  text-align: right;
  float: right;
}
/*#endregion*/
/* ------------------------
 WIDGETS
------------------------ */
.code-card {
  margin-bottom: 30px;
}
.widget-link {
  margin-left: 5px;
}
/* ------------------------
 MEDIA QUERIES
------------------------ */
@media (min-width: 576px) {
  .df-navigation-btn-container .btn {
    width: auto;
  }
}
@media (max-width: 767px) {
  .no-bg {
    margin-bottom: 240px;
  }
  #footfloat {
    position: relative;
    float: none;
    bottom: 15px;
    text-align: center;
    margin: 0;
    margin-top: 15px;
  }
  #footer #footfloat a {
    padding: 0;
  }
  .search .input-group {
    width: 100%;
  }
  .dashboard_btn {
    text-align: left;
  }
  #directorySearchDiv {
    width: 100%;
    margin-top: 5px;
  }
  #directorySortDiv,
  .directory_create_buttons {
    text-align: center;
  }
  .gq_bottom_container {
    bottom: 280px;
  }
  .form_type img {
    margin-right: 0;
    margin-top: -10px;
    height: 35px;
  }
  .form_intro .btn:not(:last-of-type) {
    margin-right: 0;
  }
  #todaysDate {
    margin-top: 0;
  }
  #groupEditorModal .inline_input {
    width: 80%;
  }
  #feedback {
    list-style-position: inside;
  }
  .search_tips_image {
    width: 200px;
    float: none;
    margin: auto;
    margin-bottom: 10px;
    text-align: center;
  }
  .search_tips_image img {
    box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.4);
  }
  .admin_directory_nav_tabs {
    display: inline-block;
    width: 100%;
  }
  .admin_directory_sort_buttons {
    text-align: center;
    float: none;
  }
  #welcomeDiv hr {
    margin: 10px -5px 20px -5px;
  }
  #welcomeDiv img {
    width: 125px;
  }
  .DFPageContent.row {
    margin-left: 15px;
    margin-right: 15px;
  }
  .navigation_placeholder {
    height: auto;
    padding: 10px;
  }
  .index-row {
    margin: 0;
  }
  .row.DFPageContent {
    padding: 0;
  }
  .admin-icon {
    font-size: 90px;
  }
  .inline_remove_btn {
    padding-left: 15px;
  }
  .has-form-comments .submissions-left-col {
    border-bottom: 1px solid #dddddd;
    padding-bottom: 15px;
    margin-bottom: 15px;
  }
  .submissions-left-col {
    min-height: 0 !important;
    padding: 5px 15px;
  }
  .submissions-right-col {
    min-height: 0 !important;
    padding: 5px;
  }
}
/* Small devices (tablets, 768px and up) */
@media (min-width: 768px) {
  #addressBookAccordion .panel-heading {
    display: table;
    width: 100%;
  }
  #addressBookAccordion .panel-heading .panel_heading_group_name {
    font-size: 18px;
  }
  #addressBookAccordion .panel-heading .group_totals {
    display: table;
  }
  #addressBookAccordion .panel-heading .group_totals .group_individuals_total {
    display: table-cell;
    text-align: left;
    width: 41px;
    float: none;
  }
  #addressBookAccordion .panel-heading .group_totals .group_groups_total {
    padding-left: 10px;
    display: table-cell;
    text-align: left;
    width: 55px;
  }
  #addressBookAccordion .panel-heading .group_totals .total_number {
    width: 20px;
    display: inline-block;
  }
  #addressBookAccordion .panel-heading .group_totals img {
    height: 20px;
    display: inline-block;
  }
  #welcomeDiv {
    height: 567px;
  }
  .df-public-nav .navbar-collapse.collapse {
    display: block !important;
    height: auto !important;
    padding-bottom: 0;
    overflow: visible !important;
  }
  .df-public-nav .navbar-header {
    display: none;
  }
  .admin-card {
    min-height: 318px;
  }
  .submissions-left-col {
    width: 325px;
    padding: 15px;
    overflow: auto;
    border-right: 1px solid #cccccc;
  }
  .submissions-right-col {
    padding: 15px;
  }
  .submissions-left-col,
  .submissions-right-col {
    min-height: calc(100vh - 70px);
    overflow-y: auto;
  }
  .submissions-table-wrapper {
    width: 100%;
    height: calc(100vh - 80px - 70px);
    overflow-y: auto;
  }
  .directory-container {
    min-height: calc(100vh - 70px);
    padding: 15px;
  }
}
/* Medium devices (desktops, 992px and up) */
@media (min-width: 992px) {
  #formDirectoryTile,
  #formDirectoryBtn {
    font-size: 1.3em;
  }
  #welcomeDiv {
    height: 565px;
  }
  .admin-card {
    min-height: 280px;
  }
}
/* Large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  #formDirectoryTile,
  #formDirectoryBtn {
    font-size: 1.5em;
  }
  #welcomeDiv {
    height: 562px;
  }
}
.DFPageContentWrapper table tr th {
  border-bottom: 2px solid #ddd;
}
.navigation_placeholder,
.button_placeholder {
  font-size: 15px !important;
}
.select_element_page_children .btn > span {
  display: inline-block;
}
.only_print {
  display: none;
}
@media print {
  .only_print {
    display: block !important;
  }
  .voucher_section {
    border: 2px dashed #ddd;
    padding: 30px;
  }
}
/*DF form wrapper container css*/
@media (max-width: 767px) {
  .df-public-nav .list-group-item {
    padding: 7.5px 7.5px 7.5px 30px;
    -webkit-transition: all ease 0.25s;
    transition: all ease 0.25s;
  }
  .df-public-nav .list-group-item.active .icon {
    display: block;
    float: right;
    font-size: 0.9em;
    margin-top: 3px;
    margin-right: -5px;
  }
  .df-public-nav .list-group-item:not(.active) {
    height: auto;
    /*padding: 7.5px 7.5px 7.5px 30px;*/
  }
  .df-public-nav.df-collapsed .list-group-item {
    border-radius: 0;
  }
  .df-public-nav.df-collapsed .list-group-item:not(.active) {
    height: 0;
    padding: 0;
    border-width: 0;
    overflow: hidden;
    visibility: hidden;
  }
}
@media (min-width: 768px) {
  .DFPageContent {
    width: 750px;
  }
}
@media (max-width: 991px) {
  .img-responsive {
    /* account for large homepage images to be responsive on mobile devices */
    max-width: 100%;
    height: auto !important;
  }
}
@media (min-width: 992px) {
  .DFPageContent {
    width: 970px;
  }
}
@media (min-width: 1200px) {
  .DFPageContent {
    width: 1170px;
  }
}
.DFPageContent {
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;
}
.admin-card {
  margin-top: 20px;
}
/* TENANT */
.tenant-fieldset {
  border: 1px solid #ddd;
  padding: 0 15px;
}
.tenant-fieldset legend {
  font-weight: 500;
}
.tree-layout {
  padding-left: 0;
}
.tree-layout ul {
  padding-left: 30px;
}
.tree-layout li {
  list-style-type: none;
  border-left: 1px dashed #666666;
}
.tree-layout li:before {
  border-bottom: 1px dashed #666666;
  display: inline-block;
  height: 20px;
  width: 10px;
  margin-top: -2px;
  margin-bottom: 2px;
  content: "";
}
.tree-layout li:last-child:before {
  border-left: 1px dashed #666666;
}
.tree-layout li:last-child > ul,
.tree-layout li:last-child {
  border-left: none !important;
}
.tree-layout > li {
  margin-bottom: 10px;
  list-style-type: none;
  border-left: none !important;
}
.tree-layout > li:before {
  display: none;
}
.tree-layout [data-toggle="popover"] {
  vertical-align: middle;
}
.tree-layout a {
  font-size: 0.9em;
}
body.no-footer {
  padding-bottom: 0;
}
body.no-footer #public-footer-wrapper {
  display: none;
}
body.no-footer .body-content {
  padding: 0;
}
.pills li a:disabled {
  border-color: #ccc;
}
/* I don't understand why these are required */
.node_body,
.node_addon {
  display: inline-block;
}
.node_body {
  padding-bottom: 0;
  padding-top: 0;
  line-height: 32px;
  position: relative;
  top: -5px;
}
.gq_node {
  height: 32px;
}
.pages-admin-content {
  width: calc(100% - 300px);
  margin-left: 300px;
  padding: 15px;
}
.pages-left-nav-sec {
  height: calc(100vh - 70px);
  width: 300px;
  position: fixed;
  background-color: #f5f6f7;
  padding: 15px;
  overflow-x: auto;
  overflow-y: auto;
  white-space: nowrap;
}
.pages-left-nav-sec [class^="icon-"]:before,
.pages-left-nav-sec [class*=" icon-"]:before {
  font-size: inherit;
}
.pages-left-nav-sec .nav-link {
  font-size: 0.9em;
}
.passthrough {
  background: none;
  color: inherit;
  padding: 0;
  border: none;
  text-align: left;
  line-height: 100%;
  -webkit-appearance: none;
}
.passthrough + .passthrough {
  margin-left: 4px;
}
.tenantList .area-label.selected {
  text-decoration: none;
  font-weight: bold;
  color: #234d7f;
}
.tenantList .nav-item .passthrough {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}
.tenantList .nav-item .passthrough.icon-home:before,
.tenantList .nav-item .passthrough.icon-folder:before,
.tenantList .nav-item .passthrough .icon-home:before,
.tenantList .nav-item .passthrough .icon-folder:before,
.tenantList .nav-item .passthrough .icon-sites:before {
  margin-right: 5px;
  vertical-align: top;
}
.tenantList .current-area,
.tenantList .area-top-list,
.tenantList .add-new-area,
.tenantList .icon-sites,
.tenantList .icon-folder {
  display: none;
}
.tenantList .area-child-list {
  display: block;
  margin: 0;
}
.tenantList .area-child-list .area-list {
  margin: 0 0 15px 5px;
  padding-left: 10px;
  border-left: 2px solid #cccccc;
}
.tenantList .area-child-list .area-list .add-new-area {
  display: block;
  color: #6c757d;
}
.tenantList .area-child-list .area-list .add-new-area .plus-sign {
  color: #1e7e34;
  font-weight: bold;
}
.tenantList .area-child-list .area-list .area-child-list {
  margin-left: 15px;
}
.tenantList .area-child-list .area-list .area-list,
.tenantList .area-child-list .area-list .icon-sites {
  display: none;
}
.tenantList .area-child-list .area-list .icon-home,
.tenantList .area-child-list .area-list .icon-folder {
  display: inline-block;
}
.tenantList .area-child-list .area-label {
  border: none;
}
.tenantList .area-child-list .current-area,
.tenantList .area-child-list .area-top-list {
  display: block;
}
.tenantList .area-child-list .icon-sites {
  display: inline;
}
`, "",{"version":3,"sources":["webpack://./styles/DFStyle_Site_Template.less","webpack://./styles/SiteIndex.less","webpack://./styles/Site.less"],"names":[],"mappings":"AAAA,6DAA6D;ACA7D;EACI,kBAAA;EACA,gBAAA;EACA,2JAAA;EAIA,4DAAA;ADDJ;AACA,kDAAkD;ACMlD;EACI,kBAAA;EACA,iBAAA;ADJJ;ACOA;EACI,aAAA;ADLJ;ACQA;EACI,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;ADNJ;ACSA;EACI,WAAA;EACA,kBAAA;ADPJ;ACUA;EACI,cAAA;ADRJ;ACWA;EACI,eAAA;EACA,cAAA;ADTJ;ACYA;EACI,WAAA;ADVJ;ACaA;EACI,cAAA;EACA,WAAA;ADXJ;ACcA;;;EAGI,gBAAA;EACA,gBAAA;ADZJ;ACeA;EACI,iBAAA;ADbJ;ACgBA;EACI,kBAAA;ADdJ;ACiBA;EACI,kBAAA;ADfJ;ACkBA;EACI,iBAAA;ADhBJ;ACmBA;EACI,kBAAA;ADjBJ;ACoBA;EACI,eAAA;ADlBJ;ACqBA;EACI,YAAA;ADnBJ;ACsBA;EACI,iBAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;ADpBJ;ACuBA;EACI,mBAAA;ADrBJ;ACwBA;;EACI,mBAAA;EACA,kBAAA;EACA,aAAA;ADrBJ;ACwBA;;EAEI,eAAA;ADtBJ;ACyBA;;EAEI,qBAAA;EACA,4BAAA;ADvBJ;AC0BA;EACI,iBAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;ADxBJ;ACoBA;EAOQ,eAAA;ADxBR;AC4BA;EACI,0BAAA;AD1BJ;AC6BA;EACI,aAAA;AD3BJ;AC8BA;;EAEI,mBAAA;AD5BJ;AC+BA;EACI,0BAAA;AD7BJ;ACgCA;EAEQ,UAAA;AD/BR;ACoCI;EACI,cAAA;ADlCR;ACsCA;EACI,gBAAA;ADpCJ;ACyCA;;;EAIQ,mBAAA;EACA,qBAAA;ADxCR;ACmCA;EASQ,aAAA;ADzCR;ACgCA;;EAcQ,iBAAA;EACA,iCAAA;EACA,iBAAA;AD1CR;AC4CQ;;EACI,oBAAA;ADzCZ;ACsBA;EAyBY,sBAAA;AD5CZ;ACmDoB;;EACI,UAAA;ADhDxB;ACsDQ;EAIQ,qBAAA;EACA,iBAAA;EACA,cAAA;ADvDhB;ACiDQ;EASQ,iBAAA;EACA,iBAAA;ADvDhB;AC6CQ;EAIQ,qBAAA;EACA,iBAAA;EACA,cAAA;AD9ChB;ACsDgB;EALA,iBAAA;EACA,iBAAA;AD9ChB;AC0DoB;;;;EAlBJ,qBAAA;EACA,iBAAA;EACA,cAAA;ADlChB;AC0CgB;;;;EALA,iBAAA;EACA,iBAAA;AD/BhB;AC+CoB;;;;EAtBJ,qBAAA;EACA,iBAAA;EACA,cAAA;ADnBhB;AC2BgB;;;;EALA,iBAAA;EACA,iBAAA;ADhBhB;ACoC4B;;;;EACI,0BAAA;EACA,iBAAA;EACA,aAAA;EACA,UAAA;AD/BhC;ACkCwB;;;;EACI,oBAAA;AD7B5B;AC+BwB;;;;EACI,qBAAA;AD1B5B;ACiCoB;;EA5CJ,qBAAA;EACA,iBAAA;EACA,cAAA;ADehB;AC+BoB;EA3CJ,iBAAA;EACA,iBAAA;ADehB;ACkCoB;;EAvDJ,qBAAA;EACA,iBAAA;EACA,cAAA;EAwDQ,iBAAA;AD9BxB;AClBgB;;EALA,iBAAA;EACA,iBAAA;AD2BhB;AC2BoB;EACI,mBAAA;ADzBxB;ACwBoB;EAGQ,eAAA;ADxB5B;ACqBoB;EAMQ,mBAAA;EACA,qBAAA;EACA,sBAAA;ADxB5B;AC6CA;;;EAGI,mBAAA;EACA,gBAAA;AD3CJ;AC8CA;EACI,eAAA;EACA,UAAA;EACA,4BAAA;AD5CJ;AC+CA;EACI,aAAA;AD7CJ;ACgDA;EACI,UAAA;EACA,SAAA;EACA,gBAAA;ED9CF,mDAAmD;EC+CjD,WAAA;AD7CJ;ACgDA;EACI,YAAA;EACA,aAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;AD9CJ;ACuCA;EAUQ,YAAA;AD9CR;ACkDA;EACI,SAAA;ADhDJ;ACmDA;EACI,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,0CAAA;EACA,cAAA;ADjDJ;ACoDA;EACI,gBAAA;ADlDJ;ACqDA;EACI,aAAA;ADnDJ;ACsDA;EACI,YAAA;EACA,iBAAA;EACA,gBAAA;ADpDJ;AACA;;2BAE2B;ACuD3B;EACI,cAAA;EACA,MAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;ADrDJ;ACwDA;EACI,yBAAA;EDtDF,oBAAoB;ECwDlB,gBAAA;EACA,mBAAA;ADtDJ;ACyDA;EACI,eAAA;EACA,gBAAA;ADvDJ;ACqDA;EAKQ,+BAAA;EACA,eAAA;ADvDR;ACyDQ;;EAEI,cAAA;ADvDZ;AC6CA;EAeQ,mBAAA;ADzDR;AC0CA;;EAoBQ,qBAAA;AD1DR;AC8DA;EACI,cAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;AD5DJ;AC+DA;;EAEI,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;AD7DJ;ACgEA;EACI,WAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;ED9DF,6BAA6B;AAC/B;ACiEA;EACI,mBAAA;AD/DJ;AC8DA;EAGQ,gBAAA;AD9DR;AC2DA;;;;EAUQ,sBAAA;EACA,qBAAA;AD/DR;ACmEA;EACI,YAAA;EACA,UAAA;EACA,SAAA;ADjEJ;ACoEA;EACI,gBAAA;EACA,gBAAA;ADlEJ;ACqEA;EACI,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;ADnEJ;ACsEA;;;;;;;;;EASI,WAAA;EACA,mBAAA;EACA,yBAAA;ADpEJ;ACuEA;;EAEI,mBAAA;ADrEJ;ACwEA;EACI,UAAA;EDtEF,wBAAwB;AAC1B;ACoEA;EAGQ,YAAA;EACA,eAAA;ADpER;ACgEA;EAQQ,eAAA;EACA,gBAAA;ADrER;AC4DA;EAWY,YAAA;ADpEZ;ACyDA;;EAkBQ,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;ADvER;ACiDA;EA0BQ,iBAAA;EACA,WAAA;ADxER;AC6CA;EA+BQ,WAAA;ADzER;AC6EA;EACI,gBAAA;EACA,qBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;AD3EJ;AC8EA;EACI,2FAAA;EACA,qBAAA;EACA,kBAAA;AD5EJ;AC+EA;EACI,yBAAA;AD7EJ;ACgFA;;ED7EE,iBAAiB;EC+Ef,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,cAAA;AD7EJ;ACmEA;EAYQ,eAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;AD5ER;AC2DA;EAmBY,YAAA;AD3EZ;ACwDA;EAwBQ,YAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;AD7ER;ACgDA;EAgCgB,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,qBAAA;AD7EhB;ACyCA;EAwCgB,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;AD9EhB;AC+BA;EAmDgB,qBAAA;EACA,wBAAA;AD/EhB;ACqFA;EACI,kBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,6CAAA;EACA,cAAA;ADnFJ;ACsEA;EAeQ,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;ADlFR;AC8DA;EAwBQ,kBAAA;EACA,QAAA;EACA,WAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EDnFN,oBAAoB;AACtB;ACqDA;EAkCQ,gBAAA;EACA,sBAAA;EDpFN,mBAAmB;ECsFb,gBAAA;ADpFR;AC+CA;EAyCQ,iBAAA;ADrFR;ACyFA;EACI,YAAA;EACA,iBAAA;ADvFJ;AC0FA;EACI,UAAA;EACA,mBAAA;ADxFJ;AC2FA;EACI,cAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;ADzFJ;AC4FA;EACI,YAAA;EACA,yBAAA;EACA,SAAA;EACA,aAAA;AD1FJ;AC6FA;EACI,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;AD3FJ;AC8FA;EACI,iBAAA;AD5FJ;AC+FA;EACI,eAAA;EACA,iBAAA;AD7FJ;ACgGA;EACI,gBAAA;AD9FJ;ACiGA;EACI,cAAA;AD/FJ;ACkGA;EACI,UAAA;ADhGJ;ACmGA;EAEQ,aAAA;ADlGR;ACsGA;EACI,WAAA;EACA,YAAA;ADpGJ;ACuGA;EACI,gBAAA;ADrGJ;ACwGA;EAEQ,cAAA;EACA,uBAAA;ADvGR;ACoGA;EAMQ,gBAAA;ADvGR;ACiGA;;EAUQ,iBAAA;ADvGR;AC2GA;EACI,cAAA;ADzGJ;AC6GI;;EAEI,6CAAA;AD3GR;AC+GA;EACI,gBAAA;AD7GJ;ACgHA;EACI,aAAA;AD9GJ;ACwHI;EACI,mBAAA;EACA,WAAA;EACA,yBAAA;ADtHR;ACwHQ;EACI,mBAAA;EACA,qBAAA;EACA,WAAA;ADtHZ;ACyHQ;EAhBA,0BAAA;EACA,mBAAA;EACA,iBAAA;ADtGR;ACwHQ;EACI,8BAAA;EACA,sBAAA;EACA,qBAAA;ADtHZ;AC2HQ;EACI,mBAAA;EACA,qBAAA;ADzHZ;AC4HQ;EACI,mBAAA;EACA,WAAA;EAnCJ,0BAAA;EACA,mBAAA;EACA,iBAAA;ADtFR;AC6HQ;EACI,mBAAA;EACA,cAAA;EA3CJ,0BAAA;EACA,mBAAA;EACA,iBAAA;AD/ER;AC8HQ;EACI,mBAAA;EACA,cAAA;EAnDJ,0BAAA;EACA,mBAAA;EACA,iBAAA;ADxER;AC+HQ;EACI,mBAAA;EACA,cAAA;EA3DJ,0BAAA;EACA,mBAAA;EACA,iBAAA;ADjER;ACgIQ;EAjEA,sCAAA;EACA,mBAAA;EACA,iBAAA;AD5DR;ACiIA;EACI,cAAA;EACA,WAAA;AD/HJ;ACkIA;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wCAAA;EACA,qCAAA;EACA,mCAAA;EACA,gCAAA;ADhIJ;ACmIA;EACI,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EDjIF;yBACuB;AACzB;AC0HA;;;EAYQ,cAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,UAAA;ADjIR;ACmIQ;;;EACI,cAAA;AD/HZ;ACmII;EACI,qBAAA;ADjIR;ACyGA;EA4BQ,cAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;ADlIR;ACoIQ;EACI,UAAA;ADlIZ;ACgGA;;EAwCQ,WAAA;EACA,aAAA;ADpIR;ACwIA;EAEQ,6BAAA;EACA,aAAA;ADvIR;ACoIA;EAOQ,0BAAA;ADxIR;AC4IA;EACI,sBAAA;ED1IF;;MAEI;AACN;ACyIQ;EACI,kBAAA;ADvIZ;ACmIA;EASQ,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;ADzIR;AC6HA;;;;EAmBQ,cAAA;EACA,kBAAA;AD1IR;AACA;;;;;EAKE;ACkJF;EACI,iBAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;ADhJJ;ACmJA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EDjJF,qBAAqB;AACvB;ACoJA;EDlJE,kDAAkD;ECoJhD,gBAAA;EACA,sBAAA;ADlJJ;ACqJA;EACI,kBAAA;EACA,mBAAA;ADnJJ;ACiJA;EAKQ,kBAAA;ADnJR;ACsJA;EAEQ,UAAA;ADrJR;AACA;;0BAE0B;AC0J1B;EACI,aAAA;EACA,OAAA;EACA,8BAAA;ADxJJ;AC2JA;EAEQ,cAAA;EACA,WAAA;EACA,kBAAA;AD1JR;AC8JA;EACI,cAAA;EACA,cAAA;EACA,2BAAA;EACA,mBAAA;EACA,0BAAA;AD5JJ;ACuJA;;EASQ,mBAAA;AD5JR;ACmJA;EAaQ,4BAAA;AD7JR;ACgJA;EAiBgB,2BAAA;AD9JhB;AC6IA;EAuBQ,gBAAA;ADjKR;AC0IA;EA2BQ,cAAA;EACA,YAAA;EACA,gBAAA;ADlKR;ACqIA;EAiCQ,gBAAA;EACA,UAAA;ADnKR;ACiIA;EAqCY,kBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,6BAAA;ADnKZ;AC0HA;EA4CgB,YAAA;EACA,cAAA;ADnKhB;ACyKA;EACI,gBAAA;EACA,mBAAA;ADvKJ;AC0KA;EACI,eAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;ADxKJ;AC2KA;EACI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;ADzKJ;AC0KI;EACI,mBAAA;ADxKR;AC0KI;EACI,mBAAA;ADxKR;AC0KI;EACI,mBAAA;ADxKR;AC0KI;EACI,mBAAA;ADxKR;AC4KA;EACI,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qIAAA;AD1KJ;ACiLA;EACI,WAAA;EACA,yBAAA;AD/KJ;ACkLA;EACI,yBAAA;ADhLJ;ACmLA;EACI,eAAA;ADjLJ;ACoLA;EACI,YAAA;EACA,oCAAA;ADlLJ;ACqLA;;;EAGI,gCAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,uCAAA;ADnLJ;AACA;;;;;;;;;;;;;;;;EAgBE;ACuLF;EACI,mBAAA;ADrLJ;ACwLA;;EAEI,cAAA;EACA,eAAA;EACA,6BAAA;ADtLJ;ACyLA;EACI,iBAAA;EACA,cAAA;ADvLJ;AC0LA;EACI,kBAAA;ADxLJ;AC2LA;EACI,mBAAA;ADzLJ;AC4LA;;EAGQ,YAAA;EACA,iBAAA;AD3LR;ACkMA;;;EAGI,WAAA;EACA,uBAAA;ADhMJ;ACmMA;EACI,yBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;ADjMJ;ACoMA;EACI,WAAA;EDlMF,6BAA6B;AAC/B;ACqMA;;;EAGI,yBAAA;ADnMJ;ACsMA;EACI,cAAA;EACA,eAAA;ADpMJ;AACA,+NAA+N;AAC/N;;0BAE0B;ACyM1B;EACI,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;ADvMJ;AC0MA;;;EAGI,qBAAA;EACA,YAAA;ADxMJ;AC2MA;EACI,mBAAA;EACA,+BAAA;EACA,WAAA;ADzMJ;ACsMA;EAMQ,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,6BAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;ADzMR;AC2LA;EAiBY,aAAA;EACA,qBAAA;EACA,cAAA;ADzMZ;ACsLA;EAsBgB,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;ADzMhB;ACgLA;EA8BY,cAAA;AD3MZ;AC6KA;EAkCY,eAAA;AD5MZ;AC0KA;EAsCY,gBAAA;EACA,cAAA;AD7MZ;ACsKA;EA4CQ,iBAAA;EACA,gBAAA;EACA,YAAA;AD/MR;ACmNA;EACI,YAAA;EACA,gBAAA;ADjNJ;ACoNA;EACI,YAAA;EACA,iBAAA;ADlNJ;ACqNA;EACI,aAAA;ADnNJ;ACsNA;EAEI,8BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;ADrNJ;ACwNA;EACI,aAAA;EACA,iBAAA;EACA,eAAA;ADtNJ;ACyNA;EACI,gBAAA;EACA,mBAAA;ADvNJ;AC0NA;EACI,cAAA;ADxNJ;AC+NA;EACI;IACI,iBAAA;IACA,sBAAA;IACA,4BAAA;ED7NN;ECgOE;IACI,aAAA;IACA,cAAA;ED9NN;ECiOE;IAEQ,aAAA;EDhOV;ECoOE;IACI,gBAAA;EDlON;ECqOE;IACI,gBAAA;IACA,gBAAA;EDnON;ECsOE;IDpOA,qBAAqB;ICsOjB,gBAAA;EDpON;ECsOE;IACI,gBAAA;IACA,kBAAA;IACA,YAAA;IDpOJ,oBAAoB;ICsOhB,eAAA;IACA,cAAA;EDpON;EC8NE;IASQ,cAAA;IACA,UAAA;EDpOV;EC0NE;IAaY,cAAA;IACA,cAAA;IACA,eAAA;EDpOd;ECqNE;;IDlNA,8BAA8B;ICsOd,WAAA;IAEA,iBAAA;IACA,sBAAA;IACA,YAAA;IACA,cAAA;IACA,kBAAA;IDrOhB,eAAe;ICuOC,iBAAA;IACA,oBAAA;EDrOlB;ECwME;;IAkCgB,2BAAA;IACA,0BAAA;IACA,cAAA;EDtOlB;ECkME;IAyCY,mBAAA;EDxOd;EC6OE;IACI,YAAA;IACA,iBAAA;IACA,kBAAA;ED3ON;EC8OE;IACI,eAAA;ED5ON;EC+OE;IACI,gCAAA;ED7ON;ECgPE;IACI,kCAAA;IACA,sBAAA;IACA,iBAAA;ED9ON;EACA;;;;MAII;ECkPF;IACI,WAAA;EDhPN;ECmPE;IACI,gCAAA;IACA,wBAAA;IACA,2BAAA;IACA,0BAAA;EDjPN;ECoPE;IACI,iBAAA;EDlPN;ECiPE;;;IAMQ,YAAA;IACA,cAAA;IACA,YAAA;IACA,eAAA;EDlPV;ECyOE;;;IAYY,cAAA;IACA,eAAA;EDhPd;ECmOE;IAkBQ,kBAAA;IACA,cAAA;EDlPV;EC+NE;IAsBY,YAAA;EDlPd;EC4NE;IA0BY,gBAAA;EDnPd;ECyNE;IA6BgB,YAAA;EDnPlB;ECsNE;;;IAqCQ,mBAAA;IACA,YAAA;IACA,gBAAA;IACA,uCAAA;IDtPR;;;cAGU;EACZ;EC0PE;;IACI,iBAAA;IACA,aAAA;EDvPN;ECqPE;IAKQ,gBAAA;IACA,SAAA;IACA,WAAA;EDvPV;ECgPE;IASY,YAAA;EDtPd;EC6OE;IAcQ,gBAAA;IACA,gBAAA;IACA,WAAA;EDxPV;ECgQE;IACI,aAAA;ED9PN;ECiQE;IACI,sBAAA;ED/PN;ECkQE;IACI,cAAA;IACA,mBAAA;EDhQN;ECmQE;IACI,cAAA;EDjQN;ECoQE;IAEQ,gBAAA;EDnQV;ECuQE;IACI,YAAA;IACA,kBAAA;EDrQN;ECwQE;IACI,kBAAA;IACA,wBAAA;IACA,cAAA;IACA,+BAAA;IDtQJ;;;;;wBAKoB;EACtB;EC4PE;IAYQ,aAAA;IACA,kBAAA;IACA,YAAA;IACA,WAAA;EDrQV;ECsPE;IAmBQ,kBAAA;IACA,QAAA;IACA,WAAA;IACA,qBAAA;IACA,cAAA;IACA,eAAA;EDtQV;EC8OE;IA4BQ,gBAAA;IACA,sBAAA;IACA,eAAA;EDvQV;ECyOE;IAkCQ,iBAAA;EDxQV;AACF;AC4QA;EACI;;;;IAII,eAAA;ED1QN;EC4QE;IACI,YAAA;ED1QN;ECyQE;IAGQ,oBAAA;EDzQV;EC4QE;IACI,UAAA;ED1QN;EC6QE;IACI,aAAA;ED3QN;EC8QE;IACI,SAAA;ED5QN;EC8QE;IACI,YAAA;ED5QN;EC+QE;IACI,eAAA;ED7QN;EC+QE;IACI,WAAA;ED7QN;ECgRE;IACI,aAAA;ED9QN;ECiRE;IACI,kBAAA;ED/QN;ECkRE;IACI,wCAAA;EDhRN;AACF;ACmRA;EACI;IDjRA,yEAAyE;ICmRrE,eAAA;IACA,uBAAA;EDjRN;AACF;AACA,4CAA4C;ACoR5C;EACI;IACI,eAAA;EDlRN;ECoRE;IACI,mBAAA;IACA,8BAAA;EDlRN;ECgRE;IAKQ,OAAA;EDlRV;EC6QE;IASQ,eAAA;IACA,gBAAA;IACA,4BAAA;IACA,cAAA;EDnRV;ECsRE;IACI,8BAAA;EDpRN;AACF;ACuRA;EACI;IACI,+BAAA;EDrRN;AACF;ACwRA;EACI;;;IAGI,wBAAA;EDtRN;AACF;AE90CA;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;AFg1CJ;AE70CA;EACI,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AF+0CJ;AACA;;CAEC;AE50CD;EACI,mBAAA;AF80CJ;AACA;;0BAE0B;AE10C1B;EACI,aAAA;AF40CJ;AEz0CA;EACI,mBAAA;AF20CJ;AEx0CA;EACI,gBAAA;AF00CJ;AEv0CA;;EAEI,gBAAA;AFy0CJ;AEt0CA;EACI,qBAAA;AFw0CJ;AEr0CA;EACI,kBAAA;AFu0CJ;AEp0CA;EACI,gBAAA;AFs0CJ;AEn0CA;EACI,WAAA;AFq0CJ;AEl0CA;EACI,gBAAA;AFo0CJ;AEj0CA;EACI,gBAAA;AFm0CJ;AEh0CA;EACI,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AFk0CJ;AEv0CA;;EASQ,gBAAA;AFk0CR;AE9zCA;EACI,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;AFg0CJ;AE7zCA;EACI,cAAA;EACA,cAAA;AF+zCJ;AE5zCA;EACI,WAAA;AF8zCJ;AE3zCA;EACI,cAAA;AF6zCJ;AE1zCA;EACI,cAAA;AF4zCJ;AEzzCA;EF2zCE,iBAAiB;EACjB,uBAAuB;EACvB,iCAAiC;AACnC;AExzCA;EACI,aAAA;AF0zCJ;AEvzCA;EACI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EFyzCF,uBAAuB;AACzB;AEzzCI;EACI,mBAAA;EACA,qBAAA;AF2zCR;AEvzCA;;EAEI,mCAAA;EACA,qBAAA;AFyzCJ;AEtzCA;;EAEI,WAAA;EACA,iBAAA;AFwzCJ;AEtzCA;;EAEI,SAAA;EACA,iBAAA;AFwzCJ;AEtzCA;;EAEI,cAAA;AFwzCJ;AEtzCA;;EAEI,cAAA;AFwzCJ;AErzCA;EACI,sBAAA;EACA,cAAA;AFuzCJ;AEpzCA;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,mBAAA;AFszCJ;AEpzCA;EACI,cAAA;AFszCJ;AEnzCA;EACI,WAAA;AFqzCJ;AEjzCI;EACI,cAAA;AFmzCR;AErzCA;EAKQ,cAAA;AFmzCR;AE/yCA;;EAGQ,cAAA;AFgzCR;AE5yCA;EACI,cAAA;AF8yCJ;AE3yCA;EACI,WAAA;AF6yCJ;AE1yCA;;EAEI,8BAAA;AF4yCJ;AEzyCA;EACI,oBAAA;EACA,eAAA;AF2yCJ;AExyCA;EACI,qBAAA;AF0yCJ;AEvyCA;EACI,aAAA;AFyyCJ;AEtyCA;EACI,YAAA;EACA,iBAAA;EACA,gBAAA;AFwyCJ;AEryCA;EACI,YAAA;AFuyCJ;AEpyCA;EACI,SAAA;AFsyCJ;AEnyCA;EACI,cAAA;EACA,kBAAA;AFqyCJ;AElyCA;EACI,mBAAA;AFoyCJ;AEjyCA;;EAEI,6BAAA;EACA,cAAA;AFmyCJ;AEhyCA;EACI,mBAAA;AFkyCJ;AEnyCA;EAGQ,gBAAA;AFmyCR;AE/xCA;;EAEI,eAAA;AFiyCJ;AACA;;sEAEsE;AE3xCtE;;;;;;EAMI,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AF6xCJ;AE1xCA;;;EAGI,gBAAA;AF4xCJ;AEzxCA;;;;;;EAMI,qBAAA;AF2xCJ;AExxCA;;EAEI,eAAA;AF0xCJ;AEvxCA;EACI,YAAA;EACA,gBAAA;EACA,mBAAA;AFyxCJ;AEtxCA;EACI,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AFwxCJ;AErxCA;EACI,YAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;AFuxCJ;AEpxCA;EACI,WAAA;AFsxCJ;AEnxCA;;EAEI,wBAAA;AFqxCJ;AElxCA;;EAEI,2EAAA;EACA,oBAAA;EACA,SAAA;EACA,QAAA;AFoxCJ;AEjxCA;;EAEI,2EAAA;EACA,oBAAA;EACA,UAAA;EACA,QAAA;AFmxCJ;AEhxCA;EACI,2CAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EFkxCF,0BAA0B;AAC5B;AEhxCA;;;EAGI,UAAA;AFkxCJ;AE/wCA;EACI,gBAAA;EACA,eAAA;AFixCJ;AACA;;0BAE0B;AE7wC1B;EAGI,mBAAA;AF6wCJ;AEhxCA;EAMQ,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AF6wCR;AEvxCA;EAaY,cAAA;AF6wCZ;AExwCA;EACI,cAAA;AF0wCJ;AACA,gBAAgB;AAChB;;0BAE0B;AEprC1B;EACI,cAAA;EACA,kBAAA;EFsrCF;sBACoB;AACtB;AEnrCA;EACI,aAAA;EACA,gBAAA;AFqrCJ;AEvrCA;;EAKQ,aAAA;AFsrCR;AE3rCA;EAQQ,0BAAA;EACA,gBAAA;EFsrCN,8CAA8C;AAChD;AEnrCA;EACI,cAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;AFqrCJ;AEzrCA;EAOQ,UAAA;EACA,iBAAA;AFqrCR;AE7rCA;EAYQ,kBAAA;AForCR;AEhsCA;;;EAkBQ,2BAAA;AFmrCR;AErsCA;;EAuBQ,MAAA;AFkrCR;AEzsCA;EA2BQ,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,+BAAA;EACA,UAAA;AFirCR;AEjtCA;EAmCY,8BAAA;AFirCZ;AEptCA;EAwCQ,yBAAA;EACA,2BAAA;AF+qCR;AE3qCA;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;AF6qCJ;AEprCA;EAUQ,gBAAA;EF6qCN,eAAe;AACjB;AExrCA;EAeQ,kBAAA;EACA,WAAA;EACA,UAAA;AF4qCR;AE7rCA;EAqBQ,WAAA;AF2qCR;AEhsCA;EAyBQ,WAAA;EACA,cAAA;AF0qCR;AEtqCA;EACI,gBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,2BAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,gBAAA;AFwqCJ;AEnrCA;EAcQ,eAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;AFwqCR;AE3rCA;EAuBQ,mBAAA;AFuqCR;AE9rCA;EA0BY,iBAAA;EACA,oBAAA;AFuqCZ;AElsCA;EAgCQ,8BAAA;AFqqCR;AErsCA;EAqCY,cAAA;AFmqCZ;AExsCA;EA0CQ,8BAAA;AFiqCR;AE7pCA;EACI,2BAAA;EACA,kBAAA;AF+pCJ;AEzpCA;EAEQ,gBAAA;EF0pCN,sCAAsC;AACxC;AE7pCA;EAMgB,cAAA;AF0pChB;AEppCA;EACI,gBAAA;AFspCJ;AEnpCA;EACI,uBAAA;EACA,kBAAA;AFqpCJ;AElpCA;EAEQ,6BAAA;EACA,mBAAA;AFmpCR;AACA,iBAAiB;AE9oCjB;EACI,wBAAA;AFgpCJ;AE7oCA;EACI,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,WAAA;AF+oCJ;AE7oCI;EACI,6CAAA;AF+oCR;AEhpCI;EAGQ,mBAAA;AFgpCZ;AE9pCA;EAmBQ,WAAA;AF8oCR;AEjqCA;EAuBQ,wBAAA;AF6oCR;AE1oCI;EACI,iBAAA;AF4oCR;AExoCA;EACI,wBAAA;AF0oCJ;AEvoCA;EACI,cAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,gDAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,kCAAA;EACA,WAAA;AFyoCJ;AEtpCA;EAgBQ,aAAA;AFyoCR;AEroCA;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;AFuoCJ;AE7oCA;EASQ,cAAA;AFuoCR;AEnoCA;EACI,eAAA;EACA,mBAAA;EACA,qBAAA;AFqoCJ;AEloCA;EACI,oCAAA;AFooCJ;AEjoCA;EACI,qBAAA;EACA,sBAAA;AFmoCJ;AEroCA;EAKQ,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AFmoCR;AE5oCA;EAaQ,gBAAA;AFkoCR;AE/oCA;EAiBQ,mBAAA;AFioCR;AElpCA;EAqBQ,mBAAA;AFgoCR;AErpCA;EAyBQ,mBAAA;AF+nCR;AExpCA;EA6BQ,mBAAA;AF8nCR;AE3pCA;EAiCQ,mBAAA;AF6nCR;AEznCA;EACI,cAAA;AF2nCJ;AE5nCA;EAIQ,mBAAA;EACA,gBAAA;EACA,UAAA;AF2nCR;AEvnCA;EACI,cAAA;AFynCJ;AE1nCA;EAIQ,mBAAA;EACA,gBAAA;EACA,UAAA;AFynCR;AErnCA;EACI,cAAA;AFunCJ;AExnCA;EAIQ,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AFunCR;AEnnCA;EACI,cAAA;AFqnCJ;AEtnCA;EAIQ,oCAAA;AFqnCR;AEjnCA;EACI,cAAA;AFmnCJ;AEpnCA;EAIQ,yBAAA;AFmnCR;AACA;;;;;;EAME;AE9mCF;EACI,cAAA;AFgnCJ;AEjnCA;EAIQ,yBAAA;AFgnCR;AE5mCA;EACI,cAAA;AF8mCJ;AE/mCA;EAIQ,yBAAA;AF8mCR;AE1mCA;EACI,cAAA;AF4mCJ;AE7mCA;EAIQ,yBAAA;EACA,gBAAA;AF4mCR;AEjnCA;EAQY,mBAAA;AF4mCZ;AEvmCA;EACI,cAAA;AFymCJ;AE1mCA;EAIQ,yBAAA;EACA,gBAAA;AFymCR;AE9mCA;EAQY,mBAAA;AFymCZ;AEpmCA;EACI,iBAAA;AFsmCJ;AACA;;0BAE0B;AEnmC1B;EACI,YAAA;AFqmCJ;AEtmCA;EAIQ,YAAA;AFqmCR;AEzmCA;EAOY,gBAAA;AFqmCZ;AE5mCA;EAUgB,gBAAA;EACA,eAAA;AFqmChB;AEhnCA;EAkBY,6BAAA;AFimCZ;AEnnCA;EAuBQ,kBAAA;EACA,kBAAA;AF+lCR;AEvnCA;EA4BQ,eAAA;EACA,6BAAA;EACA,cAAA;EACA,kBAAA;AF8lCR;AE7nCA;EAmCQ,wBAAA;AF6lCR;AEhoCA;EAuCQ,0BAAA;EACA,gBAAA;EACA,iBAAA;AF4lCR;AExlCA;EACI,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,SAAA;AF0lCJ;AEvlCA;EACI,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AFylCJ;AEtlCA;EACI,iBAAA;AFwlCJ;AErlCA;EACI,aAAA;EACA,YAAA;AFulCJ;AACA,aAAa;AEnlCb;EACI,gBAAA;AFqlCJ;AEtlCA;EAIQ,cAAA;AFqlCR;AEzlCA;EAQQ,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AFolCR;AEhlCA;EACI,8BAAA;AFklCJ;AE/kCA;;EAEI,mBAAA;AFilCJ;AE9kCA;;EAEI,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AFglCJ;AE7kCA;EAEQ,gBAAA;AF8kCR;AE1kCA;EACI,iBAAA;AF4kCJ;AACA;;0BAE0B;AExkC1B;EACI,cAAA;EACA,kBAAA;EACA,MAAA;EACA,aAAA;EACA,4CAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;AF0kCJ;AEllCA;EAWQ,cAAA;EACA,eAAA;EACA,sBAAA;AF0kCR;AEvlCA;EAiBQ,cAAA;EACA,0BAAA;AFykCR;AE3lCA;EAsBQ,cAAA;EACA,gBAAA;AFwkCR;AE/lCA;EA2BQ,qBAAA;EFukCN,oBAAoB;EErkCd,gBAAA;EACA,gBAAA;EACA,cAAA;AFukCR;AEpkCI;;EAEI,SAAA;EACA,qBAAA;EACA,4CAAA;AFskCR;AE1kCI;;;;EAQQ,cAAA;AFwkCZ;AACA;;0BAE0B;AElkC1B;;;EAIQ,cAAA;EACA,mBAAA;AFmkCR;AExkCA;EASQ,kBAAA;EACA,cAAA;AFkkCR;AE5kCA;;EAaY,cAAA;EACA,gBAAA;AFmkCZ;AEjlCA;EAmBQ,gBAAA;AFikCR;AEplCA;;EAsBY,UAAA;AFkkCZ;AE7jCA;EACI,mBAAA;AF+jCJ;AEhkCA;;EAKQ,sBAAA;AF+jCR;AE3jCA;;EAEI,iBAAA;AF6jCJ;AE1jCA;EACI,cAAA;EACA,8BAAA;AF4jCJ;AEzjCA;EACI,eAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AF2jCJ;AExjCA;EACI,gBAAA;AF0jCJ;AEvjCA;EACI,UAAA;AFyjCJ;AE1jCA;EAIQ,gBAAA;EACA,cAAA;AFyjCR;AErjCA;;EAEI,qBAAA;AFujCJ;AEpjCA;;EAEI,eAAA;EACA,WAAA;AFsjCJ;AEnjCA;EACI,sBAAA;EACA,cAAA;AFqjCJ;AEvjCA;EAKQ,mBAAA;AFqjCR;AE1jCA;EASQ,YAAA;EACA,UAAA;EACA,SAAA;AFojCR;AE5iCA;EAEQ,QAAA;AF6iCR;AE/iCA;EAMQ,WAAA;AF4iCR;AExiCA;EACI,cAAA;EACA,iBAAA;AF0iCJ;AE5iCA;;EAMQ,cAAA;AF0iCR;AEhjCA;EAUQ,eAAA;EACA,gBAAA;EACA,oBAAA;AFyiCR;AEriCA;EACI,eAAA;EACA,yBAAA;AFuiCJ;AEpiCA;EACI,mBAAA;EACA,iBAAA;EACA,WAAA;AFsiCJ;AEziCA;EAMQ,gBAAA;EACA,sBAAA;EACA,cAAA;AFsiCR;AEriCQ;;EAEI,qBAAA;AFuiCZ;AEljCA;EAgBQ,SAAA;AFqiCR;AEjiCA;EACI,gBAAA;EACA,wBAAA;EACA,cAAA;AFmiCJ;AEhiCA;EACI,WAAA;EACA,eAAA;AFkiCJ;AE/hCA;EACI,eAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AFiiCJ;AE9hCA;;EAEI,mBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AFgiCJ;AE7hCA;EACI,mBAAA;EACA,cAAA;AF+hCJ;AE5hCA;EACI,sBAAA;AF8hCJ;AE3hCA;EACI,cAAA;AF6hCJ;AACA,8DAA8D;AE1hC9D;EAEQ,eAAA;AF2hCR;AACA,+NAA+N;AAC/N,iBAAiB;AACjB;;0BAE0B;AEvhC1B;EAEQ,kCAAA;EACA,0BAAA;AFwhCR;AE3hCA;EAMY,aAAA;AFwhCZ;AEnhCA;EACI,aAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AFqhCJ;AElhCA;EACI,6BAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AFohCJ;AEjhCA;EACI,cAAA;EACA,eAAA;AFmhCJ;AE7gCA;EF+gCE;;MAEI;AACN;AElhCA;EAEQ,mBAAA;EACA,yBAAA;EACA,gCAAA;AFmhCR;AEvhCA;EAQQ,aAAA;AFkhCR;AE1hCA;EAYQ,mBAAA;EACA,yBAAA;EACA,cAAA;AFihCR;AE/hCA;EAkBQ,mBAAA;EACA,yBAAA;AFghCR;AEniCA;EAuBQ,cAAA;AF+gCR;AEtiCA;;EA4BQ,qBAAA;AF8gCR;AEtgCA;EACI,cAAA;EACA,eAAA;EFwgCF;;MAEI;AACN;AE7gCA;;EAUQ,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,wBAAA;EACA,aAAA;EACA,qBAAA;AFugCR;AEvhCA;EAoBQ,cAAA;AFsgCR;AElgCA;;EAEI,yDAAA;EACA,qBAAA;EACA,+BAAA;AFogCJ;AEjgCA;;EAEI,yDAAA;EACA,qBAAA;EACA,+BAAA;AFmgCJ;AEhgCA;;EAEI,oCAAA;AFkgCJ;AE//BA;;EAEI,yDAAA;EACA,qBAAA;EACA,gCAAA;EACA,iCAAA;EACA,sBAAA;EACA,6BAAA;AFigCJ;AE9/BA;;EAEI,yDAAA;EACA,qBAAA;EACA,+BAAA;AFggCJ;AE7/BA;EACI,sBAAA;EACA,gCAAA;EACA,kCAAA;EACA,0BAAA;AF+/BJ;AEngCA;EAOQ,gCAAA;AF+/BR;AE3/BA;;;EAGI,yBAAA;EACA,4BAAA;EACA,iCAAA;EACA,mCAAA;EACA,qBAAA;EACA,yBAAA;EACA,4BAAA;AF6/BJ;AE1/BA;EACI,aAAA;EACA,eAAA;AF4/BJ;AE9/BA;EAKQ,mBAAA;EACA,WAAA;AF4/BR;AEx/BA;EAEQ,iBAAA;AFy/BR;AEr/BA;EACI,aAAA;AFu/BJ;AEx/BA;EAIQ,uBAAA;AFu/BR;AE3/BA;EAOY,aAAA;AFu/BZ;AEl/BA;EACI,YAAA;AFo/BJ;AEj/BA;EACI,kBAAA;EACA,cAAA;AFm/BJ;AEr/BA;EAKQ,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,gCAAA;EACA,uBAAA;AFm/BR;AEh/BI;;EAEI,qBAAA;AFk/BR;AEp/BI;;EAKQ,UAAA;EACA,cAAA;AFm/BZ;AACA;;0BAE0B;AE/+B1B;EACI,eAAA;EACA,cAAA;AFi/BJ;AE9+BA;EAEQ,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AF++BR;AE3+BA;EACI,WAAA;AF6+BJ;AE1+BA;EACI,YAAA;EACA,mBAAA;EACA,YAAA;AF4+BJ;AEz+BA;EACI,WAAA;AF2+BJ;AEx+BA;EACI,WAAA;AF0+BJ;AEv+BA;EACI,kBAAA;AFy+BJ;AEt+BA;;EAEI,gCAAA;AFw+BJ;AEr+BA;;EAGQ,qBAAA;AFs+BR;AEz+BA;;EAOQ,cAAA;AFs+BR;AEl+BA;;;;;;;EAOI,uBAAA;EACA,eAAA;EACA,2BAAA;EACA,uBAAA;EACA,wCAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,mCAAA;EACA,2BAAA;EACA,gFAAA;EAGA,2EAAA;EAGA,wEAAA;AFg+BJ;AE39BA;;EAEI,gCAAA;EACA,UAAA;EACA,0FAAA;EAGA,kFAAA;AF29BJ;AEt9BA;EACI,gBAAA;EACA,2BAAA;EACA,uBAAA;AFw9BJ;AEr9BA;EACI,uBAAA;AFu9BJ;AEp9BA;EACI,6BAAA;EACA,2BAAA;AFs9BJ;AEn9BA;EAGI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,gCAAA;EACA,YAAA;AFm9BJ;AEh9BA;;EAEI,cAAA;EACA,wCAAA;EACA,qCAAA;EACA,mCAAA;EACA,gCAAA;AFk9BJ;AE/8BA;EACI,cAAA;EACA,mBAAA;AFi9BJ;AE98BA;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AFg9BJ;AE78BA;EACI,WAAA;EACA,gBAAA;EACA,eAAA;AF+8BJ;AE58BA;EACI,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AF88BJ;AE38BA;;;EAGI,qBAAA;AF68BJ;AE18BA;EACI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AF48BJ;AEz8BA;EACI,gBAAA;AF28BJ;AEx8BA;EACI,gBAAA;AF08BJ;AEv8BA;EACI,gBAAA;AFy8BJ;AEt8BA;EACI,uDAAA;EACA,gBAAA;EACA,sBAAA;AFw8BJ;AEr8BA;EACI,kBAAA;AFu8BJ;AEp8BA;EAEQ,kBAAA;AFq8BR;AEj8BA;EACI,mCAAA;EACA,gCAAA;EACA,+BAAA;EACA,8BAAA;AFm8BJ;AACA;;0BAE0B;AAC1B;;;;;;EAME;AE97BF;EACI,YAAA;AFg8BJ;AEj8BA;EAIQ,YAAA;AFg8BR;AEp8BA;EAQQ,kBAAA;AF+7BR;AE37BA;EACI,qBAAA;EACA,WAAA;EF67BF,iCAAiC;EE37B/B,aAAA;EACA,iBAAA;AF67BJ;AEl8BA;EAQQ,aAAA;EACA,oBAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;AF67BR;AEz8BA;EF28BE;;;;8BAI4B;EE17BtB,gBAAA;EACA,qBAAA;AF47BR;AEl9BA;EA0BQ,qBAAA;EACA,iBAAA;EACA,gBAAA;EAEA,oBAAA;AF07BR;AACA;;0BAE0B;AEr7B1B;EACI,YAAA;EACA,qBAAA;AFu7BJ;AEp7BA;EACI,qBAAA;AFs7BJ;AACA;;0BAE0B;AEl7B1B;EAEQ,cAAA;EACA,WAAA;AFm7BR;AEt7BA;EAMY,eAAA;AFm7BZ;AEz7BA;EAUY,YAAA;AFk7BZ;AE57BA;EAagB,cAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;AFk7BhB;AEl8BA;EAoBgB,eAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;AFi7BhB;AEx8BA;EA2BgB,WAAA;EACA,qBAAA;AFg7BhB;AE58BA;EAgCgB,YAAA;EACA,qBAAA;AF+6BhB;AACA;;0BAE0B;AEx6B1B;EACI,cAAA;EACA,mBAAA;AF06BJ;AEv6BA;EACI,iBAAA;EACA,gBAAA;AFy6BJ;AEt6BA;EACI,mBAAA;AFw6BJ;AEr6BA;EACI,gBAAA;AFu6BJ;AEp6BA;EACI,gBAAA;AFs6BJ;AACA;;EAEE;AEl6BF;EACI,aAAA;AFo6BJ;AEj6BA;EACI,sBAAA;EACA,6CAAA;AFm6BJ;AEh6BA;EACI,gBAAA;AFk6BJ;AEn6BA;EAIQ,gCAAA;AFk6BR;AEt6BA;EAQQ,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;AFi6BR;AEh7BA;EFk7BE,wBAAwB;AAC1B;AEn7BA;EAwBY,kBAAA;AF85BZ;AEt7BA;EA4BY,aAAA;AF65BZ;AEz7BA;EAgCY,cAAA;AF45BZ;AEv5BA;;EAEI,YAAA;AFy5BJ;AEt5BA;EACI,iBAAA;AFw5BJ;AEz5BA;EAIQ,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gCAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,oCAAA;EACA,iCAAA;EACA,+BAAA;EACA,4BAAA;AFw5BR;AEt5BQ;EACI,kBAAA;EACA,gBAAA;EACA,WAAA;AFw5BZ;AEn5BA;EACI,eAAA;AFq5BJ;AEl5BA;EACI,mBAAA;EACA,qBAAA;EACA,qBAAA;AFo5BJ;AEj5BA;EACI,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AFm5BJ;AEh5BA;EAEQ,mBAAA;AFi5BR;AEn5BA;EAMQ,mBAAA;AFg5BR;AEt5BA;EAUQ,mBAAA;AF+4BR;AEz5BA;EAcQ,mBAAA;AF84BR;AE55BA;EAkBQ,mBAAA;AF64BR;AEz4BA;EACI,qBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;AF24BJ;AE/4BA;EAOQ,qBAAA;AF24BR;AEl5BA;EAUY,qBAAA;EACA,cAAA;AF24BZ;AEt5BA;EAeY,mBAAA;AF04BZ;AEz5BA;EAmBY,qBAAA;EACA,cAAA;AFy4BZ;AE75BA;EAwBY,mBAAA;AFw4BZ;AEh6BA;EA4BY,qBAAA;EACA,cAAA;AFu4BZ;AEp6BA;EAiCY,mBAAA;AFs4BZ;AEv6BA;EAqCY,qBAAA;EACA,cAAA;AFq4BZ;AE36BA;EA0CY,mBAAA;AFo4BZ;AE96BA;EA8CY,qBAAA;EACA,cAAA;AFm4BZ;AEl7BA;EAmDY,mBAAA;AFk4BZ;AE73BA;EACI,iBAAA;AF+3BJ;AEh4BA;EAIQ,2BAAA;AF+3BR;AE33BA;EACI,UAAA;AF63BJ;AE93BA;EAIQ,eAAA;EACA,qBAAA;AF63BR;AEl4BA;EASQ,aAAA;AF43BR;AEx3BA;EACI,iBAAA;AF03BJ;AEv3BA;EACI,iBAAA;EACA,YAAA;AFy3BJ;AACA,aAAa;AACb;;0BAE0B;AEp3B1B;EACI,mBAAA;AFs3BJ;AEp3BA;EACI,gBAAA;AFs3BJ;AACA;;0BAE0B;AEl3B1B;EACI;IAMQ,WAAA;EF+2BV;AACF;AE32BA;EACI;IACI,oBAAA;EF62BN;EE12BE;IACI,kBAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,SAAA;IACA,gBAAA;EF42BN;EEz2BE;IACI,UAAA;EF22BN;EEx2BE;IACI,WAAA;EF02BN;EEv2BE;IACI,gBAAA;EFy2BN;EEt2BE;IACI,WAAA;IACA,eAAA;EFw2BN;EEr2BE;;IAEI,kBAAA;EFu2BN;EEp2BE;IACI,aAAA;EFs2BN;EE/1BE;IAEQ,eAAA;IACA,iBAAA;IACA,YAAA;EFg2BV;EE51BE;IAEQ,eAAA;EF61BV;EEz1BE;IACI,aAAA;EF21BN;EEx1BE;IACI,UAAA;EF01BN;EEv1BE;IACI,2BAAA;EFy1BN;EEt1BE;IACI,YAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;IACA,kBAAA;EFw1BN;EE71BE;IAQQ,8CAAA;EFw1BV;EEp1BE;IACI,qBAAA;IACA,WAAA;EFs1BN;EEn1BE;IACI,kBAAA;IACA,WAAA;EFq1BN;EEl1BE;IAEQ,2BAAA;EFm1BV;EEr1BE;IAMQ,YAAA;EFk1BV;EE90BE;IACI,iBAAA;IACA,kBAAA;EFg1BN;EE70BE;IACI,YAAA;IACA,aAAA;EF+0BN;EE50BE;IACI,SAAA;EF80BN;EE30BE;IACI,UAAA;EF60BN;EE10BE;IACI,eAAA;EF40BN;EEz0BE;IACI,kBAAA;EF20BN;EEx0BE;IAEQ,gCAAA;IACA,oBAAA;IACA,mBAAA;EFy0BV;EEn0BE;IACI,wBAAA;IACA,iBAAA;EFq0BN;EEl0BE;IACI,wBAAA;IACA,YAAA;EFo0BN;AACF;AACA,0CAA0C;AEj0B1C;EACI;IAEQ,cAAA;IACA,WAAA;EFk0BV;EEr0BE;IAMY,eAAA;EFk0Bd;EEx0BE;IAUY,cAAA;EFi0Bd;EE30BE;IAagB,mBAAA;IACA,gBAAA;IACA,WAAA;IACA,WAAA;EFi0BlB;EEj1BE;IAoBgB,kBAAA;IACA,mBAAA;IACA,gBAAA;IACA,WAAA;EFg0BlB;EEv1BE;IA2BgB,WAAA;IACA,qBAAA;EF+zBlB;EE31BE;IAgCgB,YAAA;IACA,qBAAA;EF8zBlB;EExzBE;IACI,aAAA;EF0zBN;EEvzBE;IACI,yBAAA;IACA,uBAAA;IACA,iBAAA;IACA,4BAAA;EFyzBN;EEtzBE;IACI,aAAA;EFwzBN;EErzBE;IACI,iBAAA;EFuzBN;EEpzBE;IACI,YAAA;IACA,aAAA;IACA,cAAA;IACA,+BAAA;EFszBN;EEnzBE;IACI,aAAA;EFqzBN;EElzBE;;IAEI,8BAAA;IACA,gBAAA;EFozBN;EEjzBE;IACI,WAAA;IACA,iCAAA;IACA,gBAAA;EFmzBN;EEhzBE;IACI,8BAAA;IACA,aAAA;EFkzBN;AACF;AACA,4CAA4C;AE/yB5C;EACI;;IAEI,gBAAA;EFizBN;EE9yBE;IACI,aAAA;EFgzBN;EE9yBE;IACI,iBAAA;EFgzBN;AACF;AACA,kDAAkD;AE9yBlD;EACI;;IAEI,gBAAA;EFgzBN;EE9yBE;IACI,aAAA;EFgzBN;AACF;AE7yBA;EAIgB,6BAAA;AF4yBhB;AEtyBA;;EAEI,0BAAA;AFwyBJ;AEryBA;EACI,qBAAA;AFuyBJ;AEpyBA;EACI,aAAA;AFsyBJ;AEnyBA;EACI;IACI,yBAAA;EFqyBN;EElyBE;IACI,uBAAA;IACA,aAAA;EFoyBN;AACF;AACA,gCAAgC;AEhyBhC;EACI;IAEQ,+BAAA;IACA,kCAAA;IACA,0BAAA;EFiyBV;EEhyBU;IAEQ,cAAA;IACA,YAAA;IACA,gBAAA;IACA,eAAA;IACA,kBAAA;EFiyBlB;EE5yBE;IAiBQ,YAAA;IF8xBR,mCAAmC;EACrC;EE3xBM;IAEQ,gBAAA;EF4xBd;EE9xBM;IAMQ,SAAA;IACA,UAAA;IACA,eAAA;IACA,gBAAA;IACA,kBAAA;EF2xBd;AACF;AEtxBA;EACI;IACI,YAAA;EFwxBN;AACF;AErxBA;EACI;IFuxBA,yEAAyE;IErxBrE,eAAA;IACA,uBAAA;EFuxBN;AACF;AEpxBA;EACI;IACI,YAAA;EFsxBN;AACF;AEnxBA;EACI;IACI,aAAA;EFqxBN;AACF;AElxBA;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AFoxBJ;AEjxBA;EACI,gBAAA;AFmxBJ;AACA,WAAW;AE/wBX;EACI,sBAAA;EACA,eAAA;AFixBJ;AEnxBA;EAKQ,gBAAA;AFixBR;AE7wBA;EACI,eAAA;AF+wBJ;AEhxBA;EAIQ,kBAAA;AF+wBR;AEnxBA;EAQQ,qBAAA;EACA,+BAAA;AF8wBR;AE5wBQ;EACI,iCAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AF8wBZ;AE3wBQ;EACI,+BAAA;AF6wBZ;AE1wBQ;;EAEI,4BAAA;AF4wBZ;AEvyBA;EAgCQ,mBAAA;EACA,qBAAA;EACA,4BAAA;AF0wBR;AExwBQ;EACI,aAAA;AF0wBZ;AE/yBA;EA0CQ,sBAAA;AFwwBR;AElzBA;EA8CQ,gBAAA;AFuwBR;AElwBA;EAEQ,iBAAA;AFmwBR;AErwBA;EAKQ,aAAA;AFmwBR;AExwBA;EAQQ,UAAA;AFmwBR;AEhwBA;EACI,kBAAA;AFkwBJ;AACA,8CAA8C;AEhwB9C;;EAEI,qBAAA;AFkwBJ;AEhwBA;EACI,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AFkwBJ;AEhwBA;EACI,YAAA;AFkwBJ;AEhwBA;EACI,yBAAA;EACA,kBAAA;EACA,aAAA;AFkwBJ;AEhwBA;EACI,0BAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AFkwBJ;AE9vBQ;;EACI,kBAAA;AFiwBZ;AE9wBA;EAkBQ,gBAAA;AF+vBR;AE5vBA;EACI,gBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AF8vBJ;AE5vBI;EACI,gBAAA;AF8vBR;AEzvBQ;EACI,qBAAA;EACA,iBAAA;EACA,cAAA;AF2vBZ;AEhwBA;EAWY,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;AFwvBZ;AElvBgB;;;;;EACI,iBAAA;EACA,mBAAA;AFwvBpB;AE9wBA;;;;;EAkCQ,aAAA;AFmvBR;AErxBA;EAsCQ,cAAA;EACA,SAAA;AFkvBR;AEzxBA;EA0CY,oBAAA;EACA,kBAAA;EACA,8BAAA;AFkvBZ;AE9xBA;EA8CgB,cAAA;EACA,cAAA;AFmvBhB;AElyBA;EAiDoB,cAAA;EACA,iBAAA;AFovBpB;AEtyBA;EAuDgB,iBAAA;AFkvBhB;AEzyBA;;EA6DgB,aAAA;AFgvBhB;AE7yBA;;EAkEgB,qBAAA;AF+uBhB;AEjzBA;EAuEY,YAAA;AF6uBZ;AEpzBA;;EA6EY,cAAA;AF2uBZ;AExzBA;EAiFY,eAAA;AF0uBZ","sourcesContent":["/* These MUST be 6 char hex or bad things (silently) happen */\n@font-face {\n  font-style: normal;\n  font-weight: 400;\n  src: local(\"Open Sans Regular\"), local(\"OpenSans-Regular\"), url(https://fonts.gstatic.com/s/opensans/v15/mem8YaGs126MiZpBA-UFUZ0bbck.woff2) format(\"woff2\");\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n/* variables for easier Custom Less modification */\nhtml {\n  position: relative;\n  min-height: 100vh;\n}\n.skip-to.popup.focus {\n  z-index: 1030;\n}\nbody {\n  padding-top: 70px;\n  background: #fff;\n  background-size: cover;\n  font-weight: normal;\n  font-family: \"Open Sans\", sans-serif;\n}\n.body-content {\n  width: 100%;\n  position: relative;\n}\na {\n  color: #466db2;\n}\na:hover {\n  cursor: pointer;\n  color: #304b7b;\n}\np {\n  clear: none;\n}\nh1 {\n  line-height: 1;\n  color: #333;\n}\nh1,\nh2,\nh3 {\n  margin-top: 10px;\n  font-weight: 500;\n}\nh1 {\n  font-size: 1.9rem;\n}\nh2 {\n  font-size: 1.65rem;\n}\nh3 {\n  font-size: 1.45rem;\n}\nh4 {\n  font-size: 1.3rem;\n}\nh5 {\n  font-size: 1.15rem;\n}\nh6 {\n  font-size: 1rem;\n}\n.pull-right {\n  float: right;\n}\n.loading {\n  margin: 15px auto;\n  display: block;\n  margin: 0 auto;\n  height: 100px;\n}\n.text-smaller {\n  font-size: 0.875rem;\n}\n.tile,\n.dashboard_btn {\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 15px;\n}\n[data-bind*=\"clickOrEnter\"],\n[data-bind^=\"clickOrEnter\"] {\n  cursor: pointer;\n}\n.dropdown-menu li,\n.returning_user li {\n  list-style-type: none;\n  list-style-position: initial;\n}\n.previous-question {\n  padding: 5px 10px;\n  border-top: 1px solid #ddd;\n  font-size: 13px;\n  cursor: pointer;\n}\n.previous-question strong {\n  font-size: 15px;\n}\n.current-question {\n  border-top: 1px solid #ddd;\n}\n.answer.disabled {\n  opacity: 0.65;\n}\n.previous-question:hover,\n.previous-question:focus {\n  background: #f5f5f5;\n}\n.dropdown-menu {\n  border-radius: 0 0 6px 6px;\n}\n.dropdown.open .dropdown-menu {\n  opacity: 1;\n}\n.dropdown-toggle.show + .dropdown-menu {\n  display: block;\n}\nlabel {\n  font-weight: 500;\n}\n#jsPageEditor .form-control,\n#jsPageEditor .vs__dropdown-toggle,\n#jsPageEditor .form-group .input-group .input-group-text {\n  font-weight: normal;\n  border-color: #787878;\n}\n#jsPageEditor .vs__dropdown-toggle .vs__open-indicator {\n  fill: #333333;\n}\n#jsPageEditor .form-control:focus,\n#jsPageEditor .vs--open .vs__dropdown-toggle {\n  border-width: 2px;\n  border-color: rgba(0, 0, 0, 0.87);\n  box-shadow: unset;\n}\n#jsPageEditor .form-control:focus ~ .vs__dropdown-menu,\n#jsPageEditor .vs--open .vs__dropdown-toggle ~ .vs__dropdown-menu {\n  --vs-border-width: 0;\n}\n#jsPageEditor .form-group .btn-group {\n  border-radius: 0.35rem;\n}\n#jsPageEditor .form-group.text-form-group .input-group-append .input-group-text:focus,\n#jsPageEditor .form-group.text-form-group .input-group-prepend .input-group-text:focus {\n  z-index: 0;\n}\n#jsPageEditor .form-group.has-custom-errors .border-mixin {\n  border-color: #b00020;\n  border-width: 1px;\n  outline: unset;\n}\n#jsPageEditor .form-group.has-custom-errors .border-focus-mixin {\n  border-width: 2px;\n  box-shadow: unset;\n}\n#jsPageEditor .form-group.has-custom-errors .invalid-border-mixin {\n  border-color: #b00020;\n  border-width: 1px;\n  outline: unset;\n}\n#jsPageEditor .form-group.has-custom-errors .invalid-border-mixin:focus {\n  border-width: 2px;\n  box-shadow: unset;\n}\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .form-control,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .form-control,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-text {\n  border-color: #b00020;\n  border-width: 1px;\n  outline: unset;\n}\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .form-control:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .form-control:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-text:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-text:focus {\n  border-width: 2px;\n  box-shadow: unset;\n}\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend .input-group-text {\n  border-color: #b00020;\n  border-width: 1px;\n  outline: unset;\n}\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append .input-group-text:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append .input-group-text:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend .input-group-text:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend .input-group-text:focus {\n  border-width: 2px;\n  box-shadow: unset;\n}\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append .input-group-text:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append .input-group-text:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend .input-group-text:focus,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend .input-group-text:focus {\n  outline: 2px solid #b00020;\n  box-shadow: unset;\n  border: unset;\n  z-index: 0;\n}\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append:not(.input-group-prepend) .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append:not(.input-group-prepend) .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend:not(.input-group-prepend) .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend:not(.input-group-prepend) .input-group-text {\n  border-left-width: 0;\n}\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-append:not(.input-group-append) .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-append:not(.input-group-append) .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .input-group-prepend:not(.input-group-append) .input-group-text,\n#jsPageEditor .form-group.has-custom-errors.text-form-group > div > .datepicker-group > .input-group-prepend:not(.input-group-append) .input-group-text {\n  border-right-width: 0;\n}\n#jsPageEditor .form-group.has-custom-errors.dropdown-form-group > div > div > select.form-control,\n#jsPageEditor .form-group.has-custom-errors.dropdown-form-group > div > div > .v-select .vs__dropdown-toggle {\n  border-color: #b00020;\n  border-width: 1px;\n  outline: unset;\n}\n#jsPageEditor .form-group.has-custom-errors.dropdown-form-group > div > div > .v-select.vs--open .vs__dropdown-toggle {\n  border-width: 2px;\n  box-shadow: unset;\n}\n#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-file,\n#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group {\n  border-color: #b00020;\n  border-width: 1px;\n  outline: unset;\n  border-width: 2px;\n}\n#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-file:focus,\n#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group:focus {\n  border-width: 2px;\n  box-shadow: unset;\n}\n#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group {\n  border-style: solid;\n}\n#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group a.btn {\n  border-width: 0;\n}\n#jsPageEditor .form-group.has-custom-errors.file-form-group > div > .btn-group .input-group-append {\n  border-top-width: 0;\n  border-right-width: 0;\n  border-bottom-width: 0;\n}\n.form-check-label,\n.radio-inline,\n.checkbox label {\n  font-weight: normal;\n  margin-bottom: 0;\n}\n.page-loading {\n  position: fixed;\n  opacity: 1;\n  transition: all 0.4s ease-in;\n}\nhtml.no-js .page-loading {\n  display: none;\n}\n.page-loaded {\n  opacity: 0;\n  height: 0;\n  transition: none;\n  /*ensure wheel doesn't fade out, rather disappears*/\n  z-index: -1;\n}\n.body-loading {\n  width: 100px;\n  height: 100px;\n  border-radius: 1.5ex;\n  padding: 0.2ex;\n  position: fixed;\n  left: calc(50% - 50px);\n  top: calc(50% - 50px);\n}\n.body-loading .loading {\n  height: 100%;\n}\n.popover-header {\n  margin: 0;\n}\n.popper {\n  background: #ffffff;\n  max-width: 300px;\n  border: 1px solid #cccccc;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n  padding: 7.5px;\n}\n.form-check.answer {\n  position: static;\n}\n.v--modal-overlay {\n  z-index: 1002;\n}\n.modal-content {\n  border: none;\n  max-height: 100vh;\n  overflow-y: auto;\n}\n/* ------------------------\n NAVIGATION\n-/----------------------- */\n.skip-navigation-link:focus {\n  display: block;\n  top: 0;\n  width: auto !important;\n  height: auto !important;\n  z-index: 998999;\n  background: white;\n  clip: unset;\n}\n.navbar-dark {\n  background-color: #2b2b2b;\n  /*min-height: 60px;*/\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n.navbar-dark {\n  padding-left: 0;\n  padding-right: 0;\n}\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.9);\n  cursor: pointer;\n}\n.navbar-dark .navbar-nav .nav-link:hover,\n.navbar-dark .navbar-nav .nav-link:focus {\n  color: #ffffff;\n}\n.navbar-dark a {\n  white-space: nowrap;\n}\n.navbar-dark a:hover,\n.navbar-dark a:focus {\n  text-decoration: none;\n}\n.icon-bar {\n  display: block;\n  background: #ffffff;\n  height: 1px;\n  width: 18px;\n  margin-top: 5px;\n}\n.navbar-fixed-top .navbar-collapse,\n.navbar-fixed-bottom .navbar-collapse {\n  max-height: none;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n  width: 100%;\n}\n.navbar-dark .navbar-nav > li > a {\n  color: #fff;\n  font-size: 15px;\n  text-decoration: none;\n  display: inline-block;\n  letter-spacing: 0.5px;\n  /*text-transform: uppercase;*/\n}\n.navbar-dark .navbar-nav > li {\n  padding: 13px 7.5px;\n}\n.navbar-dark .navbar-nav > li button {\n  margin-bottom: 0;\n}\n.navbar-dark .navbar-nav > li ::-webkit-input-placeholder,\n.navbar-dark .navbar-nav > li :-moz-placeholder,\n.navbar-dark .navbar-nav > li ::-moz-placeholder,\n.navbar-dark .navbar-nav > li :-ms-input-placeholder {\n  color: #fff !important;\n  opacity: 1 !important;\n}\nfieldset {\n  border: none;\n  padding: 0;\n  margin: 0;\n}\nlegend {\n  font-size: 1.2em;\n  font-weight: 500;\n}\n.navbar-dark .navbar-nav > .vr {\n  height: 50px;\n  width: 1px;\n  margin-top: 5px;\n  margin-left: 7px;\n  padding-left: 0;\n  padding-right: 7px;\n  border-left: 1px solid #3e3e3e;\n}\n.navbar-dark .navbar-nav > li:not(.active) > a:hover,\n.navbar-dark .navbar-nav > li > a:focus,\n.navbar-dark .navbar-nav > li:focus,\n.navbar-dark .navbar-nav > li.open > a:hover,\n.navbar-dark .navbar-nav > li.open > a:focus,\n.navbar-dark .navbar-nav > li.open > a:active,\n.dropdown-menu > li > a:hover,\n.dropdown-menu > li > a:focus,\n.dropdown-menu > li > a:active {\n  color: #fff;\n  background: #2b2b2b;\n  border-color: transparent;\n}\n.navbar-dark .navbar-nav > .open > a:hover,\n.navbar-dark .navbar-nav > .open > a:focus {\n  background: #27221a;\n}\n.navbar-dark .navbar-brand {\n  padding: 0;\n  /* cspell:ignore ccess */\n}\n.navbar-dark .navbar-brand img {\n  height: 50px;\n  display: inline;\n}\n.navbar-dark .navbar-brand .brand-letters {\n  display: inline;\n  margin-left: 4px;\n}\n.navbar-dark .navbar-brand .brand-letters img {\n  height: 25px;\n}\n.navbar-dark .navbar-brand .brand-letters-ccess,\n.navbar-dark .navbar-brand .brand-letters-gov {\n  font-size: 40px;\n  letter-spacing: 6pt;\n  vertical-align: middle;\n  display: inline-block;\n  margin-top: -1px;\n}\n.navbar-dark .navbar-brand .brand-letters-ccess {\n  font-weight: bold;\n  color: #ccc;\n}\n.navbar-dark .navbar-brand .brand-letters-gov {\n  color: #fff;\n}\n.navbar-dark .navbar-right {\n  font-size: 1.1em;\n  letter-spacing: 0.4pt;\n  margin: 0;\n  margin-right: -15px;\n  margin-left: auto;\n}\n.form-control.search-control {\n  background: transparent url(\"../images/search.png\") no-repeat center left 7.5px;\n  background-size: 15px;\n  padding-left: 30px;\n}\n.navbar-dark .form-control.search-control:focus {\n  border-bottom-color: #fff;\n}\n.search-backdrop,\n.my-forms-backdrop {\n  /*display: none;*/\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.9);\n  z-index: 10000;\n}\n.search-backdrop .close {\n  position: fixed;\n  top: 30px;\n  right: 30px;\n  color: #fff;\n  font-size: 2em;\n  opacity: 1;\n}\n.search-backdrop .close img {\n  height: 20px;\n}\n.search-backdrop .search-form-wrapper {\n  width: 600px;\n  height: 100px;\n  max-width: 100%;\n  position: fixed;\n  top: 25vh;\n  left: calc(50% - 300px);\n}\n.search-backdrop .search-form-wrapper .form-group label {\n  font-size: 1.5em;\n  color: #aaa;\n  margin-bottom: 0;\n  -webkit-transition: all 0.25s;\n  transition: all 0.25s;\n}\n.search-backdrop .search-form-wrapper .form-group .form-control {\n  background: none;\n  height: 40px;\n  color: #ddd;\n  border: none;\n  padding: 10px;\n  border-bottom: 1px solid #aaa;\n  border-radius: 0;\n  box-shadow: none;\n}\n.search-backdrop .search-form-wrapper .form-group .form-control:focus {\n  border-color: #466db2;\n  border-bottom-width: 2px;\n}\n.nav-search-results {\n  position: relative;\n  height: auto;\n  max-height: calc(75vh - 125px);\n  min-height: 75px;\n  overflow-y: auto;\n  width: 600px;\n  max-width: 100%;\n  background: #fff;\n  margin-top: 0;\n  padding: 0;\n  border-radius: 4px;\n  box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.25);\n  overflow: auto;\n}\n.nav-search-results .nav-search-results-inner {\n  padding: 15px;\n  position: relative;\n  height: auto;\n  width: 100%;\n  overflow-x: hidden;\n  text-align: left;\n}\n.nav-search-results .nav-search-results-caption {\n  position: absolute;\n  top: 5px;\n  right: 10px;\n  display: inline-block;\n  color: #636363;\n  font-size: 12px;\n  /*font-weight: 600;*/\n}\n.nav-search-results .result {\n  padding-top: 5px;\n  letter-spacing: normal;\n  /*font-size: 14px;*/\n  text-align: left;\n}\n.nav-search-results .result:first-of-type {\n  padding-top: 10px;\n}\n.close {\n  opacity: 0.7;\n  font-size: 1.25em;\n}\n.dropdown-menu {\n  padding: 0;\n  padding-bottom: 8px;\n}\n.dropdown-menu > li > a {\n  display: block;\n  color: #fff;\n  font-size: 13px;\n  padding: 6px 18px;\n}\n.dropdown-menu .divider {\n  opacity: 0.3;\n  background-color: #000000;\n  margin: 0;\n  display: none;\n}\n.pane-size-toggle {\n  font-size: 32px;\n  margin-top: -10px;\n  -webkit-appearance: none;\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  float: right;\n}\n.toolbox_pane .pane-size-toggle {\n  margin-top: -14px;\n}\n.toggle-symbol {\n  font-size: 24px;\n  margin-top: -10px;\n}\n.toggle-smaller {\n  margin-left: 7px;\n}\n.toggle-larger {\n  margin-left: 0;\n}\n.pane-size-toggle.close:hover {\n  opacity: 1;\n}\n.df-public-nav .navbar {\n  min-height: 0;\n}\n.navbar-toggle.public_pages_toggle {\n  margin: 5px;\n  padding: 5px;\n}\n.navbar-collapse .list-group {\n  margin-bottom: 0;\n}\n.btn .icon {\n  line-height: 0;\n  vertical-align: inherit;\n}\n.btn .icon-trash {\n  font-size: 1.1em;\n}\n.btn .icon-undo,\n.btn .icon-redo {\n  font-size: 1.15em;\n}\n.btn-link {\n  color: #466db2;\n}\n.btn-link.icon:active,\n.btn-link.icon:focus {\n  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);\n}\n.btn-group-vertical .btn {\n  margin-bottom: 0;\n}\n.fixed-top {\n  z-index: 1001;\n}\n.btn.btn-primary {\n  background: #234d7f;\n  color: #fff;\n  border-color: transparent;\n}\n.btn.btn-primary:hover {\n  background: #3471bb;\n  border-color: #3471bb;\n  color: #fff;\n}\n.btn.btn-primary:focus {\n  outline: 2px solid #3471bb;\n  outline-offset: 2px;\n  box-shadow: unset;\n}\n.btn.btn-primary:active {\n  background: #3471bb !important;\n  color: #fff !important;\n  border-color: #183557;\n}\n.btn.btn-outline-primary:hover {\n  background: #234d7f;\n  border-color: #234d7f;\n}\n.btn.btn-outline-primary:focus {\n  background: #234d7f;\n  color: #fff;\n  outline: 2px solid #234d7f;\n  outline-offset: 2px;\n  box-shadow: unset;\n}\n.btn.btn-outline-secondary:focus {\n  background: #6c757d;\n  color: #ffffff;\n  outline: 2px solid #6c757d;\n  outline-offset: 2px;\n  box-shadow: unset;\n}\n.btn.btn-outline-danger:focus {\n  background: #dc3545;\n  color: #ffffff;\n  outline: 2px solid #dc3545;\n  outline-offset: 2px;\n  box-shadow: unset;\n}\n.btn.btn-outline-success:focus {\n  background: #28a745;\n  color: #ffffff;\n  outline: 2px solid #28a745;\n  outline-offset: 2px;\n  box-shadow: unset;\n}\n.btn.btn-bare:focus {\n  outline: 2px solid rgba(0, 0, 0, 0.87);\n  outline-offset: 2px;\n  box-shadow: unset;\n}\n.btn-block {\n  display: block;\n  width: 100%;\n}\n.btn.btn-xs {\n  padding: 2px 5px;\n  font-size: 0.75rem;\n  border-radius: 3px;\n  -webkit-transition: 0.1s all ease-in-out;\n  -moz-transition: 0.1s all ease-in-out;\n  -o-transition: 0.1s all ease-in-out;\n  transition: 0.1s all ease-in-out;\n}\n.notificationBarTop {\n  background: #ffc107;\n  color: #121212;\n  text-align: center;\n  line-height: 2.5;\n  overflow: hidden;\n  /*margin-top: -15px;\n    margin-bottom: 15px;*/\n}\n.notificationBarTop a,\nhtml.bootstrap-legacy .notificationBarTop button,\nhtml.bootstrap-5 .notificationBarTop button:not(.close) {\n  color: #121212;\n  font-weight: bold;\n  border-bottom: 1px solid #121212;\n  border-radius: 0;\n  padding: 0;\n}\n.notificationBarTop a:hover,\nhtml.bootstrap-legacy .notificationBarTop button:hover,\nhtml.bootstrap-5 .notificationBarTop button:not(.close):hover {\n  color: #0a0c0d;\n}\nhtml.bootstrap-5 .notificationBarTop button:not(.close) {\n  text-decoration: none;\n}\n.notificationBarTop .close {\n  color: #eeeeee;\n  padding: 7px 10px;\n  opacity: 0.8;\n  font-size: 1.3em;\n}\n.notificationBarTop .close:hover {\n  opacity: 1;\n}\n.notificationBarTop .close:not(:disabled):not(.disabled):hover,\n.notificationBarTop .close:not(:disabled):not(.disabled):focus {\n  color: #fff;\n  opacity: 0.75;\n}\n.tab-content .result {\n  border-bottom: 1px solid #ddd;\n  padding: 15px;\n}\n.tab-content .result:first-of-type {\n  border-top: 1px solid #ddd;\n}\n.form-group {\n  margin-bottom: 0.75rem;\n  /*label.focused {\n        color: @focus;\n    }*/\n}\n.form-group label.sr-only {\n  position: absolute;\n}\n.form-group legend {\n  font-size: 1em;\n  font-weight: 600;\n  border-bottom: none;\n  margin-bottom: 2px;\n}\n.form-group .radio-inline,\n.form-group .checkbox-inline,\n.form-group .checkbox label,\n.form-group .radio label {\n  margin-left: 0;\n  margin-right: 10px;\n}\n/*.radio-inline,\n.radio,\n.checkbox-inline,\n.checkbox {\n    font-size: 14px;\n}*/\n.loading {\n  margin: 15px auto;\n  display: block;\n  margin: 0 auto;\n  height: 100px;\n}\n.have_not_searched {\n  text-align: center;\n  height: 100%;\n  width: 100%;\n  /*padding-top: 15px;*/\n}\n.have_not_searched:before {\n  /*content: \"Use this search tool to find forms.\";*/\n  font-size: 1.2em;\n  vertical-align: middle;\n}\n#questionsDiv {\n  position: relative;\n  margin-bottom: 20px;\n}\n#questionsDiv .radio {\n  margin-bottom: 7px;\n}\n.public-page-body .body-content {\n  padding: 0;\n}\n/* ------------------------\n AUTHENTICATED USER\n------------------------ */\n.index-container {\n  display: flex;\n  flex: 1;\n  flex-direction: column-reverse;\n}\n.index-content legend {\n  display: block;\n  width: 100%;\n  text-align: center;\n}\n.returning_user {\n  overflow: auto;\n  flex: 0 0 100%;\n  padding: 0px 15px 15px 15px;\n  background: #f9f9f9;\n  border-top: 1px solid #ccc;\n}\n.returning_user .returning_user_header,\n.returning_user .returning_user_body {\n  visibility: visible;\n}\n.returning_user .nav-tabs {\n  border-bottom-color: #bbbbbb;\n}\n.returning_user .nav-tabs li a {\n  background: none !important;\n}\n.returning_user .badge {\n  margin-left: 5px;\n}\n.returning_user .tab-content {\n  padding: 4px 0;\n  border: none;\n  border-top: none;\n}\n.returning_user .returning_user_list_of_forms {\n  list-style: none;\n  padding: 0;\n}\n.returning_user .returning_user_list_of_forms li {\n  position: relative;\n  display: table;\n  width: 100%;\n  padding: 0.5rem;\n  border-bottom: 1px solid #ccc;\n}\n.returning_user .returning_user_list_of_forms li .returning_user_actions {\n  float: right;\n  display: block;\n}\n#MyFormsHeading {\n  margin-top: 15px;\n  margin-bottom: 10px;\n}\n.submitted_timestamp {\n  font-size: 12px;\n  color: #6d6d6d;\n  float: left;\n  margin-top: 5px;\n}\n.my-forms-tag {\n  display: block;\n  clear: both;\n  padding: 2px 6px;\n  border-radius: 100px;\n  font-size: 80%;\n  margin-top: 5px;\n  margin-bottom: 2.5px;\n  float: left;\n}\n.my-forms-tag.returned {\n  background: #ffebce;\n}\n.my-forms-tag.in-progress {\n  background: #e0edff;\n}\n.my-forms-tag.done {\n  background: #dbf2e4;\n}\n.my-forms-tag.unavailable {\n  background: #ffe0e0;\n}\n.badge {\n  font-weight: 600;\n  display: inline-block;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n.badge-primary {\n  color: #fff;\n  background-color: #007bff;\n}\n.badge-light {\n  border: 1px solid #dee2e6;\n}\ndiv .nav-tabs {\n  margin-right: 0;\n}\n.nav-tabs > li > .nav-link {\n  border: none;\n  border-bottom: 3px solid transparent;\n}\n.nav-tabs > li > .nav-link.active,\n.nav-tabs > li > .nav-link.active:hover,\n.nav-tabs > li > .nav-link.active:focus {\n  border-bottom: 3px solid #466db2;\n  background-color: #fff;\n  border-radius: 0;\n  color: #466db2 !important;\n  border-bottom-color: #466db2 !important;\n}\n/*.nav-tabs > li.active > .nav-link.show {\n    border-bottom-color: transparent;\n}\n\n.nav-tabs > li.active > .nav-link,\n.nav-tabs > li.active > .nav-link:hover,\n.nav-tabs > li.active > .nav-link:focus {\n    border-bottom: 3px solid @focus;\n    background-color: #fff;\n    border-radius: 0;\n    color: @focus !important;\n    border-bottom-color: @focus !important;\n\n    .badge {\n        background-color: #333;\n    }\n}*/\n.nav-tabs > li {\n  margin-bottom: -1px;\n}\n.nav-tabs > li > .nav-link,\n.nav-tabs > li > .nav-link:hover {\n  color: inherit;\n  margin-right: 0;\n  background-color: transparent;\n}\n#myFormsDiv {\n  max-height: 495px;\n  overflow: auto;\n}\n#myFormsDiv ul {\n  padding-left: 20px;\n}\n#myFormsDiv li {\n  margin-bottom: 10px;\n}\n.navbar-dark .navbar-nav > li.login > a img,\n.navbar-dark .navbar-nav > li.login.dropdown > a img {\n  height: 20px;\n  margin-right: 5px;\n}\n.navbar-dark .navbar-nav > li > a,\n.navbar-dark .navbar-nav > li > a:hover,\n.navbar-dark .navbar-nav > li > a:focus {\n  color: #fff;\n  background: transparent;\n}\n.navbar-dark .navbar-nav > li .dropdown-menu {\n  background-color: #2b2b2b;\n  border: 0;\n  left: auto;\n  right: 0;\n}\n.navbar-dark .navbar-nav > li .dropdown-menu > li > a {\n  color: #fff;\n  /*text-transform: uppercase;*/\n}\n.nav .open > a,\n.nav .open > a:hover,\n.nav .open > a:focus {\n  border-color: transparent;\n}\n.help-block {\n  color: #717171;\n  font-size: 13px;\n}\n/*----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/\n/* ------------------------\n FOOTER\n------------------------ */\n#demo {\n  width: 600px;\n  padding-top: 5px;\n  margin-left: 10px;\n  float: left;\n}\n#demo a,\na.visited,\na.hover {\n  text-decoration: none;\n  border: none;\n}\n#footer {\n  background: #2b2b2b;\n  color: rgba(255, 255, 255, 0.9);\n  width: 100%;\n}\n#footer ul {\n  padding: 24px 20px;\n  list-style-type: none;\n  text-align: center;\n  list-style: none outside none;\n  z-index: 11;\n  bottom: 0px;\n  margin: 0px auto;\n  flex: auto;\n  display: inline;\n}\n#footer ul li {\n  margin: 0 5px;\n  display: inline-block;\n  color: #e2d5b4;\n}\n#footer ul li a {\n  background: none;\n  color: #fff;\n  letter-spacing: normal;\n  font-size: 12px;\n}\n#footer ul li:first-of-type {\n  margin-left: 0;\n}\n#footer ul li:last-of-type {\n  margin-right: 0;\n}\n#footer ul li:hover {\n  background: none;\n  color: #e2d5b4;\n}\n#footer > a {\n  margin-left: auto;\n  max-height: 48px;\n  border: none;\n}\n.mi-footer-logo {\n  height: 35px;\n  margin-top: -6px;\n}\n.accessgov-footer-logo {\n  height: 45px;\n  margin-top: -10px;\n}\n.visible-xs-inline-block {\n  display: none;\n}\n.my-forms-backdrop {\n  background: rgba(0, 0, 0, 0.5);\n  height: 100vh;\n  width: 100%;\n  z-index: 999;\n}\n.index-logo {\n  height: 150px;\n  margin: 10px auto;\n  max-width: 100%;\n}\n.public-page-body .tile {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.public-page-body .body-content {\n  padding: 0 5px;\n}\n@media (max-width: 767px) {\n  body {\n    padding-top: 60px;\n    background-image: none;\n    padding-bottom: 0 !important;\n  }\n  .body-content {\n    margin-top: 0;\n    padding-top: 0;\n  }\n  .transitions-after-load .body-content {\n    height: 100vh;\n  }\n  .nav .dropdown {\n    position: static;\n  }\n  .dropdown-menu {\n    position: static;\n    box-shadow: none;\n  }\n  .notificationBarTop {\n    /*margin-top: -10px;*/\n    margin-bottom: 0;\n  }\n  #footer {\n    position: static;\n    text-align: center;\n    height: auto;\n    /*margin-top: 25px;*/\n    padding: 15px 0;\n    display: block;\n  }\n  #footer ul {\n    display: block;\n    width: 90%;\n  }\n  #footer ul li {\n    display: block;\n    margin-left: 0;\n    margin-right: 0;\n  }\n  #footer ul li a:link,\n  #footer ul li a {\n    /*background: @primary-light;*/\n    float: none;\n    margin: 0.5em 0px;\n    padding: 1.2em 0 1.2em;\n    height: auto;\n    display: block;\n    margin-bottom: 5px;\n    /*color: #fff;*/\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n  #footer ul li a:link:hover,\n  #footer ul li a:hover {\n    background: #eee !important;\n    text-decoration: underline;\n    color: #2b2b2b;\n  }\n  #footer ul li:hover a {\n    background: #454545;\n  }\n  #questionsDiv {\n    height: auto;\n    padding-bottom: 0;\n    position: relative;\n  }\n  .form-control {\n    max-width: none;\n  }\n  .visible-xs-inline-block {\n    display: inline-block !important;\n  }\n  .have_not_searched {\n    background-position: center center;\n    background-size: 150px;\n    padding-top: 30px;\n  }\n  /*.dfNavButton:not(.dfNavRemoveButton) {\n        display: block;\n        width: 100%;\n        margin-bottom: 5px;\n    }*/\n  .dropdown-toggle {\n    width: 100%;\n  }\n  .pane-size-toggle {\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg);\n    margin-top: -8px !important;\n    margin-right: 0 !important;\n  }\n  .navbar-dark {\n    padding: 13px 5px;\n  }\n  .navbar-dark a.search-toggle,\n  .navbar-dark a.search-toggle:hover,\n  .navbar-dark a.search-toggle:focus {\n    float: right;\n    color: #ffffff;\n    opacity: 0.8;\n    padding: 0 10px;\n  }\n  .navbar-dark a.search-toggle .icon,\n  .navbar-dark a.search-toggle:hover .icon,\n  .navbar-dark a.search-toggle:focus .icon {\n    display: block;\n    margin-top: 2px;\n  }\n  .navbar-dark .navbar-brand {\n    width: min-content;\n    margin: 0 auto;\n  }\n  .navbar-dark .navbar-brand img {\n    height: 33px;\n  }\n  .navbar-dark .navbar-brand .brand-letters {\n    margin-left: 3px;\n  }\n  .navbar-dark .navbar-brand .brand-letters img {\n    height: 15px;\n  }\n  .navbar-dark .navbar-toggler,\n  .navbar-dark .navbar-toggler:focus,\n  .navbar-dark .navbar-toggler:hover {\n    background: #2b2b2b;\n    border: none;\n    box-shadow: none;\n    padding: 0.25rem 0.75rem 0.5rem 0.75rem;\n    /*.navbar-toggler-icon {\n                width: 20px;\n                height: 20px;\n            }*/\n  }\n  .search-backdrop,\n  .my-forms-backdrop {\n    padding: 5px 15px;\n    height: 150vh;\n  }\n  .search-backdrop .close {\n    font-size: 1.4em;\n    top: 15px;\n    right: 15px;\n  }\n  .search-backdrop .close img {\n    height: 15px;\n  }\n  .search-backdrop .search-form-wrapper {\n    position: static;\n    margin-top: 40px;\n    width: 100%;\n  }\n  .navbar-dark .navbar-nav > .vr {\n    display: none;\n  }\n  .navbar-dark .form-group.search-group .search-control {\n    width: 100% !important;\n  }\n  .navbar-dark .navbar-left {\n    margin-left: 0;\n    margin-right: -15px;\n  }\n  .navbar-dark .navbar-nav > li {\n    padding: 0 7px;\n  }\n  .navbar-dark .icon-search {\n    font-size: 1.4em;\n  }\n  #collapse2 {\n    padding: 8px;\n    overflow-x: hidden;\n  }\n  .nav-search-results {\n    position: relative;\n    width: calc(100% - 30px);\n    z-index: 10000;\n    max-height: calc(100vh - 150px);\n    /*background: #fff;\n        margin-top: 0;\n        padding: 0;\n        border: 1px solid #ddd;\n        box-shadow: 0 2px 6px 1px rgba(0,0,0,.25);\n        overflow: auto;*/\n  }\n  .nav-search-results .nav-search-results-inner {\n    padding: 15px;\n    position: relative;\n    height: auto;\n    width: 100%;\n  }\n  .nav-search-results .nav-search-results-caption {\n    position: absolute;\n    top: 5px;\n    right: 10px;\n    display: inline-block;\n    color: #717171;\n    font-size: 11px;\n  }\n  .nav-search-results .result {\n    padding-top: 5px;\n    letter-spacing: normal;\n    font-size: 13px;\n  }\n  .nav-search-results .result:first-of-type {\n    padding-top: 10px;\n  }\n}\n@media (min-width: 768px) {\n  body,\n  label,\n  .btn,\n  .form-control {\n    font-size: 15px;\n  }\n  .navbar-dark {\n    height: 70px;\n  }\n  .navbar-dark .navbar-brand {\n    pointer-events: none;\n  }\n  .public-page-body .body-content {\n    padding: 0;\n  }\n  .index-content {\n    padding: 15px;\n  }\n  .returning_user {\n    margin: 0;\n  }\n  .mi-footer-logo {\n    float: right;\n  }\n  .lead {\n    font-size: 16px;\n  }\n  .accessgov-footer-logo {\n    float: left;\n  }\n  .my-forms-backdrop {\n    display: none;\n  }\n  #collapse2 {\n    margin-right: 10px;\n  }\n  .navbar-inverse .navbar-nav > li .dropdown-menu {\n    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);\n  }\n}\n@media (max-width: 991px) {\n  .img-responsive {\n    /* account for large homepage images to be responsive on mobile devices */\n    max-width: 100%;\n    height: auto !important;\n  }\n}\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: 992px) {\n  .lead {\n    font-size: 17px;\n  }\n  .index-container {\n    flex-direction: row;\n    min-height: calc(100vh - 70px);\n  }\n  .index-container .index-content {\n    flex: 1;\n  }\n  .index-container .returning_user {\n    flex: 0 0 375px;\n    border-top: none;\n    border-right: 1px solid #ccc;\n    overflow: auto;\n  }\n  .body-content {\n    min-height: calc(100vh - 70px);\n  }\n}\n@media (min-width: 1200px) {\n  .have_not_searched {\n    background-position: center 40%;\n  }\n}\n@media print {\n  .no_print,\n  #footer,\n  .btn {\n    display: none !important;\n  }\n}\n.no-bg {\n  background: #fff;\n  padding-bottom: 0;\n  margin-bottom: 0;\n  padding-top: 70px;\n  padding-bottom: 60px;\n  height: 100vh;\n}\nimg.bg {\n  min-height: 100%;\n  min-width: 1024px;\n  width: 100%;\n  height: auto;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n/* Override the default bootstrap behavior where horizontal description lists\n   will truncate terms that are too long to fit in the left column\n*/\n.dl-horizontal dt {\n  white-space: normal;\n}\n/* ------------------------\n GENERAL STYLES\n------------------------ */\n.body-content-fluid {\n  padding: 15px;\n}\nh1 {\n  margin-bottom: 20px;\n}\nh3 {\n  margin-top: 15px;\n}\nb,\nstrong {\n  font-weight: 600;\n}\n.inline-block {\n  display: inline-block;\n}\n.indent {\n  padding-left: 45px;\n}\n.alert p:last-child {\n  margin-bottom: 0;\n}\n.width-auto {\n  width: auto;\n}\n.scroll-y {\n  overflow-y: auto;\n}\n.scroll-x {\n  overflow-x: auto;\n}\n.well {\n  background: #eee;\n  border-radius: 0;\n  border: 0;\n  margin-top: 10px;\n  box-shadow: none;\n}\n.well ul:last-of-type,\n.well p:last-of-type {\n  margin-bottom: 0;\n}\n.breadcrumb {\n  background: #fff;\n  padding: 0;\n  padding-bottom: 3px;\n  border-bottom: 1px solid #ddd;\n  border-radius: 0;\n}\n.breadcrumb > li + li:before {\n  padding: 0 3px;\n  color: #666666;\n}\na.tile {\n  color: #444;\n}\n.btn-outline-danger {\n  color: #d42435;\n}\n.btn-outline-success {\n  color: #1e7e34;\n}\n.tile:not(.form_intro) h2 {\n  /*margin-top: 0;*/\n  /*padding-bottom: 5px;*/\n  /*border-bottom: 1px solid #eee;*/\n}\n.well > h3 {\n  margin-top: 0;\n}\n.add-new-row .btn {\n  display: block;\n  width: 100%;\n  border-radius: 0;\n  box-sizing: border-box;\n  margin-top: 3px;\n  /* for active outline */\n}\n.add-new-row .btn:not(:focus):not(:hover) {\n  background: #ffffff;\n  border-color: #dddddd;\n}\n#DataSourceTable .btn:hover,\n#DataSourceTable .btn:focus {\n  box-shadow: inset 0 0 0 1px #3471bb;\n  border-color: #3471bb;\n}\n.action-success-icon,\n.action-failure-icon {\n  float: left;\n  margin-right: 5px;\n}\n.action-success-text,\n.action-failure-text {\n  margin: 0;\n  font-weight: bold;\n}\n.action-success-text,\n.action-success-icon {\n  color: #008000;\n}\n.action-failure-text,\n.action-failure-icon {\n  color: #800000;\n}\n.optional:after {\n  content: \" (Optional)\";\n  color: #737373;\n}\n.plus-sign {\n  color: #1e7e34;\n  font-size: 1.25em;\n  margin-top: -3px;\n  display: inline-block;\n  vertical-align: baseline;\n  line-height: normal;\n}\n*:disabled .plus-sign {\n  color: #666666;\n}\n.btn-outline-secondary:hover .icon-trash {\n  color: #fff;\n}\n.btn:hover:disabled .plus-sign {\n  color: #666666;\n}\n.btn:hover .plus-sign {\n  color: #ffffff;\n}\n.btn:disabled .icon-trash,\nbutton:disabled .icon-trash {\n  color: inherit;\n}\n.icon-trash {\n  color: #d64343;\n}\n.pull-left {\n  float: left;\n}\n[disabled=\"disabled\"],\n.disabled img:hover {\n  cursor: not-allowed !important;\n}\n.disabled {\n  pointer-events: none;\n  cursor: default;\n}\nhr {\n  border-color: #dddddd;\n}\n.v--modal-overlay {\n  z-index: 1002;\n}\n.modal-content {\n  border: none;\n  max-height: 100vh;\n  overflow-y: auto;\n}\n.modal .loading {\n  height: 50px;\n}\n.modal-title {\n  margin: 0;\n}\n.modal-footer {\n  display: block;\n  text-align: center;\n}\n.address-field {\n  margin-bottom: 10px;\n}\n.card-header,\n.list-group-item {\n  background-color: transparent;\n  color: inherit;\n}\n.card-body {\n  background: #f5f5f5;\n}\n.card-body .table {\n  margin-bottom: 0;\n}\n.clickable-element,\na {\n  cursor: pointer;\n}\n/* --------------------------------------------------------------------\n    DATEPICKER\n-------------------------------------------------------------------- */\n.ui-state-default,\n.ui-widget-content .ui-state-default,\n.ui-widget-header .ui-state-default,\n.ui-button,\nhtml .ui-button.ui-state-disabled:hover,\nhtml .ui-button.ui-state-disabled:active {\n  background: #fff;\n  border-color: transparent;\n  text-align: center;\n  width: 30px;\n  color: #0071bc;\n  padding: 5px 0;\n  border-radius: 2px;\n}\n.ui-state-highlight,\n.ui-widget-content .ui-state-highlight,\n.ui-widget-header .ui-state-highlight {\n  background: #eee;\n}\n.ui-state-active,\n.ui-widget-content .ui-state-active,\n.ui-widget-header .ui-state-active,\na.ui-button:active,\n.ui-button:active,\n.ui-button.ui-state-active:hover {\n  border-color: #466db2;\n}\n.ui-datepicker .ui-datepicker-next,\n.ui-datepicker .ui-datepicker-prev {\n  cursor: pointer;\n}\n.ui-widget-header {\n  border: none;\n  border-radius: 0;\n  background: #f1f1f1;\n}\n.ui-datepicker table thead {\n  text-transform: uppercase;\n  font-size: 0.8em;\n  color: #666;\n  background: #f1f1f1;\n}\n.ui-datepicker-trigger {\n  height: 20px;\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  cursor: pointer;\n}\n.ui-datepicker .ui-datepicker-title {\n  color: #555;\n}\n.ui-datepicker .ui-datepicker-prev span,\n.ui-datepicker .ui-datepicker-next span {\n  display: none !important;\n}\n.ui-datepicker .ui-datepicker-prev,\n.ui-datepicker .ui-datepicker-prev:hover {\n  background: url(\"../images/prev.png\") center center no-repeat;\n  background-size: 8px;\n  left: 2px;\n  top: 2px;\n}\n.ui-datepicker .ui-datepicker-next,\n.ui-datepicker .ui-datepicker-next:hover {\n  background: url(\"../images/next.png\") center center no-repeat;\n  background-size: 8px;\n  right: 2px;\n  top: 2px;\n}\n#ui-datepicker-div {\n  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.3);\n  border-radius: 5px;\n  border: none;\n  z-index: 10 !important;\n  /*override inline z-index*/\n}\n#ui-datepicker-div .ui-priority-secondary,\n#ui-datepicker-div .ui-widget-content .ui-priority-secondary,\n#ui-datepicker-div .ui-widget-header .ui-priority-secondary {\n  opacity: 1;\n}\n.index-heading {\n  margin-top: 20px;\n  font-size: 24px;\n}\n/* ------------------------\n VALIDATION\n------------------------ */\n.validation-summary-errors {\n  margin-bottom: 15px;\n}\n.validation-summary-errors ul {\n  list-style: none;\n  margin: auto;\n  vertical-align: middle;\n  margin-bottom: 0;\n  padding-left: 0;\n}\n.validation-summary-errors ul li {\n  color: #b94a48;\n}\n.required {\n  color: #b94a48;\n}\n/*#region ADMIN*/\n/* ------------------------\n GUIDED QUESIONS\n------------------------ */\n.gq_error_message {\n  color: #d01022;\n  margin-right: 15px;\n  /*border: 1px solid red;\n    padding: 3px 8px;*/\n}\n.gq_maincontent {\n  height: 200px;\n  font-size: 0.9em;\n}\n.gq_maincontent textarea,\n.gq_maincontent .htmlContent {\n  height: 182px;\n}\n.gq_maincontent .htmlContent {\n  border: 1px dashed #dddddd;\n  overflow: hidden;\n  /* Because we want encourage shorter content */\n}\n.gq_container {\n  overflow: auto;\n  width: 100%;\n  margin: 0;\n  position: relative;\n}\n.gq_container > h2 {\n  padding: 0;\n  margin: 0 0 9px 0;\n}\n.gq_container .gq_box_container {\n  position: relative;\n}\n.gq_container .gq_box_container,\n.gq_container .gq_top_container,\n.gq_container .gq_bottom_container {\n  height: calc(100vh - 400px);\n}\n.gq_container .gq_top_container,\n.gq_container .gq_bottom_container {\n  top: 0;\n}\n.gq_container .gq_top_container {\n  background: #f5f5f5;\n  border: 1px solid #ddd;\n  width: 100%;\n  overflow: auto;\n  padding-right: 475px !important;\n  z-index: 0;\n}\n.gq_container .gq_top_container svg {\n  white-space: nowrap !important;\n}\n.gq_container .gq_top_container.is_editing {\n  width: calc(100% - 400px);\n  padding-right: 0 !important;\n}\n.gq_editor_controls {\n  position: fixed;\n  background: #fff;\n  padding: 10px 15px 0 15px;\n  right: 16px;\n  width: 398px;\n  margin-top: -60px;\n  z-index: 1000;\n}\n.gq_editor_controls .btn {\n  margin-bottom: 0;\n  /*float: left;*/\n}\n.gq_editor_controls .close {\n  position: absolute;\n  right: 15px;\n  padding: 0;\n}\n.gq_editor_controls .close:hover {\n  color: #444;\n}\n.gq_editor_controls .change-text {\n  float: left;\n  padding: 7px 0;\n}\n.gq_bottom_container {\n  background: #fff;\n  z-index: 999;\n  display: block;\n  position: absolute;\n  padding-top: 60px;\n  width: 400px;\n  height: calc(100vh - 120px);\n  bottom: 0;\n  right: 0;\n  border: 1px solid #ddd;\n  overflow-y: auto;\n}\n.gq_bottom_container .gq_bottom_container_top {\n  position: fixed;\n  width: 398px;\n  background: #fff;\n  padding: 10px 0 5px 0;\n  z-index: 1000;\n  box-shadow: 0 1px 8px 0 #fff;\n}\n.gq_bottom_container .form-group {\n  margin-bottom: 10px;\n}\n.gq_bottom_container .form-group label {\n  top: 0 !important;\n  left: 2px !important;\n}\n.gq_bottom_container .selected {\n  border-left: 4px solid #466db2;\n}\n.gq_bottom_container .list-group-item:not(.selected) a {\n  color: inherit;\n}\n.gq_bottom_container .list-group-item:not(.selected):hover {\n  border-left: 4px solid #dddddd;\n}\n.overflow-y-auto {\n  overflow-y: auto !important;\n  overflow-x: hidden;\n}\n#endpointEditor .panel {\n  border-radius: 0;\n  /*border-left: 8px solid transparent;*/\n}\n#endpointEditor .panel .panel-heading strong {\n  color: #234d7f;\n}\n.node-name {\n  margin-bottom: 0;\n}\n#zoomInAndOut {\n  z-index: 501 !important;\n  position: absolute;\n}\n.web_details_section h3 {\n  border-bottom: 1px solid #eee;\n  padding-bottom: 3px;\n}\n/*Template Nodes*/\n#gqTemplateNodes {\n  display: none !important;\n}\n.gq_node {\n  background: #fff;\n  font-size: 0.9em;\n  padding: 0;\n  white-space: nowrap !important;\n  overflow: hidden;\n  border: none;\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);\n  border-radius: 3px;\n  color: #444;\n}\n.gq_node.error {\n  box-shadow: 0 1px 6px 0 rgba(200, 0, 0, 0.75);\n}\n.gq_node.error .node_body {\n  background: #ffecec;\n}\n.gq_node a {\n  color: #444;\n}\n.gq_node > div {\n  display: flex !important;\n}\n.gq_node.error {\n  border-color: red;\n}\n.selected_node {\n  border-color: dodgerblue;\n}\n.node_addon {\n  display: block;\n  height: 32px;\n  overflow: hidden;\n  width: 40px;\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\n  text-align: center;\n  vertical-align: super;\n  padding: 7.5px;\n  padding: 5px 8px;\n  background-image: url(\"../images/endpoint.png\");\n  background-repeat: no-repeat;\n  background-position: center center;\n  color: #fff;\n}\n.node_addon .plus-sign {\n  margin-top: 0;\n}\n.node_body {\n  text-align: center;\n  height: 32px;\n  padding: 5px 8px;\n  display: block;\n  overflow: hidden;\n  width: auto;\n}\n.node_body a {\n  color: #466db2;\n}\n.gq_node .node_body:hover {\n  cursor: pointer;\n  background: #f5f5f5;\n  text-decoration: none;\n}\n.node_body.long {\n  box-shadow: -10px 0 15px -10px inset;\n}\n.color-indicators {\n  display: inline-block;\n  vertical-align: middle;\n}\n.color-indicators span {\n  height: 12px;\n  width: 12px;\n  display: inline-block;\n  border-radius: 6px;\n  margin-left: 3px;\n}\n.color-indicators span:first-of-type {\n  margin-left: 5px;\n}\n.color-indicators [data-indicator=\"webForm\"] {\n  background: #389de4;\n}\n.color-indicators [data-indicator=\"pdfForm\"] {\n  background: #d6504f;\n}\n.color-indicators [data-indicator=\"link\"] {\n  background: #c063e6;\n}\n.color-indicators [data-indicator=\"contact\"] {\n  background: #2ab95c;\n}\n.color-indicators [data-indicator=\"content\"] {\n  background: #eaa030;\n}\n.gq_question_node {\n  display: block;\n}\n.gq_question_node .node_addon {\n  background: #333333;\n  font-size: 1.4em;\n  padding: 0;\n}\n.gq_linked_question_node {\n  display: block;\n}\n.gq_linked_question_node .node_addon {\n  background: #333333;\n  font-size: 1.4em;\n  padding: 0;\n}\n.gq_answer_node {\n  display: block;\n}\n.gq_answer_node .node_addon {\n  background: #d4d4d4;\n  font-size: 1.6em;\n  padding: 0;\n  color: #202020;\n}\n.gq_web_node {\n  display: block;\n}\n.gq_web_node .node_addon {\n  background-color: #389de4 !important;\n}\n.gq_pdf_node {\n  display: block;\n}\n.gq_pdf_node .node_addon {\n  background-color: #d6504f;\n}\n/*.gq_pdf_node.gq_web_node {\n    .node_addon {\n        background-image: url(\"../images/endpoint.png\"), linear-gradient(@pdf-red 50%, @button-color 50%);\n        background-repeat: no-repeat;\n        background-position: center center;\n    }\n}*/\n.gq_link_node {\n  display: block;\n}\n.gq_link_node .node_addon {\n  background-color: #c063e6;\n}\n.gq_link_node.gq_pdf_node {\n  display: block;\n}\n.gq_link_node.gq_pdf_node .node_addon {\n  background-color: #1496b6;\n}\n.gq_contact_node {\n  display: block;\n}\n.gq_contact_node .node_addon {\n  background-color: #2ab95c;\n  font-size: 1.2em;\n}\n.gq_contact_node .node_addon span {\n  vertical-align: top;\n}\n.gq_content_node {\n  display: block;\n}\n.gq_content_node .node_addon {\n  background-color: #eaa030;\n  font-size: 1.3em;\n}\n.gq_content_node .node_addon span {\n  vertical-align: top;\n}\n#GuidedSearchContainer {\n  padding-top: 10px;\n}\n/* ------------------------\n Admin Endpoint Creator\n------------------------ */\n#formUploadAccordion {\n  border: none;\n}\n#formUploadAccordion .panel-default {\n  border: none;\n}\n#formUploadAccordion .panel-default .panel-heading {\n  background: #fff;\n}\n#formUploadAccordion .panel-default .panel-heading .edit {\n  margin-left: 5px;\n  cursor: pointer;\n}\n#formUploadAccordion .panel-default:last-of-type .card-body {\n  border-bottom: 1px solid #ddd;\n}\n#formUploadAccordion .form_upload_type > input {\n  visibility: hidden;\n  position: absolute;\n}\n#formUploadAccordion .form_upload_type > input + img {\n  cursor: pointer;\n  border: 1px solid transparent;\n  padding: 7.5px;\n  border-radius: 4px;\n}\n#formUploadAccordion .form_upload_type > input:checked + img {\n  border-color: dodgerblue;\n}\n#formUploadAccordion .qualified_question {\n  border-top: 1px solid #eee;\n  margin-top: 10px;\n  padding-top: 10px;\n}\n.panel_header {\n  display: inline-block;\n  font-size: 1.7em;\n  border: none;\n  padding: 0 !important;\n  margin: 0;\n}\n.step_header {\n  display: inline-block;\n  text-align: center;\n  color: #fff !important;\n  background: #444;\n  width: 35px;\n  height: 35px;\n  vertical-align: baseline;\n  margin-right: 10px;\n  border-radius: 50%;\n  padding-top: 2px;\n}\n#wysiwyg_ifr {\n  min-height: 300px;\n}\n#formUploadAccordion .form_upload_type > input + img {\n  height: 100px;\n  padding: 5px;\n}\n/*#endregion*/\n.panel-default .panel-heading.is_hidden {\n  background: #eee;\n}\n.panel-default .panel-heading.is_hidden strong {\n  color: #000000;\n}\n.panel-default .panel-heading.is_hidden .is_hidden_text {\n  color: #000000;\n  font-weight: bold;\n  font-style: italic;\n  float: right;\n}\n[class*=\"cke_editor\"] {\n  margin-bottom: 15px !important;\n}\ntextarea.cke_source,\n.cke_editable {\n  font-weight: normal;\n}\n.admin_directory_additional_content_box,\n.admin_directory_qualifying_questions_box {\n  max-height: 300px;\n  overflow: auto;\n  border: 1px solid #ddd;\n  padding: 15px;\n  margin-bottom: 10px;\n}\n#submitFormEntry .btn:last-child {\n  margin-left: 5px;\n}\n.directory_accordion .card-body .btn:not(:last-child) {\n  margin-right: 5px;\n}\n/* ------------------------\n MENU\n------------------------ */\n.admin-card {\n  display: block;\n  position: relative;\n  top: 0;\n  padding: 15px;\n  box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.25);\n  border: none;\n  text-align: center;\n  transition: all ease 0.25s;\n}\n.admin-card .admin-icon {\n  color: #234d7f;\n  font-size: 95px;\n  vertical-align: middle;\n}\n.admin-card .admin-icon:before {\n  display: block;\n  margin: 30px auto 5px auto;\n}\n.admin-card .card-text {\n  color: #212529;\n  margin-top: 10px;\n}\n.admin-card .caption-heading {\n  display: inline-block;\n  /*font-weight: 600;*/\n  font-size: 1.2em;\n  margin-top: 10px;\n  color: #234d7f;\n}\n.admin-card:focus,\n.admin-card:hover {\n  top: -4px;\n  text-decoration: none;\n  box-shadow: 0 6px 25px 0 rgba(0, 0, 0, 0.25);\n}\n.admin-card:focus .admin-icon,\n.admin-card:hover .admin-icon,\n.admin-card:focus .caption-heading,\n.admin-card:hover .caption-heading {\n  color: #3e7eca;\n}\n/* ------------------------\n SUBMISSIONS\n------------------------ */\n.editable-container .editable-click,\n.editable-container a.editable-click,\n.editable-container a.editable-click:hover {\n  color: inherit;\n  border-bottom: none;\n}\n.editable-container .editable-buttons {\n  position: absolute;\n  margin-left: 0;\n}\n.editable-container .editable-buttons .editable-submit,\n.editable-container .editable-buttons .editable-cancel {\n  padding: 0 3px;\n  margin-left: 3px;\n}\n.editable-container .editable-input {\n  margin-top: -4px;\n}\n.editable-container .editable-input input,\n.editable-container .editable-input select {\n  padding: 0;\n}\n.table-sm {\n  font-size: 0.875rem;\n}\n.table-sm th,\n.table-sm td {\n  vertical-align: middle;\n}\n.table .editable-td,\n.table-sm .editable-td {\n  padding-bottom: 0;\n}\n.inline-edit-field {\n  color: inherit;\n  border-bottom: none !important;\n}\n.submissions-vr {\n  display: inline;\n  border-left: 1px solid #dee2e6;\n  margin-left: 15px;\n  margin-right: 15px;\n  vertical-align: middle;\n  height: 20px;\n}\n.submissions-bulk-input {\n  max-width: 170px;\n}\n.submissions-bulk-btn {\n  padding: 0;\n}\n.submissions-bulk-btn .icon-trash {\n  margin-top: -8px;\n  display: block;\n}\n.delete-submissions:focus,\n.delete-submissions:hover {\n  text-decoration: none;\n}\n.submissions-left-col,\n.submissions-right-col {\n  padding: 0 15px;\n  width: 100%;\n}\n.submissions-left-col {\n  background: whitesmoke;\n  overflow: auto;\n}\n.submissions-left-col .help-block {\n  white-space: nowrap;\n}\n.submissions-left-col .comment-card {\n  border: none;\n  padding: 0;\n  margin: 0;\n}\n.no-form-comments .submissions-left-col {\n  width: 0;\n}\n.no-form-comments .submissions-right-col {\n  width: 100%;\n}\n.has-form-comments {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.has-form-comments .submissions-left-col,\n.has-form-comments .submissions-right-col {\n  overflow: auto;\n}\n.has-form-comments .submissions-right-col {\n  padding-left: 0;\n  padding-right: 0;\n  padding-bottom: 30px;\n}\n.submissions-bulk-options {\n  display: inline;\n  width: calc(100% - 100px);\n}\n.submissions-actions-td {\n  white-space: nowrap;\n  text-align: right;\n  width: 85px;\n}\n.submissions-actions-td .icon {\n  font-size: 1.1em;\n  vertical-align: middle;\n  line-height: 0;\n}\n.submissions-actions-td .icon:hover,\n.submissions-actions-td .icon:focus {\n  text-decoration: none;\n}\n.submissions-actions-td .icon-comment {\n  margin: 0;\n}\n.submissions-comment-count {\n  font-size: 0.9em;\n  vertical-align: baseline;\n  line-height: 0;\n}\n.form-control-review {\n  width: auto;\n  display: inline;\n}\n.pdf-inline {\n  display: inline;\n  display: table;\n  float: left;\n  margin-bottom: 5px;\n}\n.display-label,\n.display-value {\n  display: table-cell;\n  padding: 0;\n  margin: 0;\n  padding-right: 5px;\n  text-align: left;\n  vertical-align: top;\n  float: left;\n}\n.display-label {\n  font-weight: bolder;\n  font-size: 1em;\n}\n.display-value {\n  word-break: break-word;\n}\n.calculated-list-item {\n  display: block;\n}\n/* fix formatting issue for display elements on review pages */\n.display-element-container .form-group {\n  max-width: 100%;\n}\n/*----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/\n/*#region PUBLIC*/\n/* ------------------------\n DYNAMIC FORMS\n------------------------ */\n.df-public-nav .list-group-item {\n  -webkit-transition: all ease 0.25s;\n  transition: all ease 0.25s;\n}\n.df-public-nav .list-group-item .icon {\n  display: none;\n}\n.df-page-title {\n  display: none;\n  margin-top: 0;\n  margin-left: 0;\n  border-left: 0;\n  font-size: 18px;\n  padding-left: 0;\n}\n.dfForEachItem .dfNavRemoveButton {\n  background-color: transparent;\n  position: absolute;\n  right: 0;\n  top: -7px;\n  padding: 0 10px;\n  color: #d42435;\n  font-size: 1.5em;\n}\n.dfForEachItem.row {\n  margin-left: 0;\n  margin-right: 0;\n}\n.defDiv {\n  /*.settingDiv {\n        background: @cream;\n    }*/\n}\n.defDiv .defHeader {\n  background: #2b2b2b;\n  background-color: #2b2b2b;\n  border-bottom: 1px solid #050505;\n}\n.defDiv .settingHeader {\n  display: none;\n}\n.defDiv *[data-df-type=\"AddChildButton\"] {\n  background: #2b2b2b;\n  background-color: #2b2b2b;\n  color: #70b85d;\n}\n.defDiv *[data-df-type=\"AddChildButton\"]:hover {\n  background: #050505;\n  background-color: #050505;\n}\n.defDiv [data-df-type=\"NameOutput\"] {\n  color: #6edcff;\n}\n.defDiv .childrenDiv,\n.defDiv .form {\n  border-color: #050505;\n}\n.DFPageContent {\n  margin-left: 0;\n  margin-right: 0;\n  /*.{\n        padding: 0;\n    }*/\n}\n.DFPageContent .checkbox:only-of-type [type=\"checkbox\"][data-val-required]:before,\n.DFPageContent .checkbox-inline:only-of-type [type=\"checkbox\"][data-val-required]:before {\n  color: #d64343;\n  margin-top: -3px;\n  margin-left: -12px;\n  font-weight: bold;\n  vertical-align: text-top;\n  content: \" *\";\n  display: inline-block;\n}\n.DFPageContent .col-sm-12.col-xs-offset-1 {\n  margin-left: 0;\n}\na.dfPageLink_Complete,\nbutton[type=\"submit\"].dfPageLink_Complete {\n  background-image: url(\"../images/success.png\");\n  background-size: 17px;\n  background-position: 7px center;\n}\na.dfPageLink_Invalid,\nbutton[type=\"submit\"].dfPageLink_Invalid {\n  background-image: url(\"../images/warning.png\");\n  background-size: 17px;\n  background-position: 7px center;\n}\na.dfPageLink_Disabled,\nbutton[type=\"submit\"].dfPageLink_Disabled {\n  background-color: #f0f0f0 !important;\n}\na.dfPageLink_InProgress,\nbutton[type=\"submit\"].dfPageLink_InProgress {\n  background-image: url(\"../images/in_progress.png\");\n  background-size: 10px;\n  background-position: 11px center;\n  background-color: #ddd !important;\n  color: #444 !important;\n  border-color: #bbb !important;\n}\na.dfPageLink_Saving,\nbutton[type=\"submit\"].dfPageLink_Saving {\n  background-image: url(\"../images/Spinner-1s-16px.gif\");\n  background-size: 17px;\n  background-position: 7px center;\n}\n.list-group-item {\n  word-break: break-word;\n  text-decoration: none !important;\n  -webkit-transition: all ease 0.15s;\n  transition: all ease 0.15s;\n}\n.list-group-item a {\n  text-decoration: none !important;\n}\n.list-group-item.active,\n.list-group-item.active:hover,\n.list-group-item.active:focus {\n  background-color: #ffffff;\n  color: buttontext !important;\n  border-left-width: 5px !important;\n  border-left-style: solid !important;\n  border-color: #466db2;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.df-navigation-btn-container {\n  display: flex;\n  flex-wrap: wrap;\n}\n.df-navigation-btn-container .btn {\n  margin-bottom: 15px;\n  width: 100%;\n}\n.form_submit_success_buttons .btn:not(:last-of-type) {\n  margin-right: 5px;\n}\n.bs-docs-grid {\n  padding: 15px;\n}\n.bs-docs-grid .clearfix.alert-danger {\n  margin: auto !important;\n}\n.bs-docs-grid .clearfix.alert-danger .pull-left img {\n  display: none;\n}\n.select_element_page_children .btn {\n  height: auto;\n}\n.icon-with-text {\n  position: relative;\n  color: inherit;\n}\n.icon-with-text .icon-text {\n  opacity: 0;\n  background: #fff;\n  position: absolute;\n  top: -4ex;\n  right: 0;\n  border: 1px solid #999;\n  padding: 0 4px;\n  pointer-events: none;\n  z-index: 100;\n  white-space: nowrap;\n  -webkit-transition: opacity linear 0.15s;\n  transition: opacity linear 0.15s;\n  transition-delay: 0.25s;\n}\n.icon-with-text:hover,\n.icon-with-text:focus {\n  text-decoration: none;\n}\n.icon-with-text:hover .icon-text,\n.icon-with-text:focus .icon-text {\n  opacity: 1;\n  color: inherit;\n}\n/* ------------------------\n PUBLIC USER\n------------------------ */\n#welcomeDiv img {\n  max-width: 100%;\n  margin: 15px 0;\n}\n#welcomeDiv hr {\n  margin-left: -10px;\n  margin-right: -10px;\n  margin-top: 25px;\n  margin-bottom: 35px;\n}\n.search {\n  width: 100%;\n}\n.search .input-group {\n  margin: auto;\n  margin-bottom: 10px;\n  width: 300px;\n}\n.drop_target {\n  clear: both;\n}\n.page_title {\n  float: left;\n}\n.input-group-text {\n  font-size: inherit;\n}\na[data-toggle=\"popover\"],\n.list_items_toggle {\n  text-decoration: none !important;\n}\n.has-error .form-control,\n.panel-default .card-body .has-error .form-control {\n  border-color: #ca0706;\n}\n.has-error .help-block,\n.panel-default .card-body .has-error .help-block {\n  color: #a94442;\n}\n.select2-container--default.select2-container--focus .select2-selection--multiple,\n.select2-container--default.select2-container--focus .select2-selection--single,\n.select2 select2-container select2-container--default select2-container--below,\n.select2 select2-container select2-container--default,\n.select2-selection--single,\n.select2-selection--multiple,\n.select2-container--default {\n  height: 34px !important;\n  max-width: 100%;\n  border-radius: 0 !important;\n  border: none !important;\n  border-bottom: 2px solid #ddd !important;\n  border-color: #dddddd;\n  padding: 2px;\n  font-size: 14px;\n  background: none !important;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  -webkit-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n}\n.select2-container--default.select2-container--focus .select2-selection--multiple,\n.select2-container--default.select2-container--focus .select2-selection--single {\n  border-color: #466db2 !important;\n  outline: 0;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);\n}\n.select2-container {\n  border-radius: 0;\n  background: none !important;\n  border: none !important;\n}\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n  height: 32px !important;\n}\n.select2-container .select2-selection--single .select2-selection__rendered {\n  padding-left: 12px !important;\n  padding-top: 3px !important;\n}\n.dashboard_btn {\n  display: block;\n  border-radius: 2px;\n  text-align: center;\n  padding: 15px;\n  font-size: 1.2em;\n  text-decoration: none !important;\n  height: auto;\n}\n#formDirectoryBtn,\n.dashboard_btn {\n  color: #234d7f;\n  -webkit-transition: 0.1s all ease-in-out;\n  -moz-transition: 0.1s all ease-in-out;\n  -o-transition: 0.1s all ease-in-out;\n  transition: 0.1s all ease-in-out;\n}\n#formDirectoryBtn:hover {\n  color: #3471bb;\n  background: #f3f3f3;\n}\n#formDirectoryBtn a {\n  margin-top: 10px;\n  display: inline;\n  color: #234d7f;\n}\n.dashboard_btn span {\n  color: #444;\n  margin-top: 10px;\n  display: inline;\n}\n.dashboard_btn img {\n  height: 25px;\n  margin-right: 3px;\n  margin-top: 0;\n  display: inline;\n}\n#formDirectoryTile:hover,\n#formDirectoryBtn:hover,\n.dashboard_btn:hover {\n  text-decoration: none;\n}\n#formDirectoryTile img {\n  height: 75px;\n  margin: auto;\n  margin-top: 20px;\n  margin-bottom: 15px;\n}\n#formDirectoryTile {\n  font-size: 1.2em;\n}\n#homeSearchForm {\n  margin-top: 15px;\n}\n.has_results {\n  background: #fff;\n}\n.need_character:before {\n  content: \"Please enter at least 1 character to search.\";\n  font-size: 1.2em;\n  vertical-align: middle;\n}\n#questionsDiv {\n  position: relative;\n}\n#questionsDiv .radio {\n  margin-bottom: 7px;\n}\n.transitions-after-load * {\n  -webkit-transition: none !important;\n  -moz-transition: none !important;\n  -ms-transition: none !important;\n  -o-transition: none !important;\n}\n/* ------------------------\n ENDPOINT LANDING\n------------------------ */\n/*.form_intro {\n    padding-top: 15px;\n\n    .btn:not(:last-of-type) {\n        margin-right: 5px;\n    }\n}*/\n.form_type {\n  float: right;\n}\n.form_type img {\n  height: 45px;\n}\n.form_type img:not(:last-of-type) {\n  margin-right: -3px;\n}\n.form_intro h1 {\n  display: inline-block;\n  width: 100%;\n  /*border-bottom: 1px solid #eee;*/\n  margin-top: 0;\n  line-height: 100%;\n}\n.form_intro h1 .form_name {\n  display: none;\n  white-space: inherit;\n  width: auto;\n  vertical-align: baseline;\n  margin-right: 10px;\n}\n.form_intro h1 .form_title {\n  /*display: block;\n        line-height: 110%;\n        font-size: .6em;\n\n        padding: 3px 0 5px 0;*/\n  font-size: 0.9em;\n  display: inline-block;\n}\n.form_intro h1 .form_year {\n  display: inline-block;\n  line-height: 110%;\n  font-size: 0.7em;\n  padding: 3px 0 5px 0;\n}\n/* ------------------------\n EDIT FORM\n------------------------ */\n#validationStatus img {\n  height: 20px;\n  display: inline-block;\n}\n#assessmentCode {\n  display: inline-block;\n}\n/* ------------------------\n ADDRESS BOOK\n------------------------ */\n#addressBookAccordion .panel-heading {\n  display: table;\n  width: 100%;\n}\n#addressBookAccordion .panel-heading .panel_heading_group_name {\n  font-size: 14px;\n}\n#addressBookAccordion .panel-heading .group_totals {\n  float: right;\n}\n#addressBookAccordion .panel-heading .group_totals .group_individuals_total {\n  display: block;\n  text-align: right;\n  float: right;\n  width: 50px;\n}\n#addressBookAccordion .panel-heading .group_totals .group_groups_total {\n  padding-left: 0;\n  display: block;\n  text-align: right;\n  width: 70px;\n}\n#addressBookAccordion .panel-heading .group_totals .total_number {\n  width: 20px;\n  display: inline-block;\n}\n#addressBookAccordion .panel-heading .group_totals img {\n  height: 19px;\n  display: inline-block;\n}\n/* ------------------------\n FORM DIRECTORY\n------------------------ */\n#directorySearchDiv {\n  display: block;\n  margin-bottom: 10px;\n}\n#directorySortDiv {\n  text-align: right;\n  margin-top: 15px;\n}\n.directory-deselect {\n  white-space: nowrap;\n}\n.panel-group {\n  margin-top: 15px;\n}\n.panel {\n  border-radius: 0;\n}\n/*.panel:last-of-type {\n    border-bottom: 1px solid #999999;\n}*/\n.panel-group .panel + .panel {\n  margin-top: 0;\n}\n.accordion > .card:first-of-type:last-of-type {\n  border-radius: 0.25rem;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n}\n.panel-default {\n  margin-bottom: 0;\n}\n.panel-default a {\n  text-decoration: none !important;\n}\n.panel-default .panel-heading {\n  border-top: 1px solid #999999;\n  border-bottom: none;\n  border-radius: 0;\n  background: #fff;\n  font-size: 1.1em;\n  color: #444;\n  width: 100%;\n  display: table;\n}\n.panel-default .panel-heading strong {\n  /*color: @button-color;*/\n}\n.panel-default .card-body hr {\n  border-color: #ddd;\n}\n.panel-default .card-body h5 {\n  margin-top: 0;\n}\n.panel-default .card-body .help-block {\n  color: #666666;\n}\n.panel-group .panel-heading + .panel-collapse > .card-body,\n.panel-group .panel-heading + .panel-collapse > .list-group {\n  border: none;\n}\n.pills li {\n  margin-right: 3px;\n}\n.pills li a {\n  font-size: 0.85em;\n  font-weight: 500;\n  letter-spacing: -0.25pt;\n  border-radius: 15px;\n  border: 1px solid #6c757d;\n  padding: 2px 6px;\n  text-decoration: none !important;\n  color: #6c757d;\n  display: block;\n  margin-bottom: 4px;\n  -webkit-transition: 0.1s ease-in-out;\n  -moz-transition: 0.1s ease-in-out;\n  -o-transition: 0.1s ease-in-out;\n  transition: 0.1s ease-in-out;\n}\n.pills li a.disabled {\n  border-color: #999;\n  background: #ddd;\n  color: #999;\n}\n#tags {\n  display: inline;\n}\n.pills li a:hover {\n  background: #eeeeee;\n  border-color: #466db2;\n  text-decoration: none;\n}\n.pills li.active a {\n  background: #466db2;\n  border-color: transparent;\n  text-decoration: none;\n  color: #fff !important;\n}\n.pills li.active .filter_linked {\n  background: #1496b6;\n}\n.pills li.active .filter_web {\n  background: #234d7f;\n}\n.pills li.active .filter_pdf {\n  background: #d6504f;\n}\n.pills li.active .filter_contact {\n  background: #2ab95c;\n}\n.pills li.active .filter_content {\n  background: #eaa030;\n}\n.pills {\n  list-style-type: none;\n  padding: 0;\n  padding-top: 2px;\n  margin-bottom: 5px;\n}\n.pills li {\n  display: inline-block;\n}\n.pills li .filter_linked {\n  border-color: #1496b6;\n  color: #1496b6;\n}\n.pills li .filter_linked:hover {\n  background: #1496b6;\n}\n.pills li .filter_web {\n  border-color: #234d7f;\n  color: #234d7f;\n}\n.pills li .filter_web:hover {\n  background: #234d7f;\n}\n.pills li .filter_pdf {\n  border-color: #d6504f;\n  color: #d6504f;\n}\n.pills li .filter_pdf:hover {\n  background: #d6504f;\n}\n.pills li .filter_contact {\n  border-color: #2ab95c;\n  color: #2ab95c;\n}\n.pills li .filter_contact:hover {\n  background: #2ab95c;\n}\n.pills li .filter_content {\n  border-color: #eaa030;\n  color: #eaa030;\n}\n.pills li .filter_content:hover {\n  background: #eaa030;\n}\n.related_forms_list {\n  padding-left: 5px;\n}\n.related_forms_list li {\n  list-style-position: inside;\n}\n.display_tags_keys {\n  padding: 0;\n}\n.display_tags_keys li {\n  display: inline;\n  list-style-type: none;\n}\n.display_tags_keys li:not(:last-of-type):after {\n  content: \", \";\n}\n.directory_create_buttons {\n  text-align: right;\n}\n.admin_directory_sort_buttons {\n  text-align: right;\n  float: right;\n}\n/*#endregion*/\n/* ------------------------\n WIDGETS\n------------------------ */\n.code-card {\n  margin-bottom: 30px;\n}\n.widget-link {\n  margin-left: 5px;\n}\n/* ------------------------\n MEDIA QUERIES\n------------------------ */\n@media (min-width: 576px) {\n  .df-navigation-btn-container .btn {\n    width: auto;\n  }\n}\n@media (max-width: 767px) {\n  .no-bg {\n    margin-bottom: 240px;\n  }\n  #footfloat {\n    position: relative;\n    float: none;\n    bottom: 15px;\n    text-align: center;\n    margin: 0;\n    margin-top: 15px;\n  }\n  #footer #footfloat a {\n    padding: 0;\n  }\n  .search .input-group {\n    width: 100%;\n  }\n  .dashboard_btn {\n    text-align: left;\n  }\n  #directorySearchDiv {\n    width: 100%;\n    margin-top: 5px;\n  }\n  #directorySortDiv,\n  .directory_create_buttons {\n    text-align: center;\n  }\n  .gq_bottom_container {\n    bottom: 280px;\n  }\n  .form_type img {\n    margin-right: 0;\n    margin-top: -10px;\n    height: 35px;\n  }\n  .form_intro .btn:not(:last-of-type) {\n    margin-right: 0;\n  }\n  #todaysDate {\n    margin-top: 0;\n  }\n  #groupEditorModal .inline_input {\n    width: 80%;\n  }\n  #feedback {\n    list-style-position: inside;\n  }\n  .search_tips_image {\n    width: 200px;\n    float: none;\n    margin: auto;\n    margin-bottom: 10px;\n    text-align: center;\n  }\n  .search_tips_image img {\n    box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.4);\n  }\n  .admin_directory_nav_tabs {\n    display: inline-block;\n    width: 100%;\n  }\n  .admin_directory_sort_buttons {\n    text-align: center;\n    float: none;\n  }\n  #welcomeDiv hr {\n    margin: 10px -5px 20px -5px;\n  }\n  #welcomeDiv img {\n    width: 125px;\n  }\n  .DFPageContent.row {\n    margin-left: 15px;\n    margin-right: 15px;\n  }\n  .navigation_placeholder {\n    height: auto;\n    padding: 10px;\n  }\n  .index-row {\n    margin: 0;\n  }\n  .row.DFPageContent {\n    padding: 0;\n  }\n  .admin-icon {\n    font-size: 90px;\n  }\n  .inline_remove_btn {\n    padding-left: 15px;\n  }\n  .has-form-comments .submissions-left-col {\n    border-bottom: 1px solid #dddddd;\n    padding-bottom: 15px;\n    margin-bottom: 15px;\n  }\n  .submissions-left-col {\n    min-height: 0 !important;\n    padding: 5px 15px;\n  }\n  .submissions-right-col {\n    min-height: 0 !important;\n    padding: 5px;\n  }\n}\n/* Small devices (tablets, 768px and up) */\n@media (min-width: 768px) {\n  #addressBookAccordion .panel-heading {\n    display: table;\n    width: 100%;\n  }\n  #addressBookAccordion .panel-heading .panel_heading_group_name {\n    font-size: 18px;\n  }\n  #addressBookAccordion .panel-heading .group_totals {\n    display: table;\n  }\n  #addressBookAccordion .panel-heading .group_totals .group_individuals_total {\n    display: table-cell;\n    text-align: left;\n    width: 41px;\n    float: none;\n  }\n  #addressBookAccordion .panel-heading .group_totals .group_groups_total {\n    padding-left: 10px;\n    display: table-cell;\n    text-align: left;\n    width: 55px;\n  }\n  #addressBookAccordion .panel-heading .group_totals .total_number {\n    width: 20px;\n    display: inline-block;\n  }\n  #addressBookAccordion .panel-heading .group_totals img {\n    height: 20px;\n    display: inline-block;\n  }\n  #welcomeDiv {\n    height: 567px;\n  }\n  .df-public-nav .navbar-collapse.collapse {\n    display: block !important;\n    height: auto !important;\n    padding-bottom: 0;\n    overflow: visible !important;\n  }\n  .df-public-nav .navbar-header {\n    display: none;\n  }\n  .admin-card {\n    min-height: 318px;\n  }\n  .submissions-left-col {\n    width: 325px;\n    padding: 15px;\n    overflow: auto;\n    border-right: 1px solid #cccccc;\n  }\n  .submissions-right-col {\n    padding: 15px;\n  }\n  .submissions-left-col,\n  .submissions-right-col {\n    min-height: calc(100vh - 70px);\n    overflow-y: auto;\n  }\n  .submissions-table-wrapper {\n    width: 100%;\n    height: calc(100vh - 80px - 70px);\n    overflow-y: auto;\n  }\n  .directory-container {\n    min-height: calc(100vh - 70px);\n    padding: 15px;\n  }\n}\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: 992px) {\n  #formDirectoryTile,\n  #formDirectoryBtn {\n    font-size: 1.3em;\n  }\n  #welcomeDiv {\n    height: 565px;\n  }\n  .admin-card {\n    min-height: 280px;\n  }\n}\n/* Large devices (large desktops, 1200px and up) */\n@media (min-width: 1200px) {\n  #formDirectoryTile,\n  #formDirectoryBtn {\n    font-size: 1.5em;\n  }\n  #welcomeDiv {\n    height: 562px;\n  }\n}\n.DFPageContentWrapper table tr th {\n  border-bottom: 2px solid #ddd;\n}\n.navigation_placeholder,\n.button_placeholder {\n  font-size: 15px !important;\n}\n.select_element_page_children .btn > span {\n  display: inline-block;\n}\n.only_print {\n  display: none;\n}\n@media print {\n  .only_print {\n    display: block !important;\n  }\n  .voucher_section {\n    border: 2px dashed #ddd;\n    padding: 30px;\n  }\n}\n/*DF form wrapper container css*/\n@media (max-width: 767px) {\n  .df-public-nav .list-group-item {\n    padding: 7.5px 7.5px 7.5px 30px;\n    -webkit-transition: all ease 0.25s;\n    transition: all ease 0.25s;\n  }\n  .df-public-nav .list-group-item.active .icon {\n    display: block;\n    float: right;\n    font-size: 0.9em;\n    margin-top: 3px;\n    margin-right: -5px;\n  }\n  .df-public-nav .list-group-item:not(.active) {\n    height: auto;\n    /*padding: 7.5px 7.5px 7.5px 30px;*/\n  }\n  .df-public-nav.df-collapsed .list-group-item {\n    border-radius: 0;\n  }\n  .df-public-nav.df-collapsed .list-group-item:not(.active) {\n    height: 0;\n    padding: 0;\n    border-width: 0;\n    overflow: hidden;\n    visibility: hidden;\n  }\n}\n@media (min-width: 768px) {\n  .DFPageContent {\n    width: 750px;\n  }\n}\n@media (max-width: 991px) {\n  .img-responsive {\n    /* account for large homepage images to be responsive on mobile devices */\n    max-width: 100%;\n    height: auto !important;\n  }\n}\n@media (min-width: 992px) {\n  .DFPageContent {\n    width: 970px;\n  }\n}\n@media (min-width: 1200px) {\n  .DFPageContent {\n    width: 1170px;\n  }\n}\n.DFPageContent {\n  margin-right: auto;\n  margin-left: auto;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n.admin-card {\n  margin-top: 20px;\n}\n/* TENANT */\n.tenant-fieldset {\n  border: 1px solid #ddd;\n  padding: 0 15px;\n}\n.tenant-fieldset legend {\n  font-weight: 500;\n}\n.tree-layout {\n  padding-left: 0;\n}\n.tree-layout ul {\n  padding-left: 30px;\n}\n.tree-layout li {\n  list-style-type: none;\n  border-left: 1px dashed #666666;\n}\n.tree-layout li:before {\n  border-bottom: 1px dashed #666666;\n  display: inline-block;\n  height: 20px;\n  width: 10px;\n  margin-top: -2px;\n  margin-bottom: 2px;\n  content: \"\";\n}\n.tree-layout li:last-child:before {\n  border-left: 1px dashed #666666;\n}\n.tree-layout li:last-child > ul,\n.tree-layout li:last-child {\n  border-left: none !important;\n}\n.tree-layout > li {\n  margin-bottom: 10px;\n  list-style-type: none;\n  border-left: none !important;\n}\n.tree-layout > li:before {\n  display: none;\n}\n.tree-layout [data-toggle=\"popover\"] {\n  vertical-align: middle;\n}\n.tree-layout a {\n  font-size: 0.9em;\n}\nbody.no-footer {\n  padding-bottom: 0;\n}\nbody.no-footer #public-footer-wrapper {\n  display: none;\n}\nbody.no-footer .body-content {\n  padding: 0;\n}\n.pills li a:disabled {\n  border-color: #ccc;\n}\n/* I don't understand why these are required */\n.node_body,\n.node_addon {\n  display: inline-block;\n}\n.node_body {\n  padding-bottom: 0;\n  padding-top: 0;\n  line-height: 32px;\n  position: relative;\n  top: -5px;\n}\n.gq_node {\n  height: 32px;\n}\n.pages-admin-content {\n  width: calc(100% - 300px);\n  margin-left: 300px;\n  padding: 15px;\n}\n.pages-left-nav-sec {\n  height: calc(100vh - 70px);\n  width: 300px;\n  position: fixed;\n  background-color: #f5f6f7;\n  padding: 15px;\n  overflow-x: auto;\n  overflow-y: auto;\n  white-space: nowrap;\n}\n.pages-left-nav-sec [class^=\"icon-\"]:before,\n.pages-left-nav-sec [class*=\" icon-\"]:before {\n  font-size: inherit;\n}\n.pages-left-nav-sec .nav-link {\n  font-size: 0.9em;\n}\n.passthrough {\n  background: none;\n  color: inherit;\n  padding: 0;\n  border: none;\n  text-align: left;\n  line-height: 100%;\n  -webkit-appearance: none;\n}\n.passthrough + .passthrough {\n  margin-left: 4px;\n}\n.tenantList .area-label.selected {\n  text-decoration: none;\n  font-weight: bold;\n  color: #234d7f;\n}\n.tenantList .nav-item .passthrough {\n  max-width: 300px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n}\n.tenantList .nav-item .passthrough.icon-home:before,\n.tenantList .nav-item .passthrough.icon-folder:before,\n.tenantList .nav-item .passthrough .icon-home:before,\n.tenantList .nav-item .passthrough .icon-folder:before,\n.tenantList .nav-item .passthrough .icon-sites:before {\n  margin-right: 5px;\n  vertical-align: top;\n}\n.tenantList .current-area,\n.tenantList .area-top-list,\n.tenantList .add-new-area,\n.tenantList .icon-sites,\n.tenantList .icon-folder {\n  display: none;\n}\n.tenantList .area-child-list {\n  display: block;\n  margin: 0;\n}\n.tenantList .area-child-list .area-list {\n  margin: 0 0 15px 5px;\n  padding-left: 10px;\n  border-left: 2px solid #cccccc;\n}\n.tenantList .area-child-list .area-list .add-new-area {\n  display: block;\n  color: #6c757d;\n}\n.tenantList .area-child-list .area-list .add-new-area .plus-sign {\n  color: #1e7e34;\n  font-weight: bold;\n}\n.tenantList .area-child-list .area-list .area-child-list {\n  margin-left: 15px;\n}\n.tenantList .area-child-list .area-list .area-list,\n.tenantList .area-child-list .area-list .icon-sites {\n  display: none;\n}\n.tenantList .area-child-list .area-list .icon-home,\n.tenantList .area-child-list .area-list .icon-folder {\n  display: inline-block;\n}\n.tenantList .area-child-list .area-label {\n  border: none;\n}\n.tenantList .area-child-list .current-area,\n.tenantList .area-child-list .area-top-list {\n  display: block;\n}\n.tenantList .area-child-list .icon-sites {\n  display: inline;\n}\n","@font-face {\n    font-style: normal;\n    font-weight: 400;\n    src:\n        local(\"Open Sans Regular\"),\n        local(\"OpenSans-Regular\"),\n        url(https://fonts.gstatic.com/s/opensans/v15/mem8YaGs126MiZpBA-UFUZ0bbck.woff2) format(\"woff2\");\n    unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n/* variables for easier Custom Less modification */\n@navbar-height: 70px;\n@small-font: 0.875rem;\n\nhtml {\n    position: relative;\n    min-height: 100vh;\n}\n\n.skip-to.popup.focus {\n    z-index: 1030;\n}\n\nbody {\n    padding-top: 70px;\n    background: #fff;\n    background-size: cover;\n    font-weight: normal;\n    font-family: \"Open Sans\", sans-serif;\n}\n\n.body-content {\n    width: 100%;\n    position: relative;\n}\n\na {\n    color: @link-color;\n}\n\na:hover {\n    cursor: pointer;\n    color: @link-color-hover;\n}\n\np {\n    clear: none;\n}\n\nh1 {\n    line-height: 1;\n    color: #333;\n}\n\nh1,\nh2,\nh3 {\n    margin-top: 10px;\n    font-weight: 500;\n}\n\nh1 {\n    font-size: 1.9rem;\n}\n\nh2 {\n    font-size: 1.65rem;\n}\n\nh3 {\n    font-size: 1.45rem;\n}\n\nh4 {\n    font-size: 1.3rem;\n}\n\nh5 {\n    font-size: 1.15rem;\n}\n\nh6 {\n    font-size: 1rem;\n}\n\n.pull-right {\n    float: right;\n}\n\n.loading {\n    margin: 15px auto;\n    display: block;\n    margin: 0 auto;\n    height: 100px;\n}\n\n.text-smaller {\n    font-size: @small-font;\n}\n\n.tile {\n    background: #ffffff;\n    border-radius: 8px;\n    padding: 15px;\n}\n\n[data-bind*=\"clickOrEnter\"],\n[data-bind^=\"clickOrEnter\"] {\n    cursor: pointer;\n}\n\n.dropdown-menu li,\n.returning_user li {\n    list-style-type: none;\n    list-style-position: initial;\n}\n\n.previous-question {\n    padding: 5px 10px;\n    border-top: 1px solid #ddd;\n    font-size: 13px;\n    cursor: pointer;\n\n    strong {\n        font-size: 15px;\n    }\n}\n\n.current-question {\n    border-top: 1px solid #ddd;\n}\n\n.answer.disabled {\n    opacity: 0.65;\n}\n\n.previous-question:hover,\n.previous-question:focus {\n    background: #f5f5f5;\n}\n\n.dropdown-menu {\n    border-radius: 0 0 6px 6px;\n}\n\n.dropdown.open {\n    .dropdown-menu {\n        opacity: 1;\n    }\n}\n\n.dropdown-toggle {\n    &.show + .dropdown-menu {\n        display: block;\n    }\n}\n\nlabel {\n    font-weight: 500;\n}\n\n// Specify id from public form to avoid\n// overlapping with form-control styles when form is accessed from admin\n#jsPageEditor {\n    .form-control,\n    .vs__dropdown-toggle,\n    .form-group .input-group .input-group-text {\n        font-weight: normal;\n        border-color: @primary-lightest;\n    }\n\n    .vs__dropdown-toggle .vs__open-indicator {\n        fill: @black;\n    }\n\n    .form-control:focus,\n    .vs--open .vs__dropdown-toggle {\n        border-width: 2px;\n        border-color: @active-black;\n        box-shadow: unset;\n\n        & ~ .vs__dropdown-menu {\n            --vs-border-width: 0;\n        }\n    }\n\n    .form-group {\n        .btn-group {\n            border-radius: 0.35rem;\n        }\n\n        &.text-form-group {\n            .input-group-append,\n            .input-group-prepend {\n                .input-group-text {\n                    &:focus {\n                        z-index: 0;\n                    }\n                }\n            }\n        }\n\n        &.has-custom-errors {\n            // Specify selectors to avoid inheriting styles if elements are nested\n            @width: 2px;\n            .border-mixin {\n                border-color: @custom-error-red;\n                border-width: 1px;\n                outline: unset;\n            }\n            .border-focus-mixin {\n                border-width: @width;\n                box-shadow: unset;\n            }\n            .invalid-border-mixin {\n                .border-mixin;\n                &:focus {\n                    .border-focus-mixin;\n                }\n            }\n\n            &.text-form-group {\n                & > div,\n                & > div > .datepicker-group {\n                    & > .form-control,\n                    & > .input-group-text {\n                        .invalid-border-mixin;\n                    }\n                    & > .input-group-append,\n                    & > .input-group-prepend {\n                        .input-group-text {\n                            .invalid-border-mixin;\n                            &:focus {\n                                outline: @width solid @custom-error-red;\n                                box-shadow: unset;\n                                border: unset;\n                                z-index: 0;\n                            }\n                        }\n                        &:not(.input-group-prepend) .input-group-text {\n                            border-left-width: 0;\n                        }\n                        &:not(.input-group-append) .input-group-text {\n                            border-right-width: 0;\n                        }\n                    }\n                }\n            }\n            &.dropdown-form-group {\n                & > div > div {\n                    & > select.form-control,\n                    & > .v-select .vs__dropdown-toggle {\n                        .border-mixin;\n                    }\n                    & > .v-select.vs--open .vs__dropdown-toggle {\n                        .border-focus-mixin;\n                    }\n                }\n            }\n            &.file-form-group {\n                & > div {\n                    & > .btn-file,\n                    & > .btn-group {\n                        .invalid-border-mixin;\n                        border-width: @width;\n                    }\n                    & > .btn-group {\n                        border-style: solid;\n                        a.btn {\n                            border-width: 0;\n                        }\n                        .input-group-append {\n                            border-top-width: 0;\n                            border-right-width: 0;\n                            border-bottom-width: 0;\n                        }\n                    }\n                }\n            }\n            // &.radio-form-group,\n            // &.checkbox-form-group {\n            //     & > fieldset:before {\n            //         content: \"\";\n            //         position: absolute;\n            //         top: 0;\n            //         left: 5px;\n            //         width: 2px;\n            //         height: 100%;\n            //         background: @custom-error-red;\n            //     }\n            // }\n        }\n    }\n}\n\n.form-check-label,\n.radio-inline,\n.checkbox label {\n    font-weight: normal;\n    margin-bottom: 0;\n}\n\n.page-loading {\n    position: fixed;\n    opacity: 1;\n    transition: all 0.4s ease-in;\n}\n\nhtml.no-js .page-loading {\n    display: none;\n}\n\n.page-loaded {\n    opacity: 0;\n    height: 0;\n    transition: none; /*ensure wheel doesn't fade out, rather disappears*/\n    z-index: -1;\n}\n\n.body-loading {\n    width: 100px;\n    height: 100px;\n    border-radius: 1.5ex;\n    padding: 0.2ex;\n    position: fixed;\n    left: calc(~\"50% - 50px\");\n    top: calc(~\"50% - 50px\");\n\n    .loading {\n        height: 100%;\n    }\n}\n\n.popover-header {\n    margin: 0;\n}\n\n.popper {\n    background: #ffffff;\n    max-width: 300px;\n    border: 1px solid #cccccc;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n    padding: 7.5px;\n}\n\n.form-check.answer {\n    position: static;\n}\n\n.v--modal-overlay {\n    z-index: 1002;\n}\n\n.modal-content {\n    border: none;\n    max-height: 100vh;\n    overflow-y: auto;\n}\n\n/* ------------------------\n NAVIGATION\n-/----------------------- */\n.skip-navigation-link:focus {\n    display: block;\n    top: 0;\n    width: auto !important;\n    height: auto !important;\n    z-index: 998999;\n    background: white;\n    clip: unset;\n}\n\n.navbar-dark {\n    background-color: @primary;\n    /*min-height: 60px;*/\n    padding-top: 5px;\n    padding-bottom: 5px;\n}\n\n.navbar-dark {\n    padding-left: 0;\n    padding-right: 0;\n\n    .navbar-nav .nav-link {\n        color: rgba(255, 255, 255, 0.9);\n        cursor: pointer;\n\n        &:hover,\n        &:focus {\n            color: rgba(255, 255, 255, 1);\n        }\n    }\n\n    a {\n        white-space: nowrap;\n    }\n\n    a:hover,\n    a:focus {\n        text-decoration: none;\n    }\n}\n\n.icon-bar {\n    display: block;\n    background: #ffffff;\n    height: 1px;\n    width: 18px;\n    margin-top: 5px;\n}\n\n.navbar-fixed-top .navbar-collapse,\n.navbar-fixed-bottom .navbar-collapse {\n    max-height: none;\n    border: none;\n    box-shadow: none;\n    padding: 0;\n    width: 100%;\n}\n\n.navbar-dark .navbar-nav > li > a {\n    color: #fff;\n    font-size: 15px;\n    text-decoration: none;\n    display: inline-block;\n    letter-spacing: 0.5px;\n    /*text-transform: uppercase;*/\n}\n\n.navbar-dark .navbar-nav > li {\n    padding: 13px 7.5px;\n    button {\n        margin-bottom: 0;\n    }\n\n    ::-webkit-input-placeholder,\n    :-moz-placeholder,\n    ::-moz-placeholder,\n    :-ms-input-placeholder {\n        color: #fff !important;\n        opacity: 1 !important;\n    }\n}\n\nfieldset {\n    border: none;\n    padding: 0;\n    margin: 0;\n}\n\nlegend {\n    font-size: 1.2em;\n    font-weight: 500;\n}\n\n.navbar-dark .navbar-nav > .vr {\n    height: 50px;\n    width: 1px;\n    margin-top: 5px;\n    margin-left: 7px;\n    padding-left: 0;\n    padding-right: 7px;\n    border-left: 1px solid lighten(@primary, 7.5%);\n}\n\n.navbar-dark .navbar-nav > li:not(.active) > a:hover,\n.navbar-dark .navbar-nav > li > a:focus,\n.navbar-dark .navbar-nav > li:focus,\n.navbar-dark .navbar-nav > li.open > a:hover,\n.navbar-dark .navbar-nav > li.open > a:focus,\n.navbar-dark .navbar-nav > li.open > a:active,\n.dropdown-menu > li > a:hover,\n.dropdown-menu > li > a:focus,\n.dropdown-menu > li > a:active {\n    color: #fff;\n    background: @primary;\n    border-color: transparent;\n}\n\n.navbar-dark .navbar-nav > .open > a:hover,\n.navbar-dark .navbar-nav > .open > a:focus {\n    background: #27221a;\n}\n\n.navbar-dark .navbar-brand {\n    padding: 0;\n    img {\n        height: 50px;\n        display: inline;\n    }\n\n    .brand-letters {\n        display: inline;\n        margin-left: 4px;\n        img {\n            height: 25px;\n        }\n    }\n\n    /* cspell:ignore ccess */\n    .brand-letters-ccess,\n    .brand-letters-gov {\n        font-size: 40px;\n        letter-spacing: 6pt;\n        vertical-align: middle;\n        display: inline-block;\n        margin-top: -1px;\n    }\n\n    .brand-letters-ccess {\n        font-weight: bold;\n        color: #ccc;\n    }\n\n    .brand-letters-gov {\n        color: #fff;\n    }\n}\n\n.navbar-dark .navbar-right {\n    font-size: 1.1em;\n    letter-spacing: 0.4pt;\n    margin: 0;\n    margin-right: -15px;\n    margin-left: auto;\n}\n\n.form-control.search-control {\n    background: transparent url(\"../images/search.png\") no-repeat center left 7.5px;\n    background-size: 15px;\n    padding-left: 30px;\n}\n\n.navbar-dark .form-control.search-control:focus {\n    border-bottom-color: #fff;\n}\n\n.search-backdrop {\n    /*display: none;*/\n    position: fixed;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.9);\n    z-index: 10000;\n    .close {\n        position: fixed;\n        top: 30px;\n        right: 30px;\n        color: #fff;\n        font-size: 2em;\n        opacity: 1;\n        img {\n            height: 20px;\n        }\n    }\n\n    .search-form-wrapper {\n        width: 600px;\n        height: 100px;\n        max-width: 100%;\n        position: fixed;\n        top: 25vh;\n        left: calc(~\"50% - 300px\");\n        .form-group {\n            label {\n                font-size: 1.5em;\n                color: #aaa;\n                margin-bottom: 0;\n                -webkit-transition: all 0.25s;\n                transition: all 0.25s;\n            }\n\n            .form-control {\n                background: none;\n                height: 40px;\n                color: #ddd;\n                border: none;\n                padding: 10px;\n                border-bottom: 1px solid #aaa;\n                border-radius: 0;\n                box-shadow: none;\n            }\n\n            .form-control:focus {\n                border-color: @link-color;\n                border-bottom-width: 2px;\n            }\n        }\n    }\n}\n\n.nav-search-results {\n    position: relative;\n    height: auto;\n    max-height: calc(~\"75vh - 125px\");\n    min-height: 75px;\n    overflow-y: auto;\n    width: 600px;\n    max-width: 100%;\n    background: #fff;\n    margin-top: 0;\n    padding: 0;\n    border-radius: 4px;\n    box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.25);\n    overflow: auto;\n    .nav-search-results-inner {\n        padding: 15px;\n        position: relative;\n        height: auto;\n        width: 100%;\n        overflow-x: hidden;\n        text-align: left;\n    }\n\n    .nav-search-results-caption {\n        position: absolute;\n        top: 5px;\n        right: 10px;\n        display: inline-block;\n        color: #636363;\n        font-size: 12px;\n        /*font-weight: 600;*/\n    }\n\n    .result {\n        padding-top: 5px;\n        letter-spacing: normal;\n        /*font-size: 14px;*/\n        text-align: left;\n    }\n\n    .result:first-of-type {\n        padding-top: 10px;\n    }\n}\n\n.close {\n    opacity: 0.7;\n    font-size: 1.25em;\n}\n\n.dropdown-menu {\n    padding: 0;\n    padding-bottom: 8px;\n}\n\n.dropdown-menu > li > a {\n    display: block;\n    color: #fff;\n    font-size: 13px;\n    padding: 6px 18px;\n}\n\n.dropdown-menu .divider {\n    opacity: 0.3;\n    background-color: #000000;\n    margin: 0;\n    display: none;\n}\n\n.pane-size-toggle {\n    font-size: 32px;\n    margin-top: -10px;\n    -webkit-appearance: none;\n    padding: 0;\n    cursor: pointer;\n    background: transparent;\n    border: 0;\n    float: right;\n}\n\n.toolbox_pane .pane-size-toggle {\n    margin-top: -14px;\n}\n\n.toggle-symbol {\n    font-size: 24px;\n    margin-top: -10px;\n}\n\n.toggle-smaller {\n    margin-left: 7px;\n}\n\n.toggle-larger {\n    margin-left: 0;\n}\n\n.pane-size-toggle.close:hover {\n    opacity: 1;\n}\n\n.df-public-nav {\n    .navbar {\n        min-height: 0;\n    }\n}\n\n.navbar-toggle.public_pages_toggle {\n    margin: 5px;\n    padding: 5px;\n}\n\n.navbar-collapse .list-group {\n    margin-bottom: 0;\n}\n\n.btn {\n    .icon {\n        line-height: 0;\n        vertical-align: inherit;\n    }\n    .icon-trash {\n        font-size: 1.1em;\n    }\n    .icon-undo,\n    .icon-redo {\n        font-size: 1.15em;\n    }\n}\n\n.btn-link {\n    color: @link-color;\n}\n\n.btn-link.icon {\n    &:active,\n    &:focus {\n        box-shadow: ~\"0 0 0 0.2rem rgb(0 123 255 / 25%)\";\n    }\n}\n\n.btn-group-vertical .btn {\n    margin-bottom: 0;\n}\n\n.fixed-top {\n    z-index: 1001;\n}\n\n.btn {\n    .focus-mixin(@outline-color) {\n        outline: 2px solid @outline-color;\n        outline-offset: 2px;\n        box-shadow: unset;\n    }\n\n    &.btn-primary {\n        background: @button-color;\n        color: #fff;\n        border-color: transparent;\n\n        &:hover {\n            background: @button-color-hover;\n            border-color: @button-color-hover;\n            color: #fff;\n        }\n\n        &:focus {\n            .focus-mixin(@button-color-hover);\n        }\n\n        &:active {\n            background: @button-color-hover !important;\n            color: #fff !important;\n            border-color: darken(@button-color, 10%);\n        }\n    }\n\n    &.btn-outline-primary {\n        &:hover {\n            background: @button-color;\n            border-color: @button-color;\n        }\n\n        &:focus {\n            background: @button-color;\n            color: #fff;\n            .focus-mixin(@button-color);\n        }\n    }\n\n    &.btn-outline-secondary {\n        &:focus {\n            background: #6c757d;\n            color: #ffffff;\n            .focus-mixin(#6c757d);\n        }\n    }\n\n    &.btn-outline-danger {\n        &:focus {\n            background: #dc3545;\n            color: #ffffff;\n            .focus-mixin(#dc3545);\n        }\n    }\n\n    &.btn-outline-success {\n        &:focus {\n            background: #28a745;\n            color: #ffffff;\n            .focus-mixin(#28a745);\n        }\n    }\n\n    &.btn-bare {\n        &:focus {\n            .focus-mixin(@active-black);\n        }\n    }\n}\n\n.btn-block {\n    display: block;\n    width: 100%;\n}\n\n.btn.btn-xs {\n    padding: 2px 5px;\n    font-size: 0.75rem;\n    border-radius: 3px;\n    -webkit-transition: 0.1s all ease-in-out;\n    -moz-transition: 0.1s all ease-in-out;\n    -o-transition: 0.1s all ease-in-out;\n    transition: 0.1s all ease-in-out;\n}\n\n.notificationBarTop {\n    background: @notification-bar-top-color;\n    color: @text-color-primary;\n    text-align: center;\n    line-height: 2.5;\n    overflow: hidden;\n    /*margin-top: -15px;\n    margin-bottom: 15px;*/\n\n    a,\n    html.bootstrap-legacy & button,\n    html.bootstrap-5 & button:not(.close) {\n        color: @text-color-primary;\n        font-weight: bold;\n        border-bottom: 1px solid @text-color-primary;\n        border-radius: 0;\n        padding: 0;\n\n        &:hover {\n            color: @text-color-hover;\n        }\n    }\n\n    html.bootstrap-5 & button:not(.close) {\n        text-decoration: none;\n    }\n\n    .close {\n        color: @button-color-text;\n        padding: 7px 10px;\n        opacity: 0.8;\n        font-size: 1.3em;\n\n        &:hover {\n            opacity: 1;\n        }\n    }\n\n    .close:not(:disabled):not(.disabled):hover,\n    .close:not(:disabled):not(.disabled):focus {\n        color: #fff;\n        opacity: 0.75;\n    }\n}\n\n.tab-content {\n    .result {\n        border-bottom: 1px solid #ddd;\n        padding: 15px;\n    }\n\n    .result:first-of-type {\n        border-top: 1px solid #ddd;\n    }\n}\n\n.form-group {\n    margin-bottom: 0.75rem;\n    label {\n        &.sr-only {\n            position: absolute;\n        }\n    }\n\n    legend {\n        font-size: 1em;\n        font-weight: 600;\n        border-bottom: none;\n        margin-bottom: 2px;\n    }\n\n    .radio-inline,\n    .checkbox-inline,\n    .checkbox label,\n    .radio label {\n        margin-left: 0;\n        margin-right: 10px;\n    }\n    /*label.focused {\n        color: @focus;\n    }*/\n}\n\n/*.radio-inline,\n.radio,\n.checkbox-inline,\n.checkbox {\n    font-size: 14px;\n}*/\n\n.loading {\n    margin: 15px auto;\n    display: block;\n    margin: 0 auto;\n    height: 100px;\n}\n\n.have_not_searched {\n    text-align: center;\n    height: 100%;\n    width: 100%;\n    /*padding-top: 15px;*/\n}\n\n.have_not_searched:before {\n    /*content: \"Use this search tool to find forms.\";*/\n    font-size: 1.2em;\n    vertical-align: middle;\n}\n\n#questionsDiv {\n    position: relative;\n    margin-bottom: 20px;\n\n    .radio {\n        margin-bottom: 7px;\n    }\n}\n.public-page-body {\n    .body-content {\n        padding: 0;\n    }\n}\n\n/* ------------------------\n AUTHENTICATED USER\n------------------------ */\n@my-forms-width: 375px;\n.index-container {\n    display: flex;\n    flex: 1;\n    flex-direction: column-reverse;\n}\n\n.index-content {\n    legend {\n        display: block;\n        width: 100%;\n        text-align: center;\n    }\n}\n\n.returning_user {\n    overflow: auto;\n    flex: 0 0 100%;\n    padding: 0px 15px 15px 15px;\n    background: #f9f9f9;\n    border-top: 1px solid #ccc;\n\n    .returning_user_header,\n    .returning_user_body {\n        visibility: visible;\n    }\n\n    .nav-tabs {\n        border-bottom-color: #bbbbbb;\n\n        li {\n            a {\n                background: none !important;\n            }\n        }\n    }\n\n    .badge {\n        margin-left: 5px;\n    }\n\n    .tab-content {\n        padding: 4px 0;\n        border: none;\n        border-top: none;\n    }\n\n    .returning_user_list_of_forms {\n        list-style: none;\n        padding: 0;\n\n        li {\n            position: relative;\n            display: table;\n            width: 100%;\n            padding: 0.5rem;\n            border-bottom: 1px solid #ccc;\n\n            .returning_user_actions {\n                float: right;\n                display: block;\n            }\n        }\n    }\n}\n\n#MyFormsHeading {\n    margin-top: 15px;\n    margin-bottom: 10px;\n}\n\n.submitted_timestamp {\n    font-size: 12px;\n    color: #6d6d6d;\n    float: left;\n    margin-top: 5px;\n}\n\n.my-forms-tag {\n    display: block;\n    clear: both;\n    padding: 2px 6px;\n    border-radius: 100px;\n    font-size: 80%;\n    margin-top: 5px;\n    margin-bottom: 2.5px;\n    float: left;\n    &.returned {\n        background: #ffebce;\n    }\n    &.in-progress {\n        background: #e0edff;\n    }\n    &.done {\n        background: #dbf2e4;\n    }\n    &.unavailable {\n        background: #ffe0e0;\n    }\n}\n\n.badge {\n    font-weight: 600;\n    display: inline-block;\n    padding: 0.25em 0.4em;\n    font-size: 75%;\n    font-weight: 700;\n    line-height: 1;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: baseline;\n    border-radius: 0.25rem;\n    transition:\n        color 0.15s ease-in-out,\n        background-color 0.15s ease-in-out,\n        border-color 0.15s ease-in-out,\n        box-shadow 0.15s ease-in-out;\n}\n\n.badge-primary {\n    color: #fff;\n    background-color: #007bff;\n}\n\n.badge-light {\n    border: 1px solid #dee2e6;\n}\n\ndiv .nav-tabs {\n    margin-right: 0;\n}\n\n.nav-tabs > li > .nav-link {\n    border: none;\n    border-bottom: 3px solid transparent;\n}\n\n.nav-tabs > li > .nav-link.active,\n.nav-tabs > li > .nav-link.active:hover,\n.nav-tabs > li > .nav-link.active:focus {\n    border-bottom: 3px solid @focus;\n    background-color: #fff;\n    border-radius: 0;\n    color: @focus !important;\n    border-bottom-color: @focus !important;\n}\n\n/*.nav-tabs > li.active > .nav-link.show {\n    border-bottom-color: transparent;\n}\n\n.nav-tabs > li.active > .nav-link,\n.nav-tabs > li.active > .nav-link:hover,\n.nav-tabs > li.active > .nav-link:focus {\n    border-bottom: 3px solid @focus;\n    background-color: #fff;\n    border-radius: 0;\n    color: @focus !important;\n    border-bottom-color: @focus !important;\n\n    .badge {\n        background-color: #333;\n    }\n}*/\n\n.nav-tabs > li {\n    margin-bottom: -1px;\n}\n\n.nav-tabs > li > .nav-link,\n.nav-tabs > li > .nav-link:hover {\n    color: inherit;\n    margin-right: 0;\n    background-color: transparent;\n}\n\n#myFormsDiv {\n    max-height: 495px;\n    overflow: auto;\n}\n\n#myFormsDiv ul {\n    padding-left: 20px;\n}\n\n#myFormsDiv li {\n    margin-bottom: 10px;\n}\n\n.navbar-dark .navbar-nav > li.login > a,\n.navbar-dark .navbar-nav > li.login.dropdown > a {\n    img {\n        height: 20px;\n        margin-right: 5px;\n    }\n}\n\n.navbar-dark .navbar-nav > li {\n}\n\n.navbar-dark .navbar-nav > li > a,\n.navbar-dark .navbar-nav > li > a:hover,\n.navbar-dark .navbar-nav > li > a:focus {\n    color: #fff;\n    background: transparent;\n}\n\n.navbar-dark .navbar-nav > li .dropdown-menu {\n    background-color: @primary;\n    border: 0;\n    left: auto;\n    right: 0;\n}\n\n.navbar-dark .navbar-nav > li .dropdown-menu > li > a {\n    color: #fff;\n    /*text-transform: uppercase;*/\n}\n\n.nav .open > a,\n.nav .open > a:hover,\n.nav .open > a:focus {\n    border-color: transparent;\n}\n\n.help-block {\n    color: #717171;\n    font-size: 13px;\n}\n\n/*----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/\n\n/* ------------------------\n FOOTER\n------------------------ */\n\n#demo {\n    width: 600px;\n    padding-top: 5px;\n    margin-left: 10px;\n    float: left;\n}\n\n#demo a,\na.visited,\na.hover {\n    text-decoration: none;\n    border: none;\n}\n\n#footer {\n    background: @primary;\n    color: rgba(255, 255, 255, 0.9);\n    width: 100%;\n\n    ul {\n        padding: 24px 20px;\n        list-style-type: none;\n        text-align: center;\n        list-style: none outside none;\n        z-index: 11;\n        bottom: 0px;\n        margin: 0px auto;\n        flex: auto;\n        display: inline;\n\n        li {\n            margin: 0 5px;\n            display: inline-block;\n            color: #e2d5b4;\n\n            a {\n                background: none;\n                color: #fff;\n                letter-spacing: normal;\n                font-size: 12px;\n            }\n        }\n\n        li:first-of-type {\n            margin-left: 0;\n        }\n\n        li:last-of-type {\n            margin-right: 0;\n        }\n\n        li:hover {\n            background: none;\n            color: #e2d5b4;\n        }\n    }\n\n    > a {\n        margin-left: auto;\n        max-height: 48px;\n        border: none;\n    }\n}\n\n.mi-footer-logo {\n    height: 35px;\n    margin-top: -6px;\n}\n\n.accessgov-footer-logo {\n    height: 45px;\n    margin-top: -10px;\n}\n\n.visible-xs-inline-block {\n    display: none;\n}\n\n.my-forms-backdrop {\n    &:extend(.search-backdrop);\n    background: rgba(0, 0, 0, 0.5);\n    height: 100vh;\n    width: 100%;\n    z-index: 999;\n}\n\n.index-logo {\n    height: 150px;\n    margin: 10px auto;\n    max-width: 100%;\n}\n\n.public-page-body .tile {\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.public-page-body .body-content {\n    padding: 0 5px;\n}\n\n// .returning_user {\n//     margin: 0 -15px;\n// }\n\n@media (max-width: 767px) {\n    body {\n        padding-top: 60px;\n        background-image: none;\n        padding-bottom: 0 !important;\n    }\n\n    .body-content {\n        margin-top: 0;\n        padding-top: 0;\n    }\n\n    .transitions-after-load {\n        .body-content {\n            height: 100vh;\n        }\n    }\n\n    .nav .dropdown {\n        position: static;\n    }\n\n    .dropdown-menu {\n        position: static;\n        box-shadow: none;\n    }\n\n    .notificationBarTop {\n        /*margin-top: -10px;*/\n        margin-bottom: 0;\n    }\n    #footer {\n        position: static;\n        text-align: center;\n        height: auto;\n        /*margin-top: 25px;*/\n        padding: 15px 0;\n        display: block;\n\n        ul {\n            display: block;\n            width: 90%;\n\n            li {\n                display: block;\n                margin-left: 0;\n                margin-right: 0;\n\n                a:link,\n                a {\n                    /*background: @primary-light;*/\n                    float: none;\n                    display: block;\n                    margin: 0.5em 0px;\n                    padding: 1.2em 0 1.2em;\n                    height: auto;\n                    display: block;\n                    margin-bottom: 5px;\n                    /*color: #fff;*/\n                    padding-top: 10px;\n                    padding-bottom: 10px;\n                }\n\n                a:link:hover,\n                a:hover {\n                    background: #eee !important;\n                    text-decoration: underline;\n                    color: @primary;\n                }\n            }\n\n            li:hover a {\n                background: @primary-light;\n            }\n        }\n    }\n\n    #questionsDiv {\n        height: auto;\n        padding-bottom: 0;\n        position: relative;\n    }\n\n    .form-control {\n        max-width: none;\n    }\n\n    .visible-xs-inline-block {\n        display: inline-block !important;\n    }\n\n    .have_not_searched {\n        background-position: center center;\n        background-size: 150px;\n        padding-top: 30px;\n    }\n\n    /*.dfNavButton:not(.dfNavRemoveButton) {\n        display: block;\n        width: 100%;\n        margin-bottom: 5px;\n    }*/\n\n    .dropdown-toggle {\n        width: 100%;\n    }\n\n    .pane-size-toggle {\n        -webkit-transform: rotate(90deg);\n        transform: rotate(90deg);\n        margin-top: -8px !important;\n        margin-right: 0 !important;\n    }\n\n    .navbar-dark {\n        padding: 13px 5px;\n\n        a.search-toggle,\n        a.search-toggle:hover,\n        a.search-toggle:focus {\n            float: right;\n            color: #ffffff;\n            opacity: 0.8;\n            padding: 0 10px;\n\n            .icon {\n                display: block;\n                margin-top: 2px;\n            }\n        }\n\n        .navbar-brand {\n            width: min-content;\n            margin: 0 auto;\n\n            img {\n                height: 33px;\n            }\n\n            .brand-letters {\n                margin-left: 3px;\n\n                img {\n                    height: 15px;\n                }\n            }\n        }\n\n        .navbar-toggler,\n        .navbar-toggler:focus,\n        .navbar-toggler:hover {\n            background: @primary;\n            border: none;\n            box-shadow: none;\n            padding: 0.25rem 0.75rem 0.5rem 0.75rem;\n            /*.navbar-toggler-icon {\n                width: 20px;\n                height: 20px;\n            }*/\n        }\n    }\n\n    .search-backdrop {\n        padding: 5px 15px;\n        height: 150vh;\n\n        .close {\n            font-size: 1.4em;\n            top: 15px;\n            right: 15px;\n            img {\n                height: 15px;\n            }\n        }\n\n        .search-form-wrapper {\n            position: static;\n            margin-top: 40px;\n            width: 100%;\n            .form-control {\n                label {\n                }\n            }\n        }\n    }\n\n    .navbar-dark .navbar-nav > .vr {\n        display: none;\n    }\n\n    .navbar-dark .form-group.search-group .search-control {\n        width: 100% !important;\n    }\n\n    .navbar-dark .navbar-left {\n        margin-left: 0;\n        margin-right: -15px;\n    }\n\n    .navbar-dark .navbar-nav > li {\n        padding: 0 7px;\n    }\n\n    .navbar-dark {\n        .icon-search {\n            font-size: 1.4em;\n        }\n    }\n\n    #collapse2 {\n        padding: 8px;\n        overflow-x: hidden;\n    }\n\n    .nav-search-results {\n        position: relative;\n        width: calc(~\"100% - 30px\");\n        z-index: 10000;\n        max-height: calc(~\"100vh - 150px\");\n        /*background: #fff;\n        margin-top: 0;\n        padding: 0;\n        border: 1px solid #ddd;\n        box-shadow: 0 2px 6px 1px rgba(0,0,0,.25);\n        overflow: auto;*/\n        .nav-search-results-inner {\n            padding: 15px;\n            position: relative;\n            height: auto;\n            width: 100%;\n        }\n\n        .nav-search-results-caption {\n            position: absolute;\n            top: 5px;\n            right: 10px;\n            display: inline-block;\n            color: #717171;\n            font-size: 11px;\n        }\n\n        .result {\n            padding-top: 5px;\n            letter-spacing: normal;\n            font-size: 13px;\n        }\n\n        .result:first-of-type {\n            padding-top: 10px;\n        }\n    }\n}\n\n@media (min-width: 768px) {\n    body,\n    label,\n    .btn,\n    .form-control {\n        font-size: 15px;\n    }\n    .navbar-dark {\n        height: @navbar-height;\n        .navbar-brand {\n            pointer-events: none;\n        }\n    }\n    .public-page-body .body-content {\n        padding: 0;\n    }\n\n    .index-content {\n        padding: 15px;\n    }\n\n    .returning_user {\n        margin: 0;\n    }\n    .mi-footer-logo {\n        float: right;\n    }\n\n    .lead {\n        font-size: 16px;\n    }\n    .accessgov-footer-logo {\n        float: left;\n    }\n\n    .my-forms-backdrop {\n        display: none;\n    }\n\n    #collapse2 {\n        margin-right: 10px;\n    }\n\n    .navbar-inverse .navbar-nav > li .dropdown-menu {\n        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);\n    }\n}\n\n@media (max-width: 991px) {\n    .img-responsive {\n        /* account for large homepage images to be responsive on mobile devices */\n        max-width: 100%;\n        height: auto !important;\n    }\n}\n\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: 992px) {\n    .lead {\n        font-size: 17px;\n    }\n    .index-container {\n        flex-direction: row;\n        min-height: calc(~\"100vh\" - @navbar-height);\n\n        .index-content {\n            flex: 1;\n        }\n\n        .returning_user {\n            flex: 0 0 @my-forms-width;\n            border-top: none;\n            border-right: 1px solid #ccc;\n            overflow: auto;\n        }\n    }\n    .body-content {\n        min-height: calc(~\"100vh\" - @navbar-height);\n    }\n}\n\n@media (min-width: 1200px) {\n    .have_not_searched {\n        background-position: center 40%;\n    }\n}\n\n@media print {\n    .no_print,\n    #footer,\n    .btn {\n        display: none !important;\n    }\n}\n","@submissions-left-col-width: 325px;\n@navbar-height: 70px;\n@footer-height: 70px;\n@success: #28a745;\n@success-dark: darken(@success, 10%);\n@danger: #e04b59;\n@danger-dark: darken(@danger, 10%);\n\n.no-bg {\n    background: #fff;\n    padding-bottom: 0;\n    margin-bottom: 0;\n    padding-top: 70px;\n    padding-bottom: 60px;\n    height: 100vh;\n}\n\nimg.bg {\n    min-height: 100%;\n    min-width: 1024px;\n    width: 100%;\n    height: auto;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: -1;\n}\n\n/* Override the default bootstrap behavior where horizontal description lists\n   will truncate terms that are too long to fit in the left column\n*/\n.dl-horizontal dt {\n    white-space: normal;\n}\n\n/* ------------------------\n GENERAL STYLES\n------------------------ */\n\n.body-content-fluid {\n    padding: 15px;\n}\n\nh1 {\n    margin-bottom: 20px;\n}\n\nh3 {\n    margin-top: 15px;\n}\n\nb,\nstrong {\n    font-weight: 600;\n}\n\n.inline-block {\n    display: inline-block;\n}\n\n.indent {\n    padding-left: 45px;\n}\n\n.alert p:last-child {\n    margin-bottom: 0;\n}\n\n.width-auto {\n    width: auto;\n}\n\n.scroll-y {\n    overflow-y: auto;\n}\n\n.scroll-x {\n    overflow-x: auto;\n}\n\n.well {\n    background: #eee;\n    border-radius: 0;\n    border: 0;\n    margin-top: 10px;\n    box-shadow: none;\n\n    ul:last-of-type,\n    p:last-of-type {\n        margin-bottom: 0;\n    }\n}\n\n.breadcrumb {\n    background: #fff;\n    padding: 0;\n    padding-bottom: 3px;\n    border-bottom: 1px solid #ddd;\n    border-radius: 0;\n}\n\n.breadcrumb > li + li:before {\n    padding: 0 3px;\n    color: #666666;\n}\n\na.tile {\n    color: #444;\n}\n\n.btn-outline-danger {\n    color: @danger-dark;\n}\n\n.btn-outline-success {\n    color: @success-dark;\n}\n\n.tile:not(.form_intro) h2 {\n    /*margin-top: 0;*/\n    /*padding-bottom: 5px;*/\n    /*border-bottom: 1px solid #eee;*/\n}\n\n.well > h3 {\n    margin-top: 0;\n}\n\n.add-new-row .btn {\n    display: block;\n    width: 100%;\n    border-radius: 0;\n    box-sizing: border-box;\n    margin-top: 3px; /* for active outline */\n    &:not(:focus):not(:hover) {\n        background: #ffffff;\n        border-color: #dddddd;\n    }\n}\n\n#DataSourceTable .btn:hover,\n#DataSourceTable .btn:focus {\n    box-shadow: inset 0 0 0 1px @button-color-hover;\n    border-color: @button-color-hover;\n}\n\n.action-success-icon,\n.action-failure-icon {\n    float: left;\n    margin-right: 5px;\n}\n.action-success-text,\n.action-failure-text {\n    margin: 0;\n    font-weight: bold;\n}\n.action-success-text,\n.action-success-icon {\n    color: #008000;\n}\n.action-failure-text,\n.action-failure-icon {\n    color: #800000;\n}\n\n.optional:after {\n    content: \" (Optional)\";\n    color: #737373;\n}\n\n.plus-sign {\n    color: @success-dark;\n    font-size: 1.25em;\n    margin-top: -3px;\n    display: inline-block;\n    vertical-align: baseline;\n    line-height: normal;\n}\n*:disabled .plus-sign {\n    color: #666666;\n}\n\n.btn-outline-secondary:hover .icon-trash {\n    color: #fff;\n}\n\n.btn:hover {\n    &:disabled .plus-sign {\n        color: #666666;\n    }\n    .plus-sign {\n        color: #ffffff;\n    }\n}\n\n.btn:disabled,\nbutton:disabled {\n    .icon-trash {\n        color: inherit;\n    }\n}\n\n.icon-trash {\n    color: #d64343;\n}\n\n.pull-left {\n    float: left;\n}\n\n[disabled=\"disabled\"],\n.disabled img:hover {\n    cursor: not-allowed !important;\n}\n\n.disabled {\n    pointer-events: none;\n    cursor: default;\n}\n\nhr {\n    border-color: #dddddd;\n}\n\n.v--modal-overlay {\n    z-index: 1002;\n}\n\n.modal-content {\n    border: none;\n    max-height: 100vh;\n    overflow-y: auto;\n}\n\n.modal .loading {\n    height: 50px;\n}\n\n.modal-title {\n    margin: 0;\n}\n\n.modal-footer {\n    display: block;\n    text-align: center;\n}\n\n.address-field {\n    margin-bottom: 10px;\n}\n\n.card-header,\n.list-group-item {\n    background-color: transparent;\n    color: inherit;\n}\n\n.card-body {\n    background: #f5f5f5;\n    .table {\n        margin-bottom: 0;\n    }\n}\n\n.clickable-element,\na {\n    cursor: pointer;\n}\n\n/* --------------------------------------------------------------------\n    DATEPICKER\n-------------------------------------------------------------------- */\n.ui-widget {\n}\n\n.ui-state-default,\n.ui-widget-content .ui-state-default,\n.ui-widget-header .ui-state-default,\n.ui-button,\nhtml .ui-button.ui-state-disabled:hover,\nhtml .ui-button.ui-state-disabled:active {\n    background: #fff;\n    border-color: transparent;\n    text-align: center;\n    width: 30px;\n    color: #0071bc;\n    padding: 5px 0;\n    border-radius: 2px;\n}\n\n.ui-state-highlight,\n.ui-widget-content .ui-state-highlight,\n.ui-widget-header .ui-state-highlight {\n    background: #eee;\n}\n\n.ui-state-active,\n.ui-widget-content .ui-state-active,\n.ui-widget-header .ui-state-active,\na.ui-button:active,\n.ui-button:active,\n.ui-button.ui-state-active:hover {\n    border-color: @link-color;\n}\n\n.ui-datepicker .ui-datepicker-next,\n.ui-datepicker .ui-datepicker-prev {\n    cursor: pointer;\n}\n\n.ui-widget-header {\n    border: none;\n    border-radius: 0;\n    background: #f1f1f1;\n}\n\n.ui-datepicker table thead {\n    text-transform: uppercase;\n    font-size: 0.8em;\n    color: #666;\n    background: #f1f1f1;\n}\n\n.ui-datepicker-trigger {\n    height: 20px;\n    position: absolute;\n    right: 8px;\n    top: 8px;\n    cursor: pointer;\n}\n\n.ui-datepicker .ui-datepicker-title {\n    color: #555;\n}\n\n.ui-datepicker .ui-datepicker-prev span,\n.ui-datepicker .ui-datepicker-next span {\n    display: none !important;\n}\n\n.ui-datepicker .ui-datepicker-prev,\n.ui-datepicker .ui-datepicker-prev:hover {\n    background: url(\"../images/prev.png\") center center no-repeat;\n    background-size: 8px;\n    left: 2px;\n    top: 2px;\n}\n\n.ui-datepicker .ui-datepicker-next,\n.ui-datepicker .ui-datepicker-next:hover {\n    background: url(\"../images/next.png\") center center no-repeat;\n    background-size: 8px;\n    right: 2px;\n    top: 2px;\n}\n\n#ui-datepicker-div {\n    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.3);\n    border-radius: 5px;\n    border: none;\n    z-index: 10 !important; /*override inline z-index*/\n}\n\n#ui-datepicker-div .ui-priority-secondary,\n#ui-datepicker-div .ui-widget-content .ui-priority-secondary,\n#ui-datepicker-div .ui-widget-header .ui-priority-secondary {\n    opacity: 1;\n}\n\n.index-heading {\n    margin-top: 20px;\n    font-size: 24px;\n}\n\n/* ------------------------\n VALIDATION\n------------------------ */\n\n.validation-summary-errors {\n    &:extend(.alert);\n    &:extend(.alert-danger);\n    margin-bottom: 15px;\n\n    ul {\n        list-style: none;\n        margin: auto;\n        vertical-align: middle;\n        margin-bottom: 0;\n        padding-left: 0;\n\n        li {\n            color: #b94a48;\n        }\n    }\n}\n\n.required {\n    color: @error-red;\n}\n\n/*#region ADMIN*/\n\n/* ------------------------\n GUIDED QUESIONS\n------------------------ */\n\n// #gqLegend {\n//     position: absolute;\n//     bottom: 30px;\n//     left:30px;\n//     z-index: 500;\n//     padding: 15px;\n//     border: 1px solid #DDD;\n//     box-shadow: none;\n//     width: 150px;\n//     background: #fff;\n\n//     h2,\n//     a:hover,\n//     a:focus {\n//         border-bottom: none;\n//         margin: 0;\n//         padding: 0;\n//         color: #444;\n//         text-decoration: none;\n//     }\n\n//     h2 {\n//         font-size: 20px;\n//     }\n\n//     .legend-body {\n//         margin-top: 15px;\n//         border-top: 1px solid #eee;\n//     }\n\n//     strong {\n//         margin: 10px 0 5px 0;\n//         display: block;\n//     }\n// }\n\n// .legend-color {\n//     display: block;\n//     margin-bottom: 5px;\n//     margin-left: 10px;\n// }\n\n// .legend-color:before {\n//     width: 15px;\n//     height: 15px;\n//     background: #ddd;\n//     content: '';\n//     display: inline-block;\n//     margin-right: 5px;\n//     border: 1px solid #444;\n//     vertical-align: sub;\n// }\n\n// .legend-color-question:before {\n//     background: @question-color;\n// }\n\n// .legend-color-answer:before {\n//     background: @answer-color;\n// }\n\n// .legend-color-web:before {\n//     background: @web-color;\n// }\n\n// .legend-color-pdf:before {\n//     background: @pdf-red;\n// }\n\n// .legend-color-link:before {\n//     background: @linked-color;\n// }\n\n// .legend-color-contact:before {\n//     background: @contact-color;\n// }\n\n// .legend-color-content:before {\n//     background: @content-color;\n// }\n\n.gq_error_message {\n    color: #d01022;\n    margin-right: 15px;\n    /*border: 1px solid red;\n    padding: 3px 8px;*/\n}\n\n.gq_maincontent {\n    height: 200px;\n    font-size: 0.9em;\n    textarea,\n    .htmlContent {\n        height: 182px;\n    }\n    .htmlContent {\n        border: 1px dashed #dddddd;\n        overflow: hidden; /* Because we want encourage shorter content */\n    }\n}\n\n.gq_container {\n    overflow: auto;\n    width: 100%;\n    margin: 0;\n    position: relative;\n\n    > h2 {\n        padding: 0;\n        margin: 0 0 9px 0;\n    }\n\n    .gq_box_container {\n        position: relative;\n    }\n\n    .gq_box_container,\n    .gq_top_container,\n    .gq_bottom_container {\n        height: calc(~\"100vh - 400px\");\n    }\n\n    .gq_top_container,\n    .gq_bottom_container {\n        top: 0;\n    }\n\n    .gq_top_container {\n        background: #f5f5f5;\n        border: 1px solid #ddd;\n        width: 100%;\n        overflow: auto;\n        padding-right: 475px !important;\n        z-index: 0;\n\n        svg {\n            white-space: nowrap !important;\n        }\n    }\n\n    .gq_top_container.is_editing {\n        width: calc(~\"100% - 400px\");\n        padding-right: 0 !important;\n    }\n}\n\n.gq_editor_controls {\n    position: fixed;\n    background: #fff;\n    padding: 10px 15px 0 15px;\n    right: 16px;\n    width: 398px;\n    margin-top: -60px;\n    z-index: 1000;\n\n    .btn {\n        margin-bottom: 0;\n        /*float: left;*/\n    }\n\n    .close {\n        position: absolute;\n        right: 15px;\n        padding: 0;\n    }\n\n    .close:hover {\n        color: #444;\n    }\n\n    .change-text {\n        float: left;\n        padding: 7px 0;\n    }\n}\n\n.gq_bottom_container {\n    background: #fff;\n    z-index: 999;\n    display: block;\n    position: absolute;\n    padding-top: 60px;\n    width: 400px;\n    height: calc(~\"100vh - 120px\");\n    bottom: 0;\n    right: 0;\n    border: 1px solid #ddd;\n    overflow-y: auto;\n\n    .gq_bottom_container_top {\n        position: fixed;\n        width: 398px;\n        background: #fff;\n        padding: 10px 0 5px 0;\n        z-index: 1000;\n        box-shadow: 0 1px 8px 0 #fff;\n    }\n\n    .form-group {\n        margin-bottom: 10px;\n\n        label {\n            top: 0 !important;\n            left: 2px !important;\n        }\n    }\n\n    .selected {\n        border-left: 4px solid @focus;\n    }\n\n    .list-group-item:not(.selected) {\n        a {\n            color: inherit;\n        }\n    }\n\n    .list-group-item:not(.selected):hover {\n        border-left: 4px solid #dddddd;\n    }\n}\n\n.overflow-y-auto {\n    overflow-y: auto !important;\n    overflow-x: hidden;\n}\n\n.admin_gq_answer {\n}\n\n#endpointEditor {\n    .panel {\n        border-radius: 0;\n        /*border-left: 8px solid transparent;*/\n        .panel-heading {\n            strong {\n                color: @button-color;\n            }\n        }\n    }\n}\n\n.node-name {\n    margin-bottom: 0;\n}\n\n#zoomInAndOut {\n    z-index: 501 !important;\n    position: absolute;\n}\n\n.web_details_section {\n    h3 {\n        border-bottom: 1px solid #eee;\n        padding-bottom: 3px;\n    }\n}\n\n/*Template Nodes*/\n\n#gqTemplateNodes {\n    display: none !important;\n}\n\n.gq_node {\n    background: #fff;\n    font-size: 0.9em;\n    padding: 0;\n    white-space: nowrap !important;\n    overflow: hidden;\n    border: none;\n    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);\n    border-radius: 3px;\n    color: #444;\n\n    &.error {\n        box-shadow: 0 1px 6px 0 rgba(200, 0, 0, 0.75);\n        .node_body {\n            background: #ffecec;\n        }\n    }\n\n    a {\n        color: #444;\n    }\n\n    > div {\n        display: flex !important;\n    }\n\n    &.error {\n        border-color: red;\n    }\n}\n\n.selected_node {\n    border-color: dodgerblue;\n}\n\n.node_addon {\n    display: block;\n    height: 32px;\n    overflow: hidden;\n    width: 40px;\n    font-family: Verdana, Geneva, Tahoma, sans-serif;\n    text-align: center;\n    vertical-align: super;\n    padding: 7.5px;\n    padding: 5px 8px;\n    background-image: url(\"../images/endpoint.png\");\n    background-repeat: no-repeat;\n    background-position: center center;\n    color: #fff;\n\n    .plus-sign {\n        margin-top: 0;\n    }\n}\n\n.node_body {\n    text-align: center;\n    height: 32px;\n    padding: 5px 8px;\n    display: block;\n    overflow: hidden;\n    width: auto;\n\n    a {\n        color: @link-color;\n    }\n}\n\n.gq_node .node_body:hover {\n    cursor: pointer;\n    background: #f5f5f5;\n    text-decoration: none;\n}\n\n.node_body.long {\n    box-shadow: -10px 0 15px -10px inset;\n}\n\n.color-indicators {\n    display: inline-block;\n    vertical-align: middle;\n\n    span {\n        height: 12px;\n        width: 12px;\n        display: inline-block;\n        border-radius: 6px;\n        margin-left: 3px;\n    }\n\n    span:first-of-type {\n        margin-left: 5px;\n    }\n\n    [data-indicator=\"webForm\"] {\n        background: @web-color;\n    }\n\n    [data-indicator=\"pdfForm\"] {\n        background: @pdf-red;\n    }\n\n    [data-indicator=\"link\"] {\n        background: @linked-color;\n    }\n\n    [data-indicator=\"contact\"] {\n        background: @contact-color;\n    }\n\n    [data-indicator=\"content\"] {\n        background: @content-color;\n    }\n}\n\n.gq_question_node {\n    display: block;\n\n    .node_addon {\n        background: @question-color;\n        font-size: 1.4em;\n        padding: 0;\n    }\n}\n\n.gq_linked_question_node {\n    display: block;\n\n    .node_addon {\n        background: @question-color;\n        font-size: 1.4em;\n        padding: 0;\n    }\n}\n\n.gq_answer_node {\n    display: block;\n\n    .node_addon {\n        background: @answer-color;\n        font-size: 1.6em;\n        padding: 0;\n        color: #202020;\n    }\n}\n\n.gq_web_node {\n    display: block;\n\n    .node_addon {\n        background-color: @web-color !important;\n    }\n}\n\n.gq_pdf_node {\n    display: block;\n\n    .node_addon {\n        background-color: @pdf-red;\n    }\n}\n\n/*.gq_pdf_node.gq_web_node {\n    .node_addon {\n        background-image: url(\"../images/endpoint.png\"), linear-gradient(@pdf-red 50%, @button-color 50%);\n        background-repeat: no-repeat;\n        background-position: center center;\n    }\n}*/\n\n.gq_link_node {\n    display: block;\n\n    .node_addon {\n        background-color: @linked-color;\n    }\n}\n\n.gq_link_node.gq_pdf_node {\n    display: block;\n\n    .node_addon {\n        background-color: @secondary-blue-darker;\n    }\n}\n\n.gq_contact_node {\n    display: block;\n\n    .node_addon {\n        background-color: @contact-color;\n        font-size: 1.2em;\n\n        span {\n            vertical-align: top;\n        }\n    }\n}\n\n.gq_content_node {\n    display: block;\n\n    .node_addon {\n        background-color: @content-color;\n        font-size: 1.3em;\n\n        span {\n            vertical-align: top;\n        }\n    }\n}\n\n#GuidedSearchContainer {\n    padding-top: 10px;\n}\n\n/* ------------------------\n Admin Endpoint Creator\n------------------------ */\n#formUploadAccordion {\n    border: none;\n\n    .panel-default {\n        border: none;\n\n        .panel-heading {\n            background: #fff;\n\n            .edit {\n                margin-left: 5px;\n                cursor: pointer;\n            }\n        }\n    }\n\n    .panel-default:last-of-type {\n        .card-body {\n            border-bottom: 1px solid #ddd;\n        }\n    }\n\n    .form_upload_type > input {\n        visibility: hidden;\n        position: absolute;\n    }\n\n    .form_upload_type > input + img {\n        cursor: pointer;\n        border: 1px solid transparent;\n        padding: 7.5px;\n        border-radius: 4px;\n    }\n\n    .form_upload_type > input:checked + img {\n        border-color: dodgerblue;\n    }\n\n    .qualified_question {\n        border-top: 1px solid #eee;\n        margin-top: 10px;\n        padding-top: 10px;\n    }\n}\n\n.panel_header {\n    display: inline-block;\n    font-size: 1.7em;\n    border: none;\n    padding: 0 !important;\n    margin: 0;\n}\n\n.step_header {\n    display: inline-block;\n    text-align: center;\n    color: #fff !important;\n    background: #444;\n    width: 35px;\n    height: 35px;\n    vertical-align: baseline;\n    margin-right: 10px;\n    border-radius: 50%;\n    padding-top: 2px;\n}\n\n#wysiwyg_ifr {\n    min-height: 300px;\n}\n\n#formUploadAccordion .form_upload_type > input + img {\n    height: 100px;\n    padding: 5px;\n}\n\n/*#endregion*/\n\n.panel-default .panel-heading.is_hidden {\n    background: #eee;\n\n    strong {\n        color: #000000;\n    }\n\n    .is_hidden_text {\n        color: #000000;\n        font-weight: bold;\n        font-style: italic;\n        float: right;\n    }\n}\n\n[class*=\"cke_editor\"] {\n    margin-bottom: 15px !important;\n}\n\ntextarea.cke_source,\n.cke_editable {\n    font-weight: normal;\n}\n\n.admin_directory_additional_content_box,\n.admin_directory_qualifying_questions_box {\n    max-height: 300px;\n    overflow: auto;\n    border: 1px solid #ddd;\n    padding: 15px;\n    margin-bottom: 10px;\n}\n\n#submitFormEntry {\n    .btn:last-child {\n        margin-left: 5px;\n    }\n}\n\n.directory_accordion .card-body .btn:not(:last-child) {\n    margin-right: 5px;\n}\n\n/* ------------------------\n MENU\n------------------------ */\n\n.admin-card {\n    display: block;\n    position: relative;\n    top: 0;\n    padding: 15px;\n    box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.25);\n    border: none;\n    text-align: center;\n    transition: all ease 0.25s;\n\n    .admin-icon {\n        color: @button-color;\n        font-size: 95px;\n        vertical-align: middle;\n    }\n\n    .admin-icon:before {\n        display: block;\n        margin: 30px auto 5px auto;\n    }\n\n    .card-text {\n        color: @text-color;\n        margin-top: 10px;\n    }\n\n    .caption-heading {\n        display: inline-block;\n        /*font-weight: 600;*/\n        font-size: 1.2em;\n        margin-top: 10px;\n        color: @button-color;\n    }\n\n    &:focus,\n    &:hover {\n        top: -4px;\n        text-decoration: none;\n        box-shadow: 0 6px 25px 0 rgba(0, 0, 0, 0.25);\n\n        .admin-icon,\n        .caption-heading {\n            color: lighten(@button-color, 20%);\n        }\n    }\n}\n\n/* ------------------------\n SUBMISSIONS\n------------------------ */\n\n.editable-container {\n    .editable-click,\n    a.editable-click,\n    a.editable-click:hover {\n        color: inherit;\n        border-bottom: none;\n    }\n\n    .editable-buttons {\n        position: absolute;\n        margin-left: 0;\n        .editable-submit,\n        .editable-cancel {\n            padding: 0 3px;\n            margin-left: 3px;\n        }\n    }\n\n    .editable-input {\n        margin-top: -4px;\n        input,\n        select {\n            padding: 0;\n        }\n    }\n}\n\n.table-sm {\n    font-size: 0.875rem;\n\n    th,\n    td {\n        vertical-align: middle;\n    }\n}\n\n.table .editable-td,\n.table-sm .editable-td {\n    padding-bottom: 0;\n}\n\n.inline-edit-field {\n    color: inherit;\n    border-bottom: none !important;\n}\n\n.submissions-vr {\n    display: inline;\n    border-left: 1px solid #dee2e6;\n    margin-left: 15px;\n    margin-right: 15px;\n    vertical-align: middle;\n    height: 20px;\n}\n\n.submissions-bulk-input {\n    max-width: 170px;\n}\n\n.submissions-bulk-btn {\n    padding: 0;\n\n    .icon-trash {\n        margin-top: -8px;\n        display: block;\n    }\n}\n\n.delete-submissions:focus,\n.delete-submissions:hover {\n    text-decoration: none;\n}\n\n.submissions-left-col,\n.submissions-right-col {\n    padding: 0 15px;\n    width: 100%;\n}\n\n.submissions-left-col {\n    background: whitesmoke;\n    overflow: auto;\n\n    .help-block {\n        white-space: nowrap;\n    }\n\n    .comment-card {\n        border: none;\n        padding: 0;\n        margin: 0;\n    }\n\n    // .btn {\n    //     margin-bottom: 20px;\n    // }\n}\n\n.no-form-comments {\n    .submissions-left-col {\n        width: 0;\n    }\n\n    .submissions-right-col {\n        width: 100%;\n    }\n}\n\n.has-form-comments {\n    padding-top: 0;\n    padding-bottom: 0;\n\n    .submissions-left-col,\n    .submissions-right-col {\n        overflow: auto;\n    }\n\n    .submissions-right-col {\n        padding-left: 0;\n        padding-right: 0;\n        padding-bottom: 30px;\n    }\n}\n\n.submissions-bulk-options {\n    display: inline;\n    width: calc(~\"100% - 100px\");\n}\n\n.submissions-actions-td {\n    white-space: nowrap;\n    text-align: right;\n    width: 85px;\n\n    .icon {\n        font-size: 1.1em;\n        vertical-align: middle;\n        line-height: 0;\n        &:hover,\n        &:focus {\n            text-decoration: none;\n        }\n    }\n\n    .icon-comment {\n        margin: 0;\n    }\n}\n\n.submissions-comment-count {\n    font-size: 0.9em;\n    vertical-align: baseline;\n    line-height: 0;\n}\n\n.form-control-review {\n    width: auto;\n    display: inline;\n}\n\n.pdf-inline {\n    display: inline;\n    display: table;\n    float: left;\n    margin-bottom: 5px;\n}\n\n.display-label,\n.display-value {\n    display: table-cell;\n    padding: 0;\n    margin: 0;\n    padding-right: 5px;\n    text-align: left;\n    vertical-align: top;\n    float: left;\n}\n\n.display-label {\n    font-weight: bolder;\n    font-size: 1em;\n}\n\n.display-value {\n    word-break: break-word;\n}\n\n.calculated-list-item {\n    display: block;\n}\n\n/* fix formatting issue for display elements on review pages */\n.display-element-container {\n    .form-group {\n        max-width: 100%;\n    }\n}\n\n/*----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/\n/*#region PUBLIC*/\n/* ------------------------\n DYNAMIC FORMS\n------------------------ */\n.df-public-nav {\n    .list-group-item {\n        -webkit-transition: all ease 0.25s;\n        transition: all ease 0.25s;\n\n        .icon {\n            display: none;\n        }\n    }\n}\n\n.df-page-title {\n    display: none;\n    margin-top: 0;\n    margin-left: 0;\n    border-left: 0;\n    font-size: 18px;\n    padding-left: 0;\n}\n\n.dfForEachItem .dfNavRemoveButton {\n    background-color: transparent;\n    position: absolute;\n    right: 0;\n    top: -7px;\n    padding: 0 10px;\n    color: @danger-dark;\n    font-size: 1.5em;\n}\n\n.dfForEachItem.row {\n    margin-left: 0;\n    margin-right: 0;\n}\n\n.dfRegion {\n}\n\n.defDiv {\n    .defHeader {\n        background: @primary;\n        background-color: @primary;\n        border-bottom: 1px solid @primary-dark;\n    }\n\n    .settingHeader {\n        display: none;\n    }\n\n    *[data-df-type=\"AddChildButton\"] {\n        background: @primary;\n        background-color: @primary;\n        color: @green;\n    }\n\n    *[data-df-type=\"AddChildButton\"]:hover {\n        background: @primary-dark;\n        background-color: @primary-dark;\n    }\n\n    [data-df-type=\"NameOutput\"] {\n        color: #6edcff;\n    }\n\n    .childrenDiv,\n    .form {\n        border-color: @primary-dark;\n    }\n\n    /*.settingDiv {\n        background: @cream;\n    }*/\n}\n\n.DFPageContent {\n    margin-left: 0;\n    margin-right: 0;\n\n    /*.{\n        padding: 0;\n    }*/\n\n    .checkbox:only-of-type [type=\"checkbox\"][data-val-required]:before,\n    .checkbox-inline:only-of-type [type=\"checkbox\"][data-val-required]:before {\n        color: #d64343;\n        margin-top: -3px;\n        margin-left: -12px;\n        font-weight: bold;\n        vertical-align: text-top;\n        content: \" *\";\n        display: inline-block;\n    }\n\n    .col-sm-12.col-xs-offset-1 {\n        margin-left: 0;\n    }\n}\n\na.dfPageLink_Complete,\nbutton[type=\"submit\"].dfPageLink_Complete {\n    background-image: url(\"../images/success.png\");\n    background-size: 17px;\n    background-position: 7px center;\n}\n\na.dfPageLink_Invalid,\nbutton[type=\"submit\"].dfPageLink_Invalid {\n    background-image: url(\"../images/warning.png\");\n    background-size: 17px;\n    background-position: 7px center;\n}\n\na.dfPageLink_Disabled,\nbutton[type=\"submit\"].dfPageLink_Disabled {\n    background-color: #f0f0f0 !important;\n}\n\na.dfPageLink_InProgress,\nbutton[type=\"submit\"].dfPageLink_InProgress {\n    background-image: url(\"../images/in_progress.png\");\n    background-size: 10px;\n    background-position: 11px center;\n    background-color: #ddd !important;\n    color: #444 !important;\n    border-color: #bbb !important;\n}\n\na.dfPageLink_Saving,\nbutton[type=\"submit\"].dfPageLink_Saving {\n    background-image: url(\"../images/Spinner-1s-16px.gif\");\n    background-size: 17px;\n    background-position: 7px center;\n}\n\n.list-group-item {\n    word-break: break-word;\n    text-decoration: none !important;\n    -webkit-transition: all ease 0.15s;\n    transition: all ease 0.15s;\n\n    a {\n        text-decoration: none !important;\n    }\n}\n\n.list-group-item.active,\n.list-group-item.active:hover,\n.list-group-item.active:focus {\n    background-color: #ffffff;\n    color: buttontext !important;\n    border-left-width: 5px !important;\n    border-left-style: solid !important;\n    border-color: @focus;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.df-navigation-btn-container {\n    display: flex;\n    flex-wrap: wrap;\n\n    .btn {\n        margin-bottom: 15px;\n        width: 100%;\n    }\n}\n\n.form_submit_success_buttons {\n    .btn:not(:last-of-type) {\n        margin-right: 5px;\n    }\n}\n\n.bs-docs-grid {\n    padding: 15px;\n\n    .clearfix.alert-danger {\n        margin: auto !important;\n\n        .pull-left img {\n            display: none;\n        }\n    }\n}\n\n.select_element_page_children .btn {\n    height: auto;\n}\n\n.icon-with-text {\n    position: relative;\n    color: inherit;\n    // simulate title text, but allow on focus as well\n    .icon-text {\n        opacity: 0;\n        background: #fff;\n        position: absolute;\n        top: -4ex;\n        right: 0;\n        border: 1px solid #999;\n        padding: 0 4px;\n        pointer-events: none;\n        z-index: 100;\n        white-space: nowrap;\n        -webkit-transition: opacity linear 0.15s;\n        transition: opacity linear 0.15s;\n        transition-delay: 0.25s;\n    }\n\n    &:hover,\n    &:focus {\n        text-decoration: none;\n\n        .icon-text {\n            opacity: 1;\n            color: inherit;\n        }\n    }\n}\n/* ------------------------\n PUBLIC USER\n------------------------ */\n#welcomeDiv img {\n    max-width: 100%;\n    margin: 15px 0;\n}\n\n#welcomeDiv {\n    hr {\n        margin-left: -10px;\n        margin-right: -10px;\n        margin-top: 25px;\n        margin-bottom: 35px;\n    }\n}\n\n.search {\n    width: 100%;\n}\n\n.search .input-group {\n    margin: auto;\n    margin-bottom: 10px;\n    width: 300px;\n}\n\n.drop_target {\n    clear: both;\n}\n\n.page_title {\n    float: left;\n}\n\n.input-group-text {\n    font-size: inherit;\n}\n\na[data-toggle=\"popover\"],\n.list_items_toggle {\n    text-decoration: none !important;\n}\n\n.has-error,\n.panel-default .card-body .has-error {\n    .form-control {\n        border-color: #ca0706;\n    }\n\n    .help-block {\n        color: #a94442;\n    }\n}\n\n.select2-container--default.select2-container--focus .select2-selection--multiple,\n.select2-container--default.select2-container--focus .select2-selection--single,\n.select2 select2-container select2-container--default select2-container--below,\n.select2 select2-container select2-container--default,\n.select2-selection--single,\n.select2-selection--multiple,\n.select2-container--default {\n    height: 34px !important;\n    max-width: 100%;\n    border-radius: 0 !important;\n    border: none !important;\n    border-bottom: 2px solid #ddd !important;\n    border-color: #dddddd;\n    padding: 2px;\n    font-size: 14px;\n    background: none !important;\n    -webkit-box-shadow: none !important;\n    box-shadow: none !important;\n    -webkit-transition:\n        border-color ease-in-out 0.15s,\n        box-shadow ease-in-out 0.15s;\n    -o-transition:\n        border-color ease-in-out 0.15s,\n        box-shadow ease-in-out 0.15s;\n    transition:\n        border-color ease-in-out 0.15s,\n        box-shadow ease-in-out 0.15s;\n}\n\n.select2-container--default.select2-container--focus .select2-selection--multiple,\n.select2-container--default.select2-container--focus .select2-selection--single {\n    border-color: @focus !important;\n    outline: 0;\n    -webkit-box-shadow:\n        inset 0 1px 1px rgba(0, 0, 0, 0.075),\n        0 0 8px rgba(102, 175, 233, 0.6);\n    box-shadow:\n        inset 0 1px 1px rgba(0, 0, 0, 0.075),\n        0 0 8px rgba(102, 175, 233, 0.6);\n}\n\n.select2-container {\n    border-radius: 0;\n    background: none !important;\n    border: none !important;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n    height: 32px !important;\n}\n\n.select2-container .select2-selection--single .select2-selection__rendered {\n    padding-left: 12px !important;\n    padding-top: 3px !important;\n}\n\n.dashboard_btn {\n    &:extend(.tile);\n\n    display: block;\n    border-radius: 2px;\n    text-align: center;\n    padding: 15px;\n    font-size: 1.2em;\n    text-decoration: none !important;\n    height: auto;\n}\n\n#formDirectoryBtn,\n.dashboard_btn {\n    color: @button-color;\n    -webkit-transition: 0.1s all ease-in-out;\n    -moz-transition: 0.1s all ease-in-out;\n    -o-transition: 0.1s all ease-in-out;\n    transition: 0.1s all ease-in-out;\n}\n\n#formDirectoryBtn:hover {\n    color: @button-color-hover;\n    background: #f3f3f3;\n}\n\n#formDirectoryBtn a {\n    margin-top: 10px;\n    display: inline;\n    color: @button-color;\n}\n\n.dashboard_btn span {\n    color: #444;\n    margin-top: 10px;\n    display: inline;\n}\n\n.dashboard_btn img {\n    height: 25px;\n    margin-right: 3px;\n    margin-top: 0;\n    display: inline;\n}\n\n#formDirectoryTile:hover,\n#formDirectoryBtn:hover,\n.dashboard_btn:hover {\n    text-decoration: none;\n}\n\n#formDirectoryTile img {\n    height: 75px;\n    margin: auto;\n    margin-top: 20px;\n    margin-bottom: 15px;\n}\n\n#formDirectoryTile {\n    font-size: 1.2em;\n}\n\n#homeSearchForm {\n    margin-top: 15px;\n}\n\n.has_results {\n    background: #fff;\n}\n\n.need_character:before {\n    content: \"Please enter at least 1 character to search.\";\n    font-size: 1.2em;\n    vertical-align: middle;\n}\n\n#questionsDiv {\n    position: relative;\n}\n\n#questionsDiv {\n    .radio {\n        margin-bottom: 7px;\n    }\n}\n\n.transitions-after-load * {\n    -webkit-transition: none !important;\n    -moz-transition: none !important;\n    -ms-transition: none !important;\n    -o-transition: none !important;\n}\n\n/* ------------------------\n ENDPOINT LANDING\n------------------------ */\n\n/*.form_intro {\n    padding-top: 15px;\n\n    .btn:not(:last-of-type) {\n        margin-right: 5px;\n    }\n}*/\n\n.form_type {\n    float: right;\n\n    img {\n        height: 45px;\n    }\n\n    img:not(:last-of-type) {\n        margin-right: -3px;\n    }\n}\n\n.form_intro h1 {\n    display: inline-block;\n    width: 100%;\n    /*border-bottom: 1px solid #eee;*/\n    margin-top: 0;\n    line-height: 100%;\n\n    .form_name {\n        display: none;\n        white-space: inherit;\n        width: auto;\n        vertical-align: baseline;\n        margin-right: 10px;\n    }\n\n    .form_title {\n        /*display: block;\n        line-height: 110%;\n        font-size: .6em;\n\n        padding: 3px 0 5px 0;*/\n        font-size: 0.9em;\n        display: inline-block;\n    }\n\n    .form_year {\n        display: inline-block;\n        line-height: 110%;\n        font-size: 0.7em;\n\n        padding: 3px 0 5px 0;\n    }\n}\n\n/* ------------------------\n EDIT FORM\n------------------------ */\n\n#validationStatus img {\n    height: 20px;\n    display: inline-block;\n}\n\n#assessmentCode {\n    display: inline-block;\n}\n\n/* ------------------------\n ADDRESS BOOK\n------------------------ */\n\n#addressBookAccordion {\n    .panel-heading {\n        display: table;\n        width: 100%;\n\n        .panel_heading_group_name {\n            font-size: 14px;\n        }\n\n        .group_totals {\n            float: right;\n\n            .group_individuals_total {\n                display: block;\n                text-align: right;\n                float: right;\n                width: 50px;\n            }\n\n            .group_groups_total {\n                padding-left: 0;\n                display: block;\n                text-align: right;\n                width: 70px;\n            }\n\n            .total_number {\n                width: 20px;\n                display: inline-block;\n            }\n\n            img {\n                height: 19px;\n                display: inline-block;\n            }\n        }\n    }\n}\n\n/* ------------------------\n FORM DIRECTORY\n------------------------ */\n\n#directorySearchDiv {\n    display: block;\n    margin-bottom: 10px;\n}\n\n#directorySortDiv {\n    text-align: right;\n    margin-top: 15px;\n}\n\n.directory-deselect {\n    white-space: nowrap;\n}\n\n.panel-group {\n    margin-top: 15px;\n}\n\n.panel {\n    border-radius: 0;\n}\n\n/*.panel:last-of-type {\n    border-bottom: 1px solid #999999;\n}*/\n\n.panel-group .panel + .panel {\n    margin-top: 0;\n}\n\n.accordion > .card:first-of-type:last-of-type {\n    border-radius: 0.25rem;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.panel-default {\n    margin-bottom: 0;\n\n    a {\n        text-decoration: none !important;\n    }\n\n    .panel-heading {\n        border-top: 1px solid #999999;\n        border-bottom: none;\n        border-radius: 0;\n        background: #fff;\n        font-size: 1.1em;\n        color: #444;\n        width: 100%;\n        display: table;\n\n        strong {\n            /*color: @button-color;*/\n        }\n    }\n\n    .card-body {\n        hr {\n            border-color: #ddd;\n        }\n\n        h5 {\n            margin-top: 0;\n        }\n\n        .help-block {\n            color: #666666;\n        }\n    }\n}\n\n.panel-group .panel-heading + .panel-collapse > .card-body,\n.panel-group .panel-heading + .panel-collapse > .list-group {\n    border: none;\n}\n\n.pills li {\n    margin-right: 3px;\n\n    a {\n        font-size: 0.85em;\n        font-weight: 500;\n        letter-spacing: -0.25pt;\n        border-radius: 15px;\n        border: 1px solid #6c757d;\n        padding: 2px 6px;\n        text-decoration: none !important;\n        color: #6c757d;\n        display: block;\n        margin-bottom: 4px;\n        -webkit-transition: 0.1s ease-in-out;\n        -moz-transition: 0.1s ease-in-out;\n        -o-transition: 0.1s ease-in-out;\n        transition: 0.1s ease-in-out;\n\n        &.disabled {\n            border-color: #999;\n            background: #ddd;\n            color: #999;\n        }\n    }\n}\n\n#tags {\n    display: inline;\n}\n\n.pills li a:hover {\n    background: #eeeeee;\n    border-color: @link-color;\n    text-decoration: none;\n}\n\n.pills li.active a {\n    background: @link-color;\n    border-color: transparent;\n    text-decoration: none;\n    color: #fff !important;\n}\n\n.pills li.active {\n    .filter_linked {\n        background: @secondary-blue-darker;\n    }\n\n    .filter_web {\n        background: @button-color;\n    }\n\n    .filter_pdf {\n        background: @pdf-red;\n    }\n\n    .filter_contact {\n        background: @contact-color;\n    }\n\n    .filter_content {\n        background: @content-color;\n    }\n}\n\n.pills {\n    list-style-type: none;\n    padding: 0;\n    padding-top: 2px;\n    margin-bottom: 5px;\n\n    li {\n        display: inline-block;\n\n        .filter_linked {\n            border-color: @secondary-blue-darker;\n            color: @secondary-blue-darker;\n        }\n\n        .filter_linked:hover {\n            background: @secondary-blue-darker;\n        }\n\n        .filter_web {\n            border-color: @button-color;\n            color: @button-color;\n        }\n\n        .filter_web:hover {\n            background: @button-color;\n        }\n\n        .filter_pdf {\n            border-color: @pdf-red;\n            color: @pdf-red;\n        }\n\n        .filter_pdf:hover {\n            background: @pdf-red;\n        }\n\n        .filter_contact {\n            border-color: @contact-color;\n            color: @contact-color;\n        }\n\n        .filter_contact:hover {\n            background: @contact-color;\n        }\n\n        .filter_content {\n            border-color: @content-color;\n            color: @content-color;\n        }\n\n        .filter_content:hover {\n            background: @content-color;\n        }\n    }\n}\n\n.related_forms_list {\n    padding-left: 5px;\n\n    li {\n        list-style-position: inside;\n    }\n}\n\n.display_tags_keys {\n    padding: 0;\n\n    li {\n        display: inline;\n        list-style-type: none;\n    }\n\n    li:not(:last-of-type):after {\n        content: \", \";\n    }\n}\n\n.directory_create_buttons {\n    text-align: right;\n}\n\n.admin_directory_sort_buttons {\n    text-align: right;\n    float: right;\n}\n\n/*#endregion*/\n\n/* ------------------------\n WIDGETS\n------------------------ */\n\n.code-card {\n    margin-bottom: 30px;\n}\n.widget-link {\n    margin-left: 5px;\n}\n\n/* ------------------------\n MEDIA QUERIES\n------------------------ */\n\n@media (min-width: 576px) {\n    .df-navigation-btn-container {\n        // flex-wrap: nowrap;\n        // flex-direction: row-reverse;\n        // justify-content: space-between;\n\n        .btn {\n            width: auto;\n        }\n    }\n}\n\n@media (max-width: 767px) {\n    .no-bg {\n        margin-bottom: 240px;\n    }\n\n    #footfloat {\n        position: relative;\n        float: none;\n        bottom: 15px;\n        text-align: center;\n        margin: 0;\n        margin-top: 15px;\n    }\n\n    #footer #footfloat a {\n        padding: 0;\n    }\n\n    .search .input-group {\n        width: 100%;\n    }\n\n    .dashboard_btn {\n        text-align: left;\n    }\n\n    #directorySearchDiv {\n        width: 100%;\n        margin-top: 5px;\n    }\n\n    #directorySortDiv,\n    .directory_create_buttons {\n        text-align: center;\n    }\n\n    .gq_bottom_container {\n        bottom: 280px;\n    }\n\n    // #gqLegend {\n    //     bottom: 255px;\n    // }\n\n    .form_type {\n        img {\n            margin-right: 0;\n            margin-top: -10px;\n            height: 35px;\n        }\n    }\n\n    .form_intro {\n        .btn:not(:last-of-type) {\n            margin-right: 0;\n        }\n    }\n\n    #todaysDate {\n        margin-top: 0;\n    }\n\n    #groupEditorModal .inline_input {\n        width: 80%;\n    }\n\n    #feedback {\n        list-style-position: inside;\n    }\n\n    .search_tips_image {\n        width: 200px;\n        float: none;\n        margin: auto;\n        margin-bottom: 10px;\n        text-align: center;\n\n        img {\n            box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.4);\n        }\n    }\n\n    .admin_directory_nav_tabs {\n        display: inline-block;\n        width: 100%;\n    }\n\n    .admin_directory_sort_buttons {\n        text-align: center;\n        float: none;\n    }\n\n    #welcomeDiv {\n        hr {\n            margin: 10px -5px 20px -5px;\n        }\n\n        img {\n            width: 125px;\n        }\n    }\n\n    .DFPageContent.row {\n        margin-left: 15px;\n        margin-right: 15px;\n    }\n\n    .navigation_placeholder {\n        height: auto;\n        padding: 10px;\n    }\n\n    .index-row {\n        margin: 0;\n    }\n\n    .row.DFPageContent {\n        padding: 0;\n    }\n\n    .admin-icon {\n        font-size: 90px;\n    }\n\n    .inline_remove_btn {\n        padding-left: 15px;\n    }\n\n    .has-form-comments {\n        .submissions-left-col {\n            border-bottom: 1px solid #dddddd;\n            padding-bottom: 15px;\n            margin-bottom: 15px;\n        }\n    }\n\n    .no-form-comments {\n    }\n    .submissions-left-col {\n        min-height: 0 !important;\n        padding: 5px 15px;\n    }\n\n    .submissions-right-col {\n        min-height: 0 !important;\n        padding: 5px;\n    }\n}\n\n/* Small devices (tablets, 768px and up) */\n@media (min-width: 768px) {\n    #addressBookAccordion {\n        .panel-heading {\n            display: table;\n            width: 100%;\n\n            .panel_heading_group_name {\n                font-size: 18px;\n            }\n\n            .group_totals {\n                display: table;\n\n                .group_individuals_total {\n                    display: table-cell;\n                    text-align: left;\n                    width: 41px;\n                    float: none;\n                }\n\n                .group_groups_total {\n                    padding-left: 10px;\n                    display: table-cell;\n                    text-align: left;\n                    width: 55px;\n                }\n\n                .total_number {\n                    width: 20px;\n                    display: inline-block;\n                }\n\n                img {\n                    height: 20px;\n                    display: inline-block;\n                }\n            }\n        }\n    }\n\n    #welcomeDiv {\n        height: 567px;\n    }\n\n    .df-public-nav .navbar-collapse.collapse {\n        display: block !important;\n        height: auto !important;\n        padding-bottom: 0;\n        overflow: visible !important;\n    }\n\n    .df-public-nav .navbar-header {\n        display: none;\n    }\n\n    .admin-card {\n        min-height: 318px;\n    }\n\n    .submissions-left-col {\n        width: @submissions-left-col-width;\n        padding: 15px;\n        overflow: auto;\n        border-right: 1px solid #cccccc;\n    }\n\n    .submissions-right-col {\n        padding: 15px;\n    }\n\n    .submissions-left-col,\n    .submissions-right-col {\n        min-height: calc(~\"100vh\" - @navbar-height);\n        overflow-y: auto;\n    }\n\n    .submissions-table-wrapper {\n        width: 100%;\n        height: calc(~\"100vh - 80px\" - @navbar-height);\n        overflow-y: auto;\n    }\n\n    .directory-container {\n        min-height: calc(~\"100vh\" - @navbar-height);\n        padding: 15px;\n    }\n}\n\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: 992px) {\n    #formDirectoryTile,\n    #formDirectoryBtn {\n        font-size: 1.3em;\n    }\n\n    #welcomeDiv {\n        height: 565px;\n    }\n    .admin-card {\n        min-height: 280px;\n    }\n}\n/* Large devices (large desktops, 1200px and up) */\n@media (min-width: 1200px) {\n    #formDirectoryTile,\n    #formDirectoryBtn {\n        font-size: 1.5em;\n    }\n    #welcomeDiv {\n        height: 562px;\n    }\n}\n\n.DFPageContentWrapper {\n    table {\n        tr {\n            th {\n                border-bottom: 2px solid #ddd;\n            }\n        }\n    }\n}\n\n.navigation_placeholder,\n.button_placeholder {\n    font-size: 15px !important;\n}\n\n.select_element_page_children .btn > span {\n    display: inline-block;\n}\n\n.only_print {\n    display: none;\n}\n\n@media print {\n    .only_print {\n        display: block !important;\n    }\n\n    .voucher_section {\n        border: 2px dashed #ddd;\n        padding: 30px;\n    }\n}\n\n/*DF form wrapper container css*/\n\n@media (max-width: 767px) {\n    .df-public-nav {\n        .list-group-item {\n            padding: 7.5px 7.5px 7.5px 30px;\n            -webkit-transition: all ease 0.25s;\n            transition: all ease 0.25s;\n            &.active {\n                .icon {\n                    display: block;\n                    float: right;\n                    font-size: 0.9em;\n                    margin-top: 3px;\n                    margin-right: -5px;\n                }\n            }\n        }\n\n        .list-group-item:not(.active) {\n            height: auto;\n            /*padding: 7.5px 7.5px 7.5px 30px;*/\n        }\n\n        &.df-collapsed {\n            .list-group-item {\n                border-radius: 0;\n            }\n\n            .list-group-item:not(.active) {\n                height: 0;\n                padding: 0;\n                border-width: 0;\n                overflow: hidden;\n                visibility: hidden;\n            }\n        }\n    }\n}\n\n@media (min-width: 768px) {\n    .DFPageContent {\n        width: 750px;\n    }\n}\n\n@media (max-width: 991px) {\n    .img-responsive {\n        /* account for large homepage images to be responsive on mobile devices */\n        max-width: 100%;\n        height: auto !important;\n    }\n}\n\n@media (min-width: 992px) {\n    .DFPageContent {\n        width: 970px;\n    }\n}\n\n@media (min-width: 1200px) {\n    .DFPageContent {\n        width: 1170px;\n    }\n}\n\n.DFPageContent {\n    margin-right: auto;\n    margin-left: auto;\n    padding-left: 15px;\n    padding-right: 15px;\n}\n\n.admin-card {\n    margin-top: 20px;\n}\n\n/* TENANT */\n\n.tenant-fieldset {\n    border: 1px solid #ddd;\n    padding: 0 15px;\n\n    legend {\n        font-weight: 500;\n    }\n}\n\n.tree-layout {\n    padding-left: 0;\n\n    ul {\n        padding-left: 30px;\n    }\n\n    li {\n        list-style-type: none;\n        border-left: 1px dashed #666666;\n\n        &:before {\n            border-bottom: 1px dashed #666666;\n            display: inline-block;\n            height: 20px;\n            width: 10px;\n            margin-top: -2px;\n            margin-bottom: 2px;\n            content: \"\";\n        }\n\n        &:last-child:before {\n            border-left: 1px dashed #666666;\n        }\n\n        &:last-child > ul,\n        &:last-child {\n            border-left: none !important;\n        }\n    }\n\n    > li {\n        margin-bottom: 10px;\n        list-style-type: none;\n        border-left: none !important;\n\n        &:before {\n            display: none;\n        }\n    }\n\n    [data-toggle=\"popover\"] {\n        vertical-align: middle;\n    }\n\n    a {\n        font-size: 0.9em;\n    }\n}\n\n// Styles moved out of guided search for legacy compatibility\nbody.no-footer {\n    & {\n        padding-bottom: 0;\n    }\n    #public-footer-wrapper {\n        display: none;\n    }\n    .body-content {\n        padding: 0;\n    }\n}\n.pills li a:disabled {\n    border-color: #ccc;\n}\n/* I don't understand why these are required */\n.node_body,\n.node_addon {\n    display: inline-block;\n}\n.node_body {\n    padding-bottom: 0;\n    padding-top: 0;\n    line-height: 32px;\n    position: relative;\n    top: -5px;\n}\n.gq_node {\n    height: 32px;\n}\n.pages-admin-content {\n    width: calc(100% - 300px);\n    margin-left: 300px;\n    padding: 15px;\n}\n.pages-left-nav-sec {\n    height: calc(100vh - 70px);\n    width: 300px;\n    position: fixed;\n    background-color: #f5f6f7;\n    padding: 15px;\n    overflow-x: auto;\n    overflow-y: auto;\n    white-space: nowrap;\n\n    [class^=\"icon-\"],\n    [class*=\" icon-\"] {\n        &:before {\n            font-size: inherit;\n        }\n    }\n\n    .nav-link {\n        font-size: 0.9em;\n    }\n}\n.passthrough {\n    background: none;\n    color: inherit;\n    padding: 0;\n    border: none;\n    text-align: left;\n    line-height: 100%;\n    -webkit-appearance: none;\n\n    & + .passthrough {\n        margin-left: 4px;\n    }\n}\n.tenantList {\n    .area-label {\n        &.selected {\n            text-decoration: none;\n            font-weight: bold;\n            color: #234d7f;\n        }\n    }\n\n    .nav-item {\n        .passthrough {\n            max-width: 300px;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            vertical-align: middle;\n            &.icon-home,\n            &.icon-folder,\n            .icon-home,\n            .icon-folder,\n            .icon-sites {\n                &:before {\n                    margin-right: 5px;\n                    vertical-align: top;\n                }\n            }\n        }\n    }\n\n    .current-area,\n    .area-top-list,\n    .add-new-area,\n    .icon-sites,\n    .icon-folder {\n        // hide root current area list item; TODO: move show/hide logic to Vue\n        display: none;\n    }\n\n    .area-child-list {\n        display: block;\n        margin: 0;\n\n        .area-list {\n            margin: 0 0 15px 5px;\n            padding-left: 10px;\n            border-left: 2px solid #cccccc;\n            .add-new-area {\n                display: block; // display current area's add buttons (sites and content areas); TODO: move show/hide logic to Vue\n                color: #6c757d;\n                .plus-sign {\n                    color: @success-dark;\n                    font-weight: bold;\n                }\n            }\n\n            .area-child-list {\n                margin-left: 15px;\n            }\n\n            .area-list,\n            .icon-sites {\n                // hide all area-list that aren't second level; TODO: move show/hide logic to Vue\n                display: none;\n            }\n\n            .icon-home,\n            .icon-folder {\n                display: inline-block;\n            }\n        }\n\n        .area-label {\n            border: none; // avoid top level-border\n        }\n\n        // display child area items; TODO: move show/hide logic to Vue\n        .current-area,\n        .area-top-list {\n            display: block;\n        }\n\n        .icon-sites {\n            display: inline;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
